import { EventEmitter, Component, Input, Output, NgModule, Inject, ChangeDetectorRef, ViewChild, Injectable, ɵɵdefineInjectable, ErrorHandler, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule, MatTooltipModule as MatTooltipModule$1, MatSelectModule, MatMenuModule, MatIconModule, MatCardModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatChipsModule as MatChipsModule$1, MatExpansionModule, MatSidenavModule, MatFormFieldModule as MatFormFieldModule$1, MatInputModule as MatInputModule$1, MatDialogConfig, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatAutocompleteModule, MatAutocomplete } from '@angular/material';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonModule as MatButtonModule$1 } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { __awaiter, __generator, __values, __extends, __assign, __spread } from 'tslib';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule as MatCardModule$1 } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { NgxMaskModule } from 'ngx-mask';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MomentDateAdapter, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { Options, Ng5SliderModule } from 'ng5-slider';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDropzoneModule } from 'ngx-dropzone';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { startWith, map } from 'rxjs/operators';
import { MatAutocompleteModule as MatAutocompleteModule$1, MatAutocomplete as MatAutocomplete$1 } from '@angular/material/autocomplete';
import { MatIconModule as MatIconModule$1 } from '@angular/material/icon';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSelectModule as MatSelectModule$1 } from '@angular/material/select';
import { EChartOption } from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/page-title/page-title.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PageTitleComponent = /** @class */ (function () {
    function PageTitleComponent() {
        this.onChangeHandler = new EventEmitter();
        this.onBlurHandler = new EventEmitter();
        this.onFocusHandler = new EventEmitter();
        this.isInputField = false;
        this.isReactive = true;
    }
    /**
     * Sets flags based on received input.
     */
    /**
     * Sets flags based on received input.
     * @return {?}
     */
    PageTitleComponent.prototype.ngOnInit = /**
     * Sets flags based on received input.
     * @return {?}
     */
    function () {
        if (this.formFieldName && this.parentForm) {
            this.isInputField = true;
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    PageTitleComponent.prototype.changeEvent = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onChangeHandler.emit(event);
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    PageTitleComponent.prototype.blurEvent = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onBlurHandler.emit(event);
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    PageTitleComponent.prototype.focusEvent = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onFocusHandler.emit(event);
    };
    PageTitleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-page-title',
                    template: "<header class=\"inputHeading\">{{title}}</header>\n<div *ngIf=\"isInputField && isReactive\">\n  <div [formGroup]=\"parentForm\">\n    <div class=\"inputTitle\">\n      <input autofocus [placeholder]=\"placeholder\" maxlength=\"{{maxLength}}\" [formControlName]=\"formFieldName\" matInput required >\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"!isReactive && !isReadOnly\">\n    <div class=\"inputTitle\">\n      <input matInput autofocus [disabled]=\"isDisabled\" [readonly]=\"isReadOnly\" [required]=\"isRequired\" [attr.maxlength]=\"maxLength\"\n            [placeholder]=\"placeholder\" [value]=\"value\" (blur)=\"blurEvent($event)\" (focus)=\"focusEvent($event)\" (keyup)=\"changeEvent($event)\">\n    </div>\n</div>\n\n<div *ngIf=\"!isReactive && isReadOnly\">\n  <header class=\"inputHeading\">{{value}}</header>\n</div>"
                }] }
    ];
    /** @nocollapse */
    PageTitleComponent.ctorParameters = function () { return []; };
    PageTitleComponent.propDecorators = {
        title: [{ type: Input }],
        placeholder: [{ type: Input }],
        formFieldName: [{ type: Input }],
        parentForm: [{ type: Input }],
        maxLength: [{ type: Input }],
        isRequired: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        isReactive: [{ type: Input }],
        value: [{ type: Input }],
        onChangeHandler: [{ type: Output }],
        onBlurHandler: [{ type: Output }],
        onFocusHandler: [{ type: Output }]
    };
    return PageTitleComponent;
}());
if (false) {
    /** @type {?} */
    PageTitleComponent.prototype.title;
    /** @type {?} */
    PageTitleComponent.prototype.placeholder;
    /** @type {?} */
    PageTitleComponent.prototype.formFieldName;
    /** @type {?} */
    PageTitleComponent.prototype.parentForm;
    /** @type {?} */
    PageTitleComponent.prototype.maxLength;
    /** @type {?} */
    PageTitleComponent.prototype.isRequired;
    /** @type {?} */
    PageTitleComponent.prototype.isDisabled;
    /** @type {?} */
    PageTitleComponent.prototype.isReadOnly;
    /** @type {?} */
    PageTitleComponent.prototype.isReactive;
    /** @type {?} */
    PageTitleComponent.prototype.value;
    /** @type {?} */
    PageTitleComponent.prototype.onChangeHandler;
    /** @type {?} */
    PageTitleComponent.prototype.onBlurHandler;
    /** @type {?} */
    PageTitleComponent.prototype.onFocusHandler;
    /** @type {?} */
    PageTitleComponent.prototype.isInputField;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/page-title/page-title.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PageTitleModule = /** @class */ (function () {
    function PageTitleModule() {
    }
    PageTitleModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatInputModule, FormsModule, ReactiveFormsModule],
                    declarations: [PageTitleComponent],
                    exports: [PageTitleComponent],
                },] }
    ];
    return PageTitleModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/page-title/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var stringConstants = {
    DEFAULT_INFOMESSAGE_CLASSNAME: 'error-danger',
    DEFAULT_INFOMESSAGE_TEXT: 'Please enter info message.',
    DEFAULT_BARLOADER_MODE: 'indeterminate',
    DEFAULT_BARLOADER_VALUE: 40,
    DEFAULT_TEXT_CLASSNAME: 'text-default',
    DEFAULT_PAGETITLE_PATTERN: '.*S+.*',
    DEFAULT_HEADING_CLASSNAME: 'heading',
    DEFAULT_FOOTER_CLASSNAME: 'footerWrapper',
    DEFAULT_DIVIDER_CLASSNAME: 'mat-divider',
    DEFAULT_COLORBAR_CLASSNAME: 'color-bar color-bar-default',
    DEFAULT_CHIP_TEXT: 'Please enter text',
    DEFAULT_BADGE_CLASSNAME: 'badge badge-theme badge-above badge-after',
    DEFAULT_TEXTAREA_MAXLENGTH: 250,
    DEFAULT_INPUT_TYPE: 'text',
    DEFAULT_INPUT_APPEARENCE_LEGACY: 'legacy',
    DEFAULT_INPUT_APPEARENCE_OUTLINE: 'outline',
    DEFAULT_DATEPICKER_PLACEHOLDER: 'Choose a date',
    DEFAULT_DEFAULTBUTTON_CLASSNAME: 'btn btn-primary',
    DEFAULT_DATAGRID_CELL_RENDERER_FRAMEWORK: 'cellRendererFramework',
    DEFAULT_HEADER_CLASS: 'header',
    // cell renderer types start
    DEFAULT_DATAGRID_TAGS: 'tags',
    DEFAULT_DATAGRID_ACTIONS: 'actions',
    DEFAULT_DATAGRID_DATE: 'date',
    DEFAULT_DATAGRID_STATUS: 'status',
    DEFAULT_DATAGRID_NAME: 'name',
    DEFAULT_DATAGRID_FAVORITE: 'favorite',
    DEFAULT_DATAGRID_ACTIVE: 'active',
    DEFAULT_DATAGRID_ICON: 'icon',
    DEFAULT_DATAGRID_IMAGE: 'image',
    DEFAULT_DATAGRID_CLICKABLE_TAGS: 'clickable-tags',
    // cell renderer types end
    // cell renderer actions
    DEFAULT_DATAGRID_DELETE: 'delete',
    DEFAULT_DATAGRID_NAVIGATE_TO_VIEW: 'navigate_to_view',
    DEFAULT_DATAGRID_NAVIGATE_TO_EDIT: 'navigate_to_edit',
    DEFAULT_DATAGRID_COPY_COMPANIES: 'copy_companies',
    DEFAULT_DATAGRID_EXPORT_DOC: 'export_doc',
    DEFAULT_DATAGRID_EXPORT_PDF: 'export_pdf',
    DEFAULT_DATAGRID_EXPORT: 'export',
    DEFAULT_DATAGRID_PLAY: 'play',
    DEFAULT_DATAGRID_TICK: 'tick',
    DEFAULT_DATAGRID_PAUSE: 'pause',
    // cell renderer actions end
    DEFAULT_ANCHORTAG_CLASSNAME: 'd-flex align-items-center',
    // Button Group
    DEFAULT_BUTTON_GROUP_CLASSNAME: 'button-group',
    DEFAULT_BUTTON_GROUP_ICONCLASSNAME: 'save',
    DEFAULT_RADIO_BUTTON_CLASSNAME: 'radio-wrapper',
    DEFAULT_EMPTY_STATE_IMAGE_CLASSNAME: 'save',
    DEFAULT_MENU_BUTTON_CLASSNAME: 'menu-button',
    DEFAULT_PROGRESS_BUTTON_CLASSNAME: 'progress-button',
    DEFAULT_SEARCH_BAR_BUTTON_CLASSNAME: 'search-bar-button',
    // table constants
    DEFAULT_DATAGRID_CONTAINS: 'contains',
    DEFAULT_DATAGRID_NOT_CONTAINS: 'notContains',
    DEFAULT_DATAGRID_EQUALS: 'equals',
    DEFAULT_CK_EDITOR_TEXT: 'Enter your paragraph',
    DEFAULT_DATAGRID_ITB_RUNBOOK_STATUS: 'ITBRunBookStatus',
    DEFAULT_DATAGRID_PRIVATE: 'private',
    DEFAULT_DATAGRID_PUBLIC: 'public',
    DEAULT_DATAGRID_TRUE: 'true',
    DEFAULT_DATAGRID_FALSE: 'false',
    DEFAULT_DATAGRID_TEXT: 'text',
    DEFAULT_DATAGRID_SIDEBAR_ID: 'columns',
    DEFAULT_DATAGRID_SIDEBAR_LABEL: 'Columns',
    DEFAULT_DATAGRID_SIDEBAR_LABEL_KEY: 'columns',
    DEFAULT_DATAGRID_SIDEBAR_LABEL_ICON_KEY: 'columns',
    DEFAULT_DATAGRID_SIDEBAR_TOOL_PANEL: 'agColumnsToolPanel',
    DEFAULT_DATAGRID_TOOLTIP_COMPONENT: 'dataGridTooltip',
    DEFAULT_DATAGRID_COLUMN_STATE: 'columnState',
    DEFAULT_DATA_GRID_DEBOUNCE_TIME: 1000,
    // Dropup button class name
    DEFAULT_DROPUP_BUTTON_CLASSNAME: 'btn btn-',
    DEFAULT_DROPUP_LIST_CLASSNAME: 'btn-',
    DEFAULT_DROPUP_ICON_CLASSNAME: 'btn-innerico ',
    // Dropdown default class
    DEFAULT_ICON_CLASSNAME_PREFIX: 'btn-icon ',
    DEFAULT_DEFAULTBUTTON_CLASSNAME_PREFIX: 'btn btn-',
    DEFAULT_DEFAULTBUTTON_ICONCLASS_PREFIX: 'btn-innerico ',
    DEFAULT_ROUNDBUTTON_CLASSNAME_PREFIX: 'round-btn-',
    DEFAULT_ROUNDBUTTON_ICONCLASSNAME_PREFIX: 'ico-inner ',
    DEFAULT_TRUE: true,
    DEFAULT_FALSE: false,
    DEFAULT_ROUNDBUTTON_CLASSNAME: 'round-btn-light',
    DEFAULT_DROPDOWN_LIST_CLASSNAME: 'drop-down-list',
    // RSB Panel Default Classes
    DEFAULT_RSB_ITEM_LIST_CLASSNAME: 'rsb-item-list',
    DEFAULT_RSB_EXP_PANEL_FOOTER_CLASSNAME: 'footer-class',
    DEFAULT_RIGHT_SIDEBAR_CLASSNAME: 'right-sidebar',
    DEFAULT_INTEGRATIONBOXES_CLASSNAME: 'integration-boxes',
    DEFAULT_PAGINATION_CLASSNAME: 'pagination',
    DEFAULT_SURVEYCOUNT_CLASSNAME: 'survey-count',
    DEFAULT_TOOLTIP_TEXT_DELETEICON: 'Delete',
    DEFAULT_TOOLTIP_TEXT_SQUAREBUTTON: 'Add New',
    DEFAULT_CLASSNAME_INPUT_HEADING: 'inpage-heading',
    DEFAULT_EMAIL_TEMPLATE_TEXT: 'Please provide your satisfaction score below to help us improve the level of service',
    // Editor Default Classes
    DEFAULT_EDITOR_CLASSNAME: 'itb-editor',
    DEFAULT_DATEPICKER_FORMATE: 'MM/DD/YYYY',
    DEFAULT_SPINER_SIZE: 100,
    DEFAULT_FEEDBACK_COPYRIGHT_TEXT: 'Copyright 2017',
    DEFAULT_FEEDBACK_TITLE_TEXT: 'Thanks for providing your valuable feedback',
    DEFAULT_FEEDBACK_DETAIL_TEXT: 'Client satisfaction is very important to us and we greatly appreciate your feedback in this area.'
        + ' Please tell us what we need to work on.Your response will be used to improve the quality of our services',
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/icon/icon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconComponent = /** @class */ (function () {
    function IconComponent() {
        this.onClickHandler = new EventEmitter();
        this.onMouseDownHandler = new EventEmitter();
        this.onMouseUpHandler = new EventEmitter();
        this.isDisabled = false;
        this.isUnclickable = false;
        this.isBaseImage = false;
    }
    /**
     * @return {?}
     */
    IconComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.className) {
            if (this.className.includes('base64'))
                this.isBaseImage = true;
        }
        if (!this.isBaseImage) {
            this.className = stringConstants.DEFAULT_ICON_CLASSNAME_PREFIX + this.className;
            if (this.isUnclickable)
                this.className += ' no-pointer';
        }
    };
    /**
     * @return {?}
     */
    IconComponent.prototype.clickEvent = /**
     * @return {?}
     */
    function () {
        if (this.isUnclickable)
            return;
        this.onClickHandler.emit();
    };
    /**
     * @return {?}
     */
    IconComponent.prototype.mouseDownEvent = /**
     * @return {?}
     */
    function () {
        this.onMouseDownHandler.emit();
    };
    /**
     * @return {?}
     */
    IconComponent.prototype.mouseUpEvent = /**
     * @return {?}
     */
    function () {
        this.onMouseUpHandler.emit();
    };
    IconComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-icon',
                    template: "<div *ngIf=\"!isDisabled && !isLink && !isBaseImage\" matTooltip=\"{{tooltipText}}\" ngClass=\"{{className}}\"  (click)=\"clickEvent()\" (mousedown)=\"mouseDownEvent()\" (mouseup)=\"mouseUpEvent()\"></div>\n<a *ngIf=\"!isDisabled && isLink && !isBaseImage\" routerLink=\"{{link}}\"><div matTooltip=\"{{tooltipText}}\" ngClass=\"{{className}}\" (mousedown)=\"mouseDownEvent()\" (mouseup)=\"mouseUpEvent()\"></div></a>\n<div *ngIf=\"isDisabled && !isBaseImage\" ngClass=\"{{className}}\"></div>\n\n<div *ngIf=\"isBaseImage && !isDisabled\" matTooltip=\"{{tooltipText}}\" (click)=\"clickEvent()\" class=\"btn-icon\" (mousedown)=\"mouseDownEvent()\" (mouseup)=\"mouseUpEvent()\" [ngStyle]=\"{'background': 'url(' + className + ')', 'background-size': 'contain'}\"></div>\n\n<div *ngIf=\"isBaseImage && isDisabled\" matTooltip=\"{{tooltipText}}\" class=\"btn-icon\" [ngStyle]=\"{'background': 'url(' + className + ')', 'background-size': 'contain'}\"></div>"
                }] }
    ];
    /** @nocollapse */
    IconComponent.ctorParameters = function () { return []; };
    IconComponent.propDecorators = {
        tooltipText: [{ type: Input }],
        className: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        isUnclickable: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onMouseDownHandler: [{ type: Output }],
        onMouseUpHandler: [{ type: Output }]
    };
    return IconComponent;
}());
if (false) {
    /** @type {?} */
    IconComponent.prototype.tooltipText;
    /** @type {?} */
    IconComponent.prototype.className;
    /** @type {?} */
    IconComponent.prototype.isDisabled;
    /** @type {?} */
    IconComponent.prototype.isLink;
    /** @type {?} */
    IconComponent.prototype.link;
    /** @type {?} */
    IconComponent.prototype.isUnclickable;
    /** @type {?} */
    IconComponent.prototype.onClickHandler;
    /** @type {?} */
    IconComponent.prototype.onMouseDownHandler;
    /** @type {?} */
    IconComponent.prototype.onMouseUpHandler;
    /** @type {?} */
    IconComponent.prototype.isBaseImage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/icon/icon.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconModule = /** @class */ (function () {
    function IconModule() {
    }
    IconModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatProgressBarModule, MatTooltipModule, RouterModule],
                    declarations: [IconComponent],
                    exports: [IconComponent, MatTooltipModule, MatProgressBarModule],
                },] }
    ];
    return IconModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/icon/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/divider/divider.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DividerComponent = /** @class */ (function () {
    function DividerComponent() {
        this.className = stringConstants.DEFAULT_DIVIDER_CLASSNAME;
    }
    DividerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-divider',
                    template: "<div class=\"itb-divider\" [ngClass]=\"{'vertical':this.isVertical }\" >\n    <mat-divider [vertical]=\"isVertical\" [class]=\"className\"></mat-divider>\n</div>"
                }] }
    ];
    /** @nocollapse */
    DividerComponent.ctorParameters = function () { return []; };
    DividerComponent.propDecorators = {
        isVertical: [{ type: Input }],
        className: [{ type: Input }]
    };
    return DividerComponent;
}());
if (false) {
    /** @type {?} */
    DividerComponent.prototype.isVertical;
    /** @type {?} */
    DividerComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/divider/divider.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DividerModule = /** @class */ (function () {
    function DividerModule() {
    }
    DividerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatDividerModule],
                    declarations: [DividerComponent],
                    exports: [DividerComponent],
                },] }
    ];
    return DividerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/divider/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/widget/widget.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function RoundButton() { }
if (false) {
    /** @type {?} */
    RoundButton.prototype.className;
    /** @type {?} */
    RoundButton.prototype.iconClassName;
    /** @type {?} */
    RoundButton.prototype.tooltipText;
    /** @type {?} */
    RoundButton.prototype.roundButtonName;
    /** @type {?|undefined} */
    RoundButton.prototype.isLoading;
}
/**
 * @record
 */
function IconOption() { }
if (false) {
    /** @type {?} */
    IconOption.prototype.toolTipText;
    /** @type {?} */
    IconOption.prototype.className;
    /** @type {?} */
    IconOption.prototype.iconName;
}
/**
 * @record
 */
function FooterWidgetScore() { }
if (false) {
    /** @type {?} */
    FooterWidgetScore.prototype.scoreHeading;
    /** @type {?} */
    FooterWidgetScore.prototype.scoreCount;
    /** @type {?} */
    FooterWidgetScore.prototype.className;
}
var WidgetComponent = /** @class */ (function () {
    function WidgetComponent() {
        var _this = this;
        this.onClickHandler = new EventEmitter();
        this.onSelectHandler = new EventEmitter();
        this.footerClickHandler = new EventEmitter();
        this.onDropdownClickHandler = new EventEmitter();
        this.clickEvent = (/**
         * @param {?} roundButtonName
         * @return {?}
         */
        function (roundButtonName) {
            _this.onClickHandler.emit(roundButtonName);
        });
        this.hasFooter = false;
        this.colorBars = false;
        this.footerSpinner = false;
        this.isDropdownButton = false;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    WidgetComponent.prototype.footerClick = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        this.footerClickHandler.emit(items);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    WidgetComponent.prototype.selectEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onSelectHandler.emit(value);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    WidgetComponent.prototype.dropdownClickEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onDropdownClickHandler.emit(value);
    };
    WidgetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-widget',
                    template: "<div class=\"simple-widget\">\n  <div class=\"widget-header\">\n    <itb-heading [className]=\"'heading widget-h'\" [text]=\"title\"></itb-heading>\n    <div class=\"widget-icon\">\n      <p *ngIf=\"colorBars\">\n        <itb-color-bar [className]=\"'color-bar color-bar-5'\"></itb-color-bar\n        >OPEN\n      </p>\n      <p *ngIf=\"colorBars\">\n        <itb-color-bar [className]=\"'color-bar color-bar-6'\"></itb-color-bar\n        >CLOSE\n      </p>\n      <itb-select\n        style=\"width: 150px;\"\n        *ngIf=\"selectItems\"\n        [isReactive]=\"false\"\n        [itemsStringArray]=\"selectItems\"\n        [selected]=\"selectedItem\"\n        (onSimpleChangeHandler)=\"selectEvent($event)\"\n      ></itb-select>\n      <ng-container *ngIf=\"isDropdownButton\">\n        <itb-dropdown-list [dropDownButton]=\"dropDownButton\" [items]=\"dropDownButtonItems\" (onClickHandler)=\"dropdownClickEvent($event)\"></itb-dropdown-list>\n      </ng-container>\n        <div *ngFor=\"let roundButtons of roundButtons\">\n          <itb-round-button\n            [tooltipText]=\"roundButtons.tooltipText\"\n            [className]=\"roundButtons.className\"\n            [iconClassName]=\"roundButtons.iconClassName\"\n            [isLoading]=\"roundButtons.isLoading\"\n            [isDisabled]=\"roundButtons.isDisabled\"\n            (onClickHandler)=\"clickEvent(roundButtons.roundButtonName)\"\n          >\n          </itb-round-button>\n        </div>\n    </div>\n  </div>\n  <itb-bar-loader *ngIf=\"hasBarLoader\"></itb-bar-loader>\n  <div class=\"widget-icon-hover\">\n    <div *ngFor=\"let innerRoundButtons of innerRoundButtons\">\n      <itb-round-button\n        [tooltipText]=\"innerRoundButtons.tooltipText\"\n        [className]=\"innerRoundButtons.className\"\n        [iconClassName]=\"innerRoundButtons.iconClassName\"\n        [isLoading]=\"innerRoundButtons.isLoading\"\n        (onClickHandler)=\"clickEvent(innerRoundButtons.roundButtonName)\"\n      >\n      </itb-round-button>\n    </div>\n  </div>\n  <div\n    class=\"widget-body\"\n    [ngClass]=\"{ 'widget-content-center': hasContentCenter }\"\n  >\n    <ng-content></ng-content>\n  </div>\n\n  <div class=\"widget-footer-score\" *ngIf=\"footerWidgetScore\">\n    <div\n      class=\" {{ items.className }} \"\n      *ngFor=\"let items of footerWidgetScore\"\n      (click)=\"footerClick(items)\"\n    >\n      <div class=\"score-heading \">{{ items.scoreHeading }}</div>\n      <div class=\"widget-spinner\">\n        <itb-spinner *ngIf=\"footerSpinner\" [spinnerType]=\"'s'\"></itb-spinner>\n        <h3 *ngIf=\"!footerSpinner\">{{ items.scoreCount }}</h3>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"widget-footer\">\n    <itb-widget-footer\n      [text]=\"updateText\"\n      [iconClassName]=\"footerClass\"\n    ></itb-widget-footer>\n  </div>\n</div>\n",
                    styles: [".dashboard-widget{padding:10px 0}.dashboard-widget .card{border:0}.dashboard-widget gridster .mat-card{height:100%;background-color:var(--bgContainer);color:var(--color)}.dashboard-widget gridster .mat-card .mat-card-header{border-bottom:1px solid var(--border);font-size:20px;font-weight:400}.dashboard-widget gridster .mat-card .mat-card-header .mat-card-header-text{width:100%}.dashboard-widget gridster .mat-card .mat-card-header .mat-card-header-text .mat-card-title{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;float:left}.dashboard-widget gridster .mat-card .widget_buttons{position:absolute;right:0;top:50px;opacity:0;transition:.3s;-moz-transition:.3s;-webkit-transition:.3s;transform:translateY(10px) scale(.5)}.dashboard-widget gridster .mat-card .portlet-icon-refresh-lg-master{width:24px;height:24px;display:block;background-size:cover;transition:opacity .3s;-webkit-filter:var(--icoFilter);filter:var(--icoFilter)}.dashboard-widget gridster .mat-card .mat-card-content{font-weight:600;height:calc(100% - 40px);font-size:3rem;padding:0}.dashboard-widget gridster .mat-card .mat-card-content svg{width:100%;cursor:pointer}.dashboard-widget gridster .mat-card .card-footer{padding:0 10px;font-size:10px;border-top:0}.dashboard-widget gridster .mat-card .card-footer.widgets-footer{display:flex;justify-content:flex-end;border-top:1px solid var(--border);padding:.75rem 1.25rem;background:var(--titleBG);position:absolute;bottom:0;width:100%}.dashboard-widget gridster .mat-card:hover .widget_buttons{opacity:1;transform:translateY(-5px) scale(1)}.grid-stack-instance-9651 .grid-stack-item[data-gs-height=\"3\"]{height:260px}.grid-stack-instance-9651 .grid-stack-item[data-gs-y=\"4\"]{top:360px}.grid-stack>.grid-stack-item[data-gs-x=\"6\"]{left:50%}.grid-stack>.grid-stack-item[data-gs-width=\"2\"]{width:16.6666666667%}.grid-stack-instance-9651 .grid-stack-item{min-height:80px}.grid-stack>.grid-stack-item{min-width:8.3333333333%;position:absolute;padding:0}"]
                }] }
    ];
    /** @nocollapse */
    WidgetComponent.ctorParameters = function () { return []; };
    WidgetComponent.propDecorators = {
        hasFooter: [{ type: Input }],
        title: [{ type: Input }],
        footerText: [{ type: Input }],
        footerClass: [{ type: Input }],
        roundButtons: [{ type: Input }],
        innerRoundButtons: [{ type: Input }],
        footerWidgetScore: [{ type: Input }],
        hasBarLoader: [{ type: Input }],
        hasContentCenter: [{ type: Input }],
        selectItems: [{ type: Input }],
        selectedItem: [{ type: Input }],
        colorBars: [{ type: Input }],
        toggleButtonArray: [{ type: Input }],
        updateText: [{ type: Input }],
        footerSpinner: [{ type: Input }],
        isDropdownButton: [{ type: Input }],
        dropDownButton: [{ type: Input }],
        dropDownButtonItems: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onSelectHandler: [{ type: Output }],
        footerClickHandler: [{ type: Output }],
        onDropdownClickHandler: [{ type: Output }]
    };
    return WidgetComponent;
}());
if (false) {
    /** @type {?} */
    WidgetComponent.prototype.hasFooter;
    /** @type {?} */
    WidgetComponent.prototype.title;
    /** @type {?} */
    WidgetComponent.prototype.footerText;
    /** @type {?} */
    WidgetComponent.prototype.footerClass;
    /** @type {?} */
    WidgetComponent.prototype.roundButtons;
    /** @type {?} */
    WidgetComponent.prototype.innerRoundButtons;
    /** @type {?} */
    WidgetComponent.prototype.footerWidgetScore;
    /** @type {?} */
    WidgetComponent.prototype.hasBarLoader;
    /** @type {?} */
    WidgetComponent.prototype.hasContentCenter;
    /** @type {?} */
    WidgetComponent.prototype.selectItems;
    /** @type {?} */
    WidgetComponent.prototype.selectedItem;
    /** @type {?} */
    WidgetComponent.prototype.colorBars;
    /** @type {?} */
    WidgetComponent.prototype.toggleButtonArray;
    /** @type {?} */
    WidgetComponent.prototype.updateText;
    /** @type {?} */
    WidgetComponent.prototype.footerSpinner;
    /** @type {?} */
    WidgetComponent.prototype.isDropdownButton;
    /** @type {?} */
    WidgetComponent.prototype.dropDownButton;
    /** @type {?} */
    WidgetComponent.prototype.dropDownButtonItems;
    /** @type {?} */
    WidgetComponent.prototype.onClickHandler;
    /** @type {?} */
    WidgetComponent.prototype.onSelectHandler;
    /** @type {?} */
    WidgetComponent.prototype.footerClickHandler;
    /** @type {?} */
    WidgetComponent.prototype.onDropdownClickHandler;
    /** @type {?} */
    WidgetComponent.prototype.clickEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/default-button/default-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DefaultButtonComponent = /** @class */ (function () {
    function DefaultButtonComponent() {
        var _this = this;
        this.onClickHandler = new EventEmitter();
        this.clickEvent = (/**
         * @return {?}
         */
        function () {
            _this.onClickHandler.emit();
        });
    }
    /**
     * @return {?}
     */
    DefaultButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = stringConstants.DEFAULT_DEFAULTBUTTON_CLASSNAME_PREFIX + this.className
            || stringConstants.DEFAULT_DEFAULTBUTTON_CLASSNAME;
        this.iconClassName = stringConstants.DEFAULT_DEFAULTBUTTON_ICONCLASS_PREFIX + this.iconClassName;
    };
    DefaultButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-default-button',
                    template: "<ng-container *ngIf=\"!isLinkButton\">\n<button [matTooltip]=\"tooltipText\" class=\"{{iconClassName}}\" mat-flat-button [disabled]=\"isDisabled\" (click)=\"clickEvent()\" *ngIf=\"!isLoading && !isHidden\" ngClass=\"{{className}}\" [ngClass]=\"{'disabled':isDisabled }\" > {{text}} </button>\n</ng-container>\n\n<a *ngIf=\"isLinkButton\" routerLink=\"{{link}}\"><button [matTooltip]=\"tooltipText\" class=\"{{iconClassName}}\" mat-flat-button [disabled]=\"isDisabled\" (click)=\"clickEvent()\" *ngIf=\"!isLoading && !isHidden\" ngClass=\"{{className}}\" [ngClass]=\"{'disabled':isDisabled }\" > {{text}} </button></a>\n\n<button [matTooltip]=\"tooltipText\" class=\"btn-loader setting\" mat-flat-button *ngIf=\"isLoading\" ngClass=\"{{className}}\"></button>"
                }] }
    ];
    DefaultButtonComponent.propDecorators = {
        tooltipText: [{ type: Input }],
        iconClassName: [{ type: Input }],
        text: [{ type: Input }],
        className: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isLoading: [{ type: Input }],
        isLinkButton: [{ type: Input }],
        link: [{ type: Input }],
        isHidden: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return DefaultButtonComponent;
}());
if (false) {
    /** @type {?} */
    DefaultButtonComponent.prototype.tooltipText;
    /** @type {?} */
    DefaultButtonComponent.prototype.iconClassName;
    /** @type {?} */
    DefaultButtonComponent.prototype.text;
    /** @type {?} */
    DefaultButtonComponent.prototype.className;
    /** @type {?} */
    DefaultButtonComponent.prototype.isDisabled;
    /** @type {?} */
    DefaultButtonComponent.prototype.isLoading;
    /** @type {?} */
    DefaultButtonComponent.prototype.isLinkButton;
    /** @type {?} */
    DefaultButtonComponent.prototype.link;
    /** @type {?} */
    DefaultButtonComponent.prototype.isHidden;
    /** @type {?} */
    DefaultButtonComponent.prototype.onClickHandler;
    /** @type {?} */
    DefaultButtonComponent.prototype.clickEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/default-button/default-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DefaultButtonModule = /** @class */ (function () {
    function DefaultButtonModule() {
    }
    DefaultButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonModule, MatTooltipModule$1, OverlayModule, RouterModule],
                    declarations: [DefaultButtonComponent],
                    exports: [DefaultButtonComponent],
                },] }
    ];
    return DefaultButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/spinner/spinner.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerComponent = /** @class */ (function () {
    function SpinnerComponent() {
        this.spinnerSize = this.spinnerSize || stringConstants.DEFAULT_SPINER_SIZE;
        if (this.spinnerSize <= 25)
            this.spinnerType = 's';
        else if (this.spinnerSize <= 49)
            this.spinnerType = 'm';
        else
            this.spinnerType = 'l';
    }
    SpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-spinner',
                    template: "\n<div class=\"itb-spinner2 {{spinnerType}}\">\n  <div class=\"effect-1 effects\"></div>\n  <div class=\"effect-2 effects\"></div>\n  <div class=\"effect-3 effects\"></div>\n</div>\n\n<!-- Build 1.5.13 -->"
                }] }
    ];
    /** @nocollapse */
    SpinnerComponent.ctorParameters = function () { return []; };
    SpinnerComponent.propDecorators = {
        className: [{ type: Input }],
        spinnerSize: [{ type: Input }],
        spinnerType: [{ type: Input }]
    };
    return SpinnerComponent;
}());
if (false) {
    /** @type {?} */
    SpinnerComponent.prototype.className;
    /** @type {?} */
    SpinnerComponent.prototype.spinnerSize;
    /** @type {?} */
    SpinnerComponent.prototype.spinnerType;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/spinner/spinner.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerModule = /** @class */ (function () {
    function SpinnerModule() {
    }
    SpinnerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule,
                        MatProgressSpinnerModule],
                    declarations: [SpinnerComponent],
                    exports: [SpinnerComponent],
                },] }
    ];
    return SpinnerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/round-button/round-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RoundButtonComponent = /** @class */ (function () {
    function RoundButtonComponent() {
        this.onClickHandler = new EventEmitter();
        this.isLoading = false;
    }
    /**
     * @return {?}
     */
    RoundButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = "" + stringConstants.DEFAULT_ROUNDBUTTON_CLASSNAME_PREFIX + this.className ||
            stringConstants.DEFAULT_ROUNDBUTTON_CLASSNAME;
        this.iconClassName = stringConstants.DEFAULT_ROUNDBUTTON_ICONCLASSNAME_PREFIX + this.iconClassName;
    };
    /*
   * Handles your click event on icon
   */
    /*
     * Handles your click event on icon
     */
    /**
     * @param {?} event
     * @return {?}
     */
    RoundButtonComponent.prototype.onClickEvent = /*
     * Handles your click event on icon
     */
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onClickHandler.emit(event);
    };
    RoundButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-round-button',
                    template: "<button tabindex=\"-1\" *ngIf=\"!isLinkButton\" [matTooltip]=\"tooltipText\" [disabled]=\"isDisabled\"  [class]=\"className\"\n  (click)=\"onClickEvent($event)\">\n  <div *ngIf=\"!isLoading\" [class]=\"iconClassName\" [ngClass]=\"isDisabled? 'icon-disabled' : '' \"></div>\n  <itb-spinner *ngIf=\"isLoading\" [spinnerType]=\"(className === 'round-btn-dark') ? 'm white' : 'm'\" ></itb-spinner>\n</button>\n\n<a *ngIf=\"isLinkButton\" routerLink=\"{{link}}\"><button tabindex=\"-1\" [matTooltip]=\"tooltipText\" [disabled]=\"isDisabled\"  [class]=\"className\"\n  (click)=\"onClickEvent($event)\">\n  <div *ngIf=\"!isLoading\" [class]=\"iconClassName\" [ngClass]=\"isDisabled? 'icon-disabled' : '' \"></div>\n  <itb-spinner *ngIf=\"isLoading\" [spinnerType]=\"(className === 'round-btn-dark') ? 'm white' : 'm'\" ></itb-spinner>\n</button></a>"
                }] }
    ];
    /** @nocollapse */
    RoundButtonComponent.ctorParameters = function () { return []; };
    RoundButtonComponent.propDecorators = {
        iconClassName: [{ type: Input }],
        isDisabled: [{ type: Input }],
        className: [{ type: Input }],
        tooltipText: [{ type: Input }],
        isLinkButton: [{ type: Input }],
        link: [{ type: Input }],
        isLoading: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return RoundButtonComponent;
}());
if (false) {
    /** @type {?} */
    RoundButtonComponent.prototype.iconClassName;
    /** @type {?} */
    RoundButtonComponent.prototype.isDisabled;
    /** @type {?} */
    RoundButtonComponent.prototype.className;
    /** @type {?} */
    RoundButtonComponent.prototype.tooltipText;
    /** @type {?} */
    RoundButtonComponent.prototype.isLinkButton;
    /** @type {?} */
    RoundButtonComponent.prototype.link;
    /** @type {?} */
    RoundButtonComponent.prototype.isLoading;
    /** @type {?} */
    RoundButtonComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/round-button/round-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RoundButtonModule = /** @class */ (function () {
    function RoundButtonModule() {
    }
    RoundButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonModule$1, MatTooltipModule$1, RouterModule, SpinnerModule],
                    declarations: [RoundButtonComponent],
                    exports: [RoundButtonComponent],
                },] }
    ];
    return RoundButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/info-message/info-message.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InfoMessageComponent = /** @class */ (function () {
    function InfoMessageComponent() {
    }
    /**
     * @return {?}
     */
    InfoMessageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = this.className || stringConstants.DEFAULT_INFOMESSAGE_CLASSNAME;
        // this.text = this.text || stringConstants.DEFAULT_INFOMESSAGE_TEXT
    };
    InfoMessageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-info-message',
                    template: "<div class=\"info-wrapper {{className}}\">\n  {{text}}\n</div>"
                }] }
    ];
    InfoMessageComponent.propDecorators = {
        className: [{ type: Input }],
        text: [{ type: Input }]
    };
    return InfoMessageComponent;
}());
if (false) {
    /** @type {?} */
    InfoMessageComponent.prototype.className;
    /** @type {?} */
    InfoMessageComponent.prototype.text;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/info-message/info-message.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InfoMessageModule = /** @class */ (function () {
    function InfoMessageModule() {
    }
    InfoMessageModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatFormFieldModule],
                    declarations: [InfoMessageComponent],
                    exports: [InfoMessageComponent],
                },] }
    ];
    return InfoMessageModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/select/select.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectComponent = /** @class */ (function () {
    function SelectComponent() {
        this.onChangeHandler = new EventEmitter();
        this.onSimpleChangeHandler = new EventEmitter();
        this.groupChangeHandler = new EventEmitter();
        this.onOpenClickHandler = new EventEmitter();
        this.selectedValues = [];
        this.isMultiple = false;
        this.isDataInStrings = false;
        this.isReactive = true;
        this.isRequired = false;
        this.isSorted = false;
        this.hasNoDataMessage = false;
        this.hasEmptyValueOption = false;
    }
    /**
     * @return {?}
     */
    SelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.items && this.isSorted && this.isMultiple) {
            // tslint:disable-next-line: no-unbound-method
            this.items.sort(this.sortByAlphabet).sort(this.sortByChecked);
        }
        if (this.itemsStringArray && this.isSorted) {
            this.itemsStringArray.sort();
        }
        if (this.items && this.isSorted && !this.isMultiple) {
            // tslint:disable-next-line: no-unbound-method
            this.items.sort(this.sortByAlphabet);
        }
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        if (this.items) {
            this.selectedValues = this.items.filter((/**
             * @param {?} items
             * @return {?}
             */
            function (items) { return items.isSelected; }));
        }
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    SelectComponent.prototype.sortByAlphabet = /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (a, b) {
        /** @type {?} */
        var first;
        /** @type {?} */
        var second;
        if (a.label && b.label) {
            first = a.label.toLowerCase();
            second = b.label.toLowerCase();
        }
        else if (a.name && b.name) {
            first = a.name.toLowerCase();
            second = b.name.toLowerCase();
        }
        /** @type {?} */
        var comparison = 0;
        if (first < second) {
            comparison = -1;
        }
        else if (first > second) {
            comparison = 1;
        }
        return comparison;
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    SelectComponent.prototype.sortByChecked = /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (a, b) {
        /** @type {?} */
        var first = a.isSelected;
        /** @type {?} */
        var second = b.isSelected;
        /** @type {?} */
        var comparison = 0;
        if (first > second) {
            comparison = -1;
        }
        else if (first < second) {
            comparison = 1;
        }
        return comparison;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.changeEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.isUserInput === true) {
            if (this.isSorted && this.items) {
                /** @type {?} */
                var index = void 0;
                index = this.items.indexOf(event.source.value);
                this.items[index].isSelected = event.source._selected;
            }
            this.onChangeHandler.emit(event);
        }
    };
    /**
     * @param {?} o1
     * @return {?}
     */
    SelectComponent.prototype.compareFunction = /**
     * @param {?} o1
     * @return {?}
     */
    function (o1) {
        if (o1.isSelected === true)
            return true;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.onSimpleChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onSimpleChangeHandler.emit(event.value);
    };
    /**
     * @param {?} group
     * @param {?} option
     * @return {?}
     */
    SelectComponent.prototype.onGroupSelectChange = /**
     * @param {?} group
     * @param {?} option
     * @return {?}
     */
    function (group, option) {
        this.groupChangeHandler.emit({ group: group, option: option });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.onOpenEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        // tslint:disable-next-line: no-unbound-method
        if (this.isSorted && this.items && this.isMultiple)
            this.items.sort(this.sortByAlphabet).sort(this.sortByChecked);
        // tslint:disable-next-line: no-unbound-method
        if (this.isSorted && this.items && !this.isMultiple)
            this.items.sort(this.sortByAlphabet);
        this.onOpenClickHandler.emit(event);
    };
    SelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-select',
                    template: "<div *ngIf=\"isReactive && isMultiple && !isGroupSelect\" class=\"itb-select-wrapper\" [formGroup]=\"parentForm\">\n  <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\">\n    <mat-label>{{ label }}<span class=\"label-required\">*</span></mat-label>\n    <mat-select\n      [multiple]=\"isMultiple\"\n      [class]=\"className\"\n      [(ngModel)]=\"selectedValues\"\n      [formControlName]=\"formFieldName\"\n      [required]=\"isRequired\"\n      (openedChange)=\"onOpenEvent($event)\"\n      panelClass=\"itb-select multiple {{extraPanelClasses}}\"\n      disableOptionCentering\n    >\n      <ng-container *ngIf=\"!isDataInStrings\">\n          <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n          <mat-option\n            *ngFor=\"let item of items\"\n            [value]=\"item\"\n            [disabled]=\"item.isDisabled\"\n            (onSelectionChange)=\"changeEvent($event)\"\n          >\n          <itb-icon *ngIf=\"item.hasIcon\" [className]=\"item.iconClassName\" ></itb-icon>{{ item.label }}{{ item.name }}\n          </mat-option>\n      </ng-container>\n      <ng-container *ngIf=\"isDataInStrings\">\n        <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n        <mat-option\n          *ngFor=\"let item of itemsStringArray\"\n          [value]=\"item\"\n          [disabled]=\"item.isDisabled\"\n          (onSelectionChange)=\"changeEvent($event)\"\n        >\n          {{ item }}\n        </mat-option>\n      </ng-container>\n    </mat-select>\n  </mat-form-field>\n  <itb-info-message *ngIf=\"hasNoDataMessage\" [text]=\"'No data exists'\" [className]=\"'info-danger'\"></itb-info-message>\n</div>\n\n<div *ngIf =\"isReactive && !isMultiple && !isGroupSelect\" class=\"itb-select-wrapper\" [formGroup]=\"parentForm\">\n    <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\">\n      <mat-label>{{ label }}<span class=\"label-required\">*</span></mat-label>\n      <mat-select [compareWith]=\"compareFunction\"\n        [formControlName]=\"formFieldName\" [required]=\"isRequired\" panelClass=\"itb-select select-icon {{extraPanelClasses}}\" (openedChange)=\"onOpenEvent($event)\" disableOptionCentering>\n        <ng-container *ngIf=\"!isDataInStrings\">\n            <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n            <mat-option *ngFor=\"let item of items\" [value]=\"item\" [disabled]=\"item.isDisabled\"\n              (onSelectionChange)=\"changeEvent($event)\">\n              <itb-icon *ngIf=\"item.hasIcon\" [className]=\"item.iconClassName\" ></itb-icon>{{ item.label }} {{ item.name }}\n            </mat-option>\n        </ng-container>\n        <ng-container *ngIf=\"isDataInStrings\">\n          <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n          <mat-option *ngFor=\"let item of itemsStringArray\" [value]=\"item\" [disabled]=\"item.isDisabled\"\n            (onSelectionChange)=\"changeEvent($event)\">\n            {{ item }}\n          </mat-option>\n        </ng-container>\n      </mat-select>\n    </mat-form-field>\n    <itb-info-message *ngIf=\"hasNoDataMessage\" [text]=\"'No data exists'\" [className]=\"'info-danger'\"></itb-info-message>\n  </div>\n  \n<div *ngIf=\"!isReactive && !isMultiple && !isGroupSelect && !isSelectWithObjects\" class=\"itb-select-wrapper\">\n  <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\">\n    <mat-label>{{ label }}<span class=\"label-required\">*</span></mat-label>\n    <mat-select\n      [(ngModel)]=\"selected\"\n      [disabled]=\"isDisabled\"\n      (selectionChange)=\"onSimpleChange($event)\"\n      [required]=\"isRequired\"\n      (openedChange)=\"onOpenEvent($event)\"\n      panelClass=\"itb-select {{extraPanelClasses}}\"\n      disableOptionCentering\n    >\n      <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n      <mat-option *ngFor=\"let item of itemsStringArray\" [value]=\"item\">{{\n        item\n      }}</mat-option>\n    </mat-select>\n  </mat-form-field>\n  <itb-info-message *ngIf=\"hasNoDataMessage\" [text]=\"'No data exists'\" [className]=\"'info-danger'\"></itb-info-message>\n</div>\n\n<div *ngIf=\"!isReactive && isMultiple && !isGroupSelect && !isSelectWithObjects\" class=\"itb-select-wrapper\">\n    <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\">\n      <mat-label>{{ label }}<span class=\"label-required\">*</span></mat-label>\n      <mat-select\n        [(ngModel)]=\"selected\"\n        [disabled]=\"isDisabled\"\n        [required]=\"isRequired\"\n        multiple\n        (selectionChange)=\"onSimpleChange($event)\"\n        (openedChange)=\"onOpenEvent($event)\"\n        panelClass=\"itb-select multiple {{extraPanelClasses}}\"\n        disableOptionCentering\n      >\n        <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n        <mat-option *ngFor=\"let item of itemsStringArray\" [value]=\"item.id\">{{\n          item.name\n        }}</mat-option>\n      </mat-select>\n    </mat-form-field>\n    <itb-info-message *ngIf=\"hasNoDataMessage\" [text]=\"'No data exists'\" [className]=\"'info-danger'\"></itb-info-message>\n  </div>\n\n<div *ngIf=\"isGroupSelect\">\n  <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\">\n    <mat-label> {{label}} <span class=\"label-required\">*</span></mat-label>\n      <mat-select [(ngModel)]=\"selectedValues\" [required]=\"isRequired\" (openedChange)=\"onOpenEvent($event)\" panelClass=\"itb-select {{extraPanelClasses}}\" disableOptionCentering>\n        <mat-optgroup *ngFor=\"let option of groupOptions\" label=\"{{option.label}}\">\n          <mat-option *ngFor=\"let item of option.options\" [value]=\"item.value\" (click)=\"onGroupSelectChange(option.label, item)\">{{item.value}}</mat-option>\n        </mat-optgroup>\n      </mat-select>\n  </mat-form-field>\n  <itb-info-message *ngIf=\"hasNoDataMessage\" [text]=\"'No data exists'\" [className]=\"'info-danger'\"></itb-info-message>\n</div>\n\n<div *ngIf =\"!isReactive && isSelectWithObjects\" class=\"itb-select-wrapper\">\n  <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\">\n    <mat-label>{{ label }}<span class=\"label-required\">*</span></mat-label>\n    <mat-select [(ngModel)]=\"selectedValues\" [compareWith]=\"compareFunction\" [multiple]=\"isMultiple\" [disabled]=\"isDisabled\" [required]=\"isRequired\" (openedChange)=\"onOpenEvent($event)\"\n     panelClass=\"itb-select select-icon {{extraPanelClasses}}\" disableOptionCentering>\n        <mat-option *ngIf=\"hasEmptyValueOption\">{{emptyValueOption}}</mat-option>\n        <mat-option *ngFor=\"let item of items\" [value]=\"item\" [disabled]=\"item.isDisabled\"\n          (onSelectionChange)=\"changeEvent($event)\">\n          <itb-icon *ngIf=\"item.hasIcon\" [className]=\"item.iconClassName\" ></itb-icon>{{ item.label }} {{ item.name }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n    <itb-info-message *ngIf=\"hasNoDataMessage\" [text]=\"'No data exists'\" [className]=\"'info-danger'\"></itb-info-message>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SelectComponent.ctorParameters = function () { return []; };
    SelectComponent.propDecorators = {
        isDisabled: [{ type: Input }],
        parentForm: [{ type: Input }],
        className: [{ type: Input }],
        label: [{ type: Input }],
        formFieldName: [{ type: Input }],
        items: [{ type: Input }],
        isMultiple: [{ type: Input }],
        itemsStringArray: [{ type: Input }],
        isDataInStrings: [{ type: Input }],
        selected: [{ type: Input }],
        isReactive: [{ type: Input }],
        isGroupSelect: [{ type: Input }],
        groupOptions: [{ type: Input }],
        isSelectWithObjects: [{ type: Input }],
        isRequired: [{ type: Input }],
        isSorted: [{ type: Input }],
        extraPanelClasses: [{ type: Input }],
        hasNoDataMessage: [{ type: Input }],
        hasEmptyValueOption: [{ type: Input }],
        emptyValueOption: [{ type: Input }],
        onChangeHandler: [{ type: Output }],
        onSimpleChangeHandler: [{ type: Output }],
        groupChangeHandler: [{ type: Output }],
        onOpenClickHandler: [{ type: Output }],
        selectedValues: [{ type: Input }]
    };
    return SelectComponent;
}());
if (false) {
    /** @type {?} */
    SelectComponent.prototype.isDisabled;
    /** @type {?} */
    SelectComponent.prototype.parentForm;
    /** @type {?} */
    SelectComponent.prototype.className;
    /** @type {?} */
    SelectComponent.prototype.label;
    /** @type {?} */
    SelectComponent.prototype.formFieldName;
    /** @type {?} */
    SelectComponent.prototype.items;
    /** @type {?} */
    SelectComponent.prototype.isMultiple;
    /** @type {?} */
    SelectComponent.prototype.itemsStringArray;
    /** @type {?} */
    SelectComponent.prototype.isDataInStrings;
    /** @type {?} */
    SelectComponent.prototype.selected;
    /** @type {?} */
    SelectComponent.prototype.isReactive;
    /** @type {?} */
    SelectComponent.prototype.isGroupSelect;
    /** @type {?} */
    SelectComponent.prototype.groupOptions;
    /** @type {?} */
    SelectComponent.prototype.isSelectWithObjects;
    /** @type {?} */
    SelectComponent.prototype.isRequired;
    /** @type {?} */
    SelectComponent.prototype.isSorted;
    /** @type {?} */
    SelectComponent.prototype.extraPanelClasses;
    /** @type {?} */
    SelectComponent.prototype.hasNoDataMessage;
    /** @type {?} */
    SelectComponent.prototype.hasEmptyValueOption;
    /** @type {?} */
    SelectComponent.prototype.emptyValueOption;
    /** @type {?} */
    SelectComponent.prototype.onChangeHandler;
    /** @type {?} */
    SelectComponent.prototype.onSimpleChangeHandler;
    /** @type {?} */
    SelectComponent.prototype.groupChangeHandler;
    /** @type {?} */
    SelectComponent.prototype.onOpenClickHandler;
    /** @type {?} */
    SelectComponent.prototype.selectedValues;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/select/select.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectModule = /** @class */ (function () {
    function SelectModule() {
    }
    SelectModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatSelectModule, FormsModule, ReactiveFormsModule, InfoMessageModule, IconModule],
                    declarations: [SelectComponent],
                    exports: [SelectComponent],
                },] }
    ];
    return SelectModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/bar-loader/bar-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BarLoaderComponent = /** @class */ (function () {
    function BarLoaderComponent() {
        this.value = this.value || stringConstants.DEFAULT_BARLOADER_VALUE;
        this.mode = this.mode || stringConstants.DEFAULT_BARLOADER_MODE;
    }
    BarLoaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-bar-loader',
                    template: "<mat-progress-bar mode=\"{{mode}}\" value=\"{{value}}\" ngClass=\"{{className}}\" ></mat-progress-bar>\n"
                }] }
    ];
    /** @nocollapse */
    BarLoaderComponent.ctorParameters = function () { return []; };
    BarLoaderComponent.propDecorators = {
        value: [{ type: Input }],
        mode: [{ type: Input }],
        className: [{ type: Input }]
    };
    return BarLoaderComponent;
}());
if (false) {
    /** @type {?} */
    BarLoaderComponent.prototype.value;
    /** @type {?} */
    BarLoaderComponent.prototype.mode;
    /** @type {?} */
    BarLoaderComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/bar-loader/bar-loader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BarLoaderModule = /** @class */ (function () {
    function BarLoaderModule() {
    }
    BarLoaderModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatProgressBarModule],
                    declarations: [BarLoaderComponent],
                    exports: [BarLoaderComponent],
                },] }
    ];
    return BarLoaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/color-bar/color-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ColorBarComponent = /** @class */ (function () {
    function ColorBarComponent() {
        this.className = stringConstants.DEFAULT_COLORBAR_CLASSNAME;
    }
    ColorBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-color-bar',
                    template: "<div *ngIf=\"!isLink\" class=\"{{className}}\">{{text}}</div>\n\n<a *ngIf=\"isLink\" routerLink=\"{{link}}\"><div class=\"{{className}}\"></div>{{text}}</a>"
                }] }
    ];
    /** @nocollapse */
    ColorBarComponent.ctorParameters = function () { return []; };
    ColorBarComponent.propDecorators = {
        className: [{ type: Input }],
        text: [{ type: Input }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        isRandom: [{ type: Input }]
    };
    return ColorBarComponent;
}());
if (false) {
    /** @type {?} */
    ColorBarComponent.prototype.className;
    /** @type {?} */
    ColorBarComponent.prototype.text;
    /** @type {?} */
    ColorBarComponent.prototype.isLink;
    /** @type {?} */
    ColorBarComponent.prototype.link;
    /** @type {?} */
    ColorBarComponent.prototype.isRandom;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/color-bar/color-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ColorBarModule = /** @class */ (function () {
    function ColorBarModule() {
    }
    ColorBarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, RouterModule],
                    declarations: [ColorBarComponent],
                    exports: [ColorBarComponent],
                },] }
    ];
    return ColorBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dropdown-list/dropdown-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropdownListComponent = /** @class */ (function () {
    function DropdownListComponent() {
        this.onClickHandler = new EventEmitter();
        this.className = stringConstants.DEFAULT_DROPDOWN_LIST_CLASSNAME;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DropdownListComponent.prototype.onItemClickHandler = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onClickHandler.emit(value);
    };
    DropdownListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-dropdown-list',
                    template: "<div class=\"{{className}}\" *ngIf=\"dropDownButton.iconClassName\">\n    <itb-icon [matMenuTriggerFor]=\"dropdownList\" [tooltipText]=\"dropDownButton.tooltipText\" [className]=\"dropDownButton.iconClassName\"></itb-icon>\n    <mat-menu #dropdownList=\"matMenu\">\n        <button mat-menu-item *ngFor=\"let item of items\" (click)=\"onItemClickHandler(item)\">\n            <a *ngIf=\"item.link\" routerLink=\"{{item.link}}\">\n            <itb-icon [className]=\"item.iconClassName\"></itb-icon>\n            {{item.label}}</a>\n            <div *ngIf=\"!item.link\" class=\"dropup-items\">\n            <itb-icon [className]=\"item.iconClassName\"></itb-icon>\n            {{item.label}}\n            </div>\n        </button>\n    </mat-menu>\n</div>\n\n<div class=\"{{className}}\" *ngIf=\"dropDownButton.buttonClassName\">\n        <itb-round-button [matMenuTriggerFor]=\"dropdownList\" [tooltipText]=\"dropDownButton.tooltipText\" [className]=\"dropDownButton.buttonClassName\" [iconClassName]=\"dropDownButton.buttonIconClassName\"></itb-round-button>\n        <mat-menu #dropdownList=\"matMenu\">\n            <button mat-menu-item *ngFor=\"let item of items\" (click)=\"onItemClickHandler(item)\">\n                <a *ngIf=\"item.link\" routerLink=\"{{item.link}}\"><itb-icon [className]=\"item.iconClassName\"></itb-icon>\n                {{item.label}}</a>\n                <div *ngIf=\"!item.link\" class=\"dropup-items\">\n                <itb-icon [className]=\"item.iconClassName\"></itb-icon>\n                {{item.label}}\n                </div>\n            </button>\n        </mat-menu>\n    </div>"
                }] }
    ];
    /** @nocollapse */
    DropdownListComponent.ctorParameters = function () { return []; };
    DropdownListComponent.propDecorators = {
        items: [{ type: Input }],
        dropDownButton: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return DropdownListComponent;
}());
if (false) {
    /** @type {?} */
    DropdownListComponent.prototype.items;
    /** @type {?} */
    DropdownListComponent.prototype.dropDownButton;
    /** @type {?} */
    DropdownListComponent.prototype.onClickHandler;
    /** @type {?} */
    DropdownListComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dropdown-list/dropdown-list.component.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropdownListModule = /** @class */ (function () {
    function DropdownListModule() {
    }
    DropdownListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DropdownListComponent],
                    imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule, IconModule, RoundButtonModule, RouterModule],
                    exports: [DropdownListComponent],
                },] }
    ];
    return DropdownListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/heading/heading.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HeadingComponent = /** @class */ (function () {
    function HeadingComponent() {
        this.className = stringConstants.DEFAULT_HEADING_CLASSNAME;
    }
    /**
     * @return {?}
     */
    HeadingComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.isHyperLink) {
            this.breakedLink = this.link.split('//');
            if (this.breakedLink[0] !== 'http:' && this.breakedLink[0] !== 'https:') {
                this.link = '//' + this.link;
            }
        }
    };
    HeadingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-heading',
                    template: "<div *ngIf=\"!isLink && !isHyperLink\" [class]=\"className\">\n  <span>{{ text }}</span>\n</div>\n\n<div *ngIf=\"isLink\" [class]=\"className\">\n    <a routerLink=\"{{link}}\" routerLinkActive=\"active\">{{ text }}</a>\n</div>\n\n<div *ngIf=\"isHyperLink && !isLink\" [class]=\"className\">\n  <a href=\"{{link}}\" target=\"_blank\" rel=\"noopener\">{{ text }}</a>\n</div>"
                }] }
    ];
    /** @nocollapse */
    HeadingComponent.ctorParameters = function () { return []; };
    HeadingComponent.propDecorators = {
        className: [{ type: Input }],
        text: [{ type: Input }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        isHyperLink: [{ type: Input }]
    };
    return HeadingComponent;
}());
if (false) {
    /** @type {?} */
    HeadingComponent.prototype.className;
    /** @type {?} */
    HeadingComponent.prototype.text;
    /** @type {?} */
    HeadingComponent.prototype.isLink;
    /** @type {?} */
    HeadingComponent.prototype.link;
    /** @type {?} */
    HeadingComponent.prototype.isHyperLink;
    /** @type {?} */
    HeadingComponent.prototype.breakedLink;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/heading/heading.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HeadingModule = /** @class */ (function () {
    function HeadingModule() {
    }
    HeadingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, DividerModule, RouterModule],
                    declarations: [HeadingComponent],
                    exports: [HeadingComponent],
                },] }
    ];
    return HeadingModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/text/text.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextComponent = /** @class */ (function () {
    function TextComponent() {
        this.onClickHandler = new EventEmitter();
        this.className = this.text || stringConstants.DEFAULT_TEXT_CLASSNAME;
    }
    /**
     * @return {?}
     */
    TextComponent.prototype.textClick = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    TextComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-text',
                    template: "<span *ngIf=\"!isLink && !isInnerHtml\" class=\"{{className}}\" [matTooltip]=\"tooltipText\" (click)=\"textClick()\">{{text}}</span>\n\n<a *ngIf=\"isLink\" routerLink=\"{{link}}\" routerLinkActive=\"active\"><span class=\"{{className}}\" [matTooltip]=\"tooltipText\" >{{text}}</span></a>\n\n<span *ngIf=\"!isLink && isInnerHtml\" class=\"{{className}}\" (click)=\"textClick()\" [innerHtml]=\"text\" [matTooltip]=\"tooltipText\"></span>"
                }] }
    ];
    /** @nocollapse */
    TextComponent.ctorParameters = function () { return []; };
    TextComponent.propDecorators = {
        className: [{ type: Input }],
        text: [{ type: Input }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        isInnerHtml: [{ type: Input }],
        tooltipText: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return TextComponent;
}());
if (false) {
    /** @type {?} */
    TextComponent.prototype.className;
    /** @type {?} */
    TextComponent.prototype.text;
    /** @type {?} */
    TextComponent.prototype.isLink;
    /** @type {?} */
    TextComponent.prototype.link;
    /** @type {?} */
    TextComponent.prototype.isInnerHtml;
    /** @type {?} */
    TextComponent.prototype.tooltipText;
    /** @type {?} */
    TextComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/text/text.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextModule = /** @class */ (function () {
    function TextModule() {
    }
    TextModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, RouterModule, MatTooltipModule$1],
                    declarations: [TextComponent],
                    exports: [TextComponent],
                },] }
    ];
    return TextModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/widget-footer/widget-footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WidgetFooterComponent = /** @class */ (function () {
    function WidgetFooterComponent() {
    }
    WidgetFooterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-widget-footer',
                    template: "<itb-icon [tooltipText]=\"tooltipText\" [className]=\"iconClassName\"></itb-icon>\n<itb-text [className]=\"'text-x-small'\" [text]=\"text\"></itb-text>\n"
                }] }
    ];
    /** @nocollapse */
    WidgetFooterComponent.ctorParameters = function () { return []; };
    WidgetFooterComponent.propDecorators = {
        text: [{ type: Input }],
        tooltipText: [{ type: Input }],
        iconClassName: [{ type: Input }],
        className: [{ type: Input }]
    };
    return WidgetFooterComponent;
}());
if (false) {
    /** @type {?} */
    WidgetFooterComponent.prototype.text;
    /** @type {?} */
    WidgetFooterComponent.prototype.tooltipText;
    /** @type {?} */
    WidgetFooterComponent.prototype.iconClassName;
    /** @type {?} */
    WidgetFooterComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/widget-footer/widget-footer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WidgetFooterModule = /** @class */ (function () {
    function WidgetFooterModule() {
    }
    WidgetFooterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [IconModule, TextModule],
                    declarations: [WidgetFooterComponent],
                    exports: [WidgetFooterComponent],
                },] }
    ];
    return WidgetFooterModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/widget/widget.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WidgetModule = /** @class */ (function () {
    function WidgetModule() {
    }
    WidgetModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatCardModule,
                        IconModule,
                        DefaultButtonModule,
                        RoundButtonModule,
                        BarLoaderModule,
                        WidgetFooterModule,
                        HeadingModule,
                        ColorBarModule,
                        SelectModule,
                        SpinnerModule,
                        DropdownListModule,
                    ],
                    declarations: [WidgetComponent],
                    exports: [WidgetComponent],
                },] }
    ];
    return WidgetModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/widget/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/popup-alert/popup-alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PopupAlertComponent = /** @class */ (function () {
    function PopupAlertComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.hasInnerHTML = false;
    }
    /**
     * @return {?}
     */
    PopupAlertComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.data.innerHTML ? this.hasInnerHTML = true : this.hasInnerHTML = false;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.closeNotification();
        }), 1500);
    };
    /**
     * @return {?}
     */
    PopupAlertComponent.prototype.closeNotification = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    PopupAlertComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-popup-alert',
                    template: "<div *ngIf=\"data.mode==='success'\">\n  <div class=\"popup-alert\">\n    <span class=\"sa-icon sa-success animate\">\n      <span class=\"sa-line sa-tip animateSuccessTip\"></span>\n      <span class=\"sa-line sa-long animateSuccessLong\"></span>\n      <span class=\"sa-placeholder\"></span>\n      <div class=\"sa-fix\"></div>\n    </span>\n  </div>\n  <div class=\"text-center mb-5 text-uppercase\">\n    <h3>{{data.mainMessage}}</h3>\n  </div>\n  <div class=\"popup-alert-well p-20\">\n    <p *ngIf=\"!hasInnerHTML\"> <b> {{data.title}}</b> {{data.body}}</p>\n    <div *ngIf=\"hasInnerHTML\"> <b> {{data.title}} </b> <div [innerHTML]=\"data.body\"></div> </div>\n  </div>\n</div>\n<div *ngIf=\"data.mode==='fail'\">\n  <div class=\"popup-alert\">\n    <span class=\"sa-icon sa-error animateErrorIcon\">\n      <span class=\"sa-x-mark animateXMark\">\n          <span class=\"sa-line sa-left\"></span>\n          <span class=\"sa-line sa-right\"></span>\n      </span>\n    </span>\n  </div>\n  <div class=\"text-center mb-5 text-uppercase\">\n    <h3>{{data.mainMessage}}</h3>\n  </div>\n  <div class=\"popup-alert-well p-20\">\n    <p *ngIf=\"!hasInnerHTML\"> <b> {{data.title}}</b> {{data.body}}</p>\n    <div *ngIf=\"hasInnerHTML\"> <b> {{data.title}} </b> <div [innerHTML]=\"data.body\"></div> </div>\n  </div>\n</div>\n<div *ngIf=\"data.mode==='refresh'\">\n  <div class=\"popup-alert\">\n    <span class=\"sa-icon sa-refresh animate\">\n      <span class=\"sa-line sa-tip animateSuccessTip\"></span>\n      <span class=\"sa-line sa-long animateSuccessLong\"></span>\n      <span class=\"sa-placeholder\"></span>\n      <div class=\"sa-fix\"></div>\n    </span>\n  </div>\n  <div class=\"text-center mb-5 text-uppercase\">\n    <h3>{{data.mainMessage}}</h3>\n  </div>\n  <div class=\"popup-alert-well p-20\">\n    <p *ngIf=\"!hasInnerHTML\"> <b> {{data.title}}</b> {{data.body}}</p>\n    <div *ngIf=\"hasInnerHTML\"> <b> {{data.title}} </b> <div [innerHTML]=\"data.body\"></div> </div>\n  </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    PopupAlertComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return PopupAlertComponent;
}());
if (false) {
    /** @type {?} */
    PopupAlertComponent.prototype.hasInnerHTML;
    /** @type {?} */
    PopupAlertComponent.prototype.dialogRef;
    /** @type {?} */
    PopupAlertComponent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/breadcrumbs/breadcrumbs.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BreadcrumbsComponent = /** @class */ (function () {
    function BreadcrumbsComponent(dialog) {
        this.dialog = dialog;
        this.iconHandler = new EventEmitter();
    }
    /**
     * @param {?} name
     * @param {?} index
     * @return {?}
     */
    BreadcrumbsComponent.prototype.iconClickEvent = /**
     * @param {?} name
     * @param {?} index
     * @return {?}
     */
    function (name, index) {
        this.iconHandler.emit({ name: name, index: index });
    };
    /**
     * @param {?} publink
     * @return {?}
     */
    BreadcrumbsComponent.prototype.copyPublicURL = /**
     * @param {?} publink
     * @return {?}
     */
    function (publink) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, navigator.clipboard.
                            writeText(publink)];
                    case 1:
                        _a.sent();
                        navigator.clipboard
                            .readText()
                            .then()
                            .catch()
                            .then((/**
                         * @param {?} text
                         * @return {?}
                         */
                        function (text) {
                            _this.dialog.open(PopupAlertComponent, {
                                width: '600px',
                                data: {
                                    mode: 'success',
                                    mainMessage: 'Copied!',
                                    body: 'URL copied to clipboard',
                                },
                            });
                        }))
                            .catch((/**
                         * @param {?} error
                         * @return {?}
                         */
                        function (error) {
                            _this.dialog.open(PopupAlertComponent, {
                                width: '600px',
                                data: {
                                    mode: 'fail',
                                    mainMessage: 'Failed!',
                                    body: 'URL failed to copy',
                                },
                            });
                        }));
                        return [2 /*return*/];
                }
            });
        });
    };
    BreadcrumbsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-breadcrumbs',
                    template: "<nav class=\"page-bar\">\n  <ul class=\"breadcrumb\">\n    <li class=\"links\" *ngFor=\"let link of links; last as isLast;\">\n      <a tabindex=\"-1\" routerLink=\"{{link.route}}\" routerLinkActive=\"active\" *ngIf=\"!isLast\">{{link.name}}</a>\n      <a tabindex=\"-1\" class=\"disabled\" *ngIf=\"isLast\">{{link.name}}</a>\n    </li>\n    <li class=\"img-tags\" *ngFor=\"let icon of icons; let indicator=index\">\n      <itb-icon [tooltipText]=\"icon.tooltipText\" [className]=\"icon.className\"\n        (onClickHandler)=\"iconClickEvent(icon.name,indicator)\"></itb-icon>\n    </li>\n    <li *ngIf=\"publicLink\" class=\"public-url\">\n      <span>{{publicLink}}</span>\n      <itb-icon [tooltipText]=\"'Copy'\" [className]=\"'copy'\" (onClickHandler)=\"copyPublicURL(publicLink)\"></itb-icon>\n    </li>\n    <li class=\"last-update\">{{text}}</li>\n  </ul>\n</nav>"
                }] }
    ];
    /** @nocollapse */
    BreadcrumbsComponent.ctorParameters = function () { return [
        { type: MatDialog }
    ]; };
    BreadcrumbsComponent.propDecorators = {
        links: [{ type: Input }],
        text: [{ type: Input }],
        icons: [{ type: Input }],
        publicLink: [{ type: Input }],
        iconHandler: [{ type: Output }]
    };
    return BreadcrumbsComponent;
}());
if (false) {
    /** @type {?} */
    BreadcrumbsComponent.prototype.links;
    /** @type {?} */
    BreadcrumbsComponent.prototype.text;
    /** @type {?} */
    BreadcrumbsComponent.prototype.icons;
    /** @type {?} */
    BreadcrumbsComponent.prototype.publicLink;
    /** @type {?} */
    BreadcrumbsComponent.prototype.iconHandler;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbsComponent.prototype.dialog;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/breadcrumbs/breadcrumbs.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BreadcrumbsModule = /** @class */ (function () {
    function BreadcrumbsModule() {
    }
    BreadcrumbsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, RouterModule, IconModule, MatSnackBarModule],
                    declarations: [BreadcrumbsComponent],
                    exports: [BreadcrumbsComponent, RouterModule],
                },] }
    ];
    return BreadcrumbsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/breadcrumbs/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/heading/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/text/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/badge/badge.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BadgeComponent = /** @class */ (function () {
    function BadgeComponent() {
        this.className = stringConstants.DEFAULT_BADGE_CLASSNAME;
    }
    BadgeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-badge',
                    template: "<span\nclass=\"{{className}}\"\nmatBadge={{content}}\n[hidden]=\"isHidden\"\n>\n</span>"
                }] }
    ];
    /** @nocollapse */
    BadgeComponent.ctorParameters = function () { return []; };
    BadgeComponent.propDecorators = {
        className: [{ type: Input }],
        content: [{ type: Input }],
        isHidden: [{ type: Input }]
    };
    return BadgeComponent;
}());
if (false) {
    /** @type {?} */
    BadgeComponent.prototype.className;
    /** @type {?} */
    BadgeComponent.prototype.content;
    /** @type {?} */
    BadgeComponent.prototype.isHidden;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/badge/badge.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BadgeModule = /** @class */ (function () {
    function BadgeModule() {
    }
    BadgeModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatBadgeModule],
                    declarations: [BadgeComponent],
                    exports: [BadgeComponent],
                },] }
    ];
    return BadgeModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/badge/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/action-panel/action-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionPanelComponent = /** @class */ (function () {
    function ActionPanelComponent() {
        this.nonHidEWidth = 0;
        this.hiddenItemsDynamic = [];
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @param {?} buttonName
     * @return {?}
     */
    ActionPanelComponent.prototype.clickEvent = /**
     * @param {?} buttonName
     * @return {?}
     */
    function (buttonName) {
        this.onClickHandler.emit(buttonName);
    };
    /**
     * @return {?}
     */
    ActionPanelComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.container = document.querySelector('.simple-action-panel .adaptive-buttons');
        this.primary = this.container.querySelector('.-primary');
        this.primaryItems = this.container.querySelectorAll('.-primary > .hide-mobile');
        if (!this.primaryItems.length) {
            // this.primary.querySelector('itb-default-button').classList.add('hide-mobile')
            this.primaryItems = this.container.querySelectorAll('.-primary > itb-default-button');
            this.primaryItems.forEach((/**
             * @param {?} item
             * @param {?} i
             * @return {?}
             */
            function (item, i) {
                item.classList.add('hide-mobile');
                // item.setAttribute("data-order",`${i}`)
            }));
        }
        this.allPrimaryItems =
            this.container.querySelectorAll('.-primary > itb-default-button:not(.hide-mobile), .-primary > itb-dropup-button:not(.hide-mobile)');
        this.allPrimaryItems.forEach((/**
         * @param {?} item
         * @param {?} i
         * @return {?}
         */
        function (item, i) { _this.nonHidEWidth = _this.nonHidEWidth + item.offsetWidth; }));
        this.container.classList.add('--jsfied');
        this.primary.insertAdjacentHTML('beforeend', "\n      <span class=\"-more\">\n        <span aria-haspopup=\"true\" aria-expanded=\"false\">\n        <button class=\"mat-flat-button edit-dots btn btn-primary\" type=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n        <span>More</span></button>\n        </span>\n        <ul class=\"-secondary\">\n        </ul>\n      </itb-default-button>\n    ");
        this.secondary = this.container.querySelector('.-secondary');
        this.secondaryItems = this.secondary.querySelectorAll('.hide-mobile');
        this.moreLi = this.primary.querySelector('span.-more');
        this.moreBtn = this.moreLi.querySelector('button');
        this.moreBtn.addEventListener('click', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            e.preventDefault();
            _this.container.classList.toggle('--show-secondary');
            _this.moreBtn.setAttribute('aria-expanded', _this.container.classList.contains('--show-secondary').toString());
        }));
        this.container.querySelectorAll('.-primary > *').forEach((/**
         * @param {?} item
         * @param {?} i
         * @return {?}
         */
        function (item, i) {
            item.setAttribute('data-order', "" + i);
        }));
        this.doAdapt();
    };
    /**
     * @return {?}
     */
    ActionPanelComponent.prototype.doAdapt = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.moreLi.classList.remove('--hidden');
        this.secondaryItems = this.secondary.querySelectorAll('.hide-mobile');
        /** @type {?} */
        var stopWidth = this.moreBtn.offsetWidth + this.nonHidEWidth + 20;
        if (this.primary.offsetWidth <= stopWidth + (this.primaryItems.length * (this.moreBtn.offsetWidth + 20))) {
            this.primaryItems.forEach((/**
             * @param {?} item
             * @param {?} i
             * @return {?}
             */
            function (item, i) {
                if (_this.primary.offsetWidth >= (stopWidth + _this.moreBtn.offsetWidth + 20)) {
                    stopWidth += _this.moreBtn.offsetWidth + 20;
                }
                else {
                    if (!_this.hiddenItemsDynamic.includes(i)) {
                        _this.hiddenItemsDynamic.push(i);
                        _this.secondary.insertAdjacentElement('beforeend', item);
                    }
                }
            }));
        }
        if (this.primary.offsetWidth >= (stopWidth + this.moreBtn.offsetWidth + 20)) {
            this.secondaryItems.forEach((/**
             * @param {?} item
             * @param {?} i
             * @return {?}
             */
            function (item, i) {
                if (_this.primary.offsetWidth >= (stopWidth + _this.moreBtn.offsetWidth + 20)) {
                    _this.primary.insertAdjacentElement('afterbegin', item);
                    _this.hiddenItemsDynamic.pop();
                    _this.sortElements();
                }
            }));
        }
        if (!this.hiddenItemsDynamic.length) {
            this.moreLi.classList.add('--hidden');
            this.container.classList.remove('--show-secondary');
            this.moreBtn.setAttribute('aria-expanded', 'false');
        }
    };
    /**
     * @return {?}
     */
    ActionPanelComponent.prototype.sortElements = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line: max-line-length
        Array.prototype.slice.call(document.querySelectorAll('.simple-action-panel .-primary > itb-default-button[data-order], .simple-action-panel .-primary > itb-dropup-button[data-order], .simple-action-panel .-primary > span.-more[data-order]')).sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            a = a.getAttribute('data-order');
            b = b.getAttribute('data-order');
            return a.localeCompare(b);
        })).forEach((/**
         * @param {?} node
         * @return {?}
         */
        function (node) {
            node.parentNode.appendChild(node);
        }));
    };
    ActionPanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-action-panel',
                    template: "<!-- <div class=\"action-panel\">\n    <div *ngFor='let btn of btnArray'>\n      <itb-default-button [iconClassName]=\"btn.iconClassName\" [isHidden]=\"btn.isHidden\" [isDisabled]=\"btn.isDisabled\" [className]=\"btn.className\" [isLoading]=\"btn.isLoading\" [text]=\"btn.text\" (onClickHandler)=clickEvent(btn.buttonName)></itb-default-button>\n    </div>\n</div> -->\n<div class=\"action-panel simple-action-panel\" (window:resize)=\"doAdapt()\">\n  <nav class=\"tabs adaptive-buttons\">\n    <ul class=\"-primary\">\n      <itb-default-button *ngFor='let btn of btnArray' [iconClassName]=\"btn.iconClassName\" [isHidden]=\"btn.isHidden\" [isDisabled]=\"btn.isDisabled\" [className]=\"btn.className\" [isLoading]=\"btn.isLoading\" [text]=\"btn.text\" (onClickHandler)=clickEvent(btn.buttonName)></itb-default-button>\n    </ul>\n  </nav>\n</div>"
                }] }
    ];
    ActionPanelComponent.propDecorators = {
        btnArray: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return ActionPanelComponent;
}());
if (false) {
    /** @type {?} */
    ActionPanelComponent.prototype.container;
    /** @type {?} */
    ActionPanelComponent.prototype.primary;
    /** @type {?} */
    ActionPanelComponent.prototype.primaryItems;
    /** @type {?} */
    ActionPanelComponent.prototype.allPrimaryItems;
    /** @type {?} */
    ActionPanelComponent.prototype.secondary;
    /** @type {?} */
    ActionPanelComponent.prototype.secondaryItems;
    /** @type {?} */
    ActionPanelComponent.prototype.allItems;
    /** @type {?} */
    ActionPanelComponent.prototype.moreLi;
    /** @type {?} */
    ActionPanelComponent.prototype.moreBtn;
    /** @type {?} */
    ActionPanelComponent.prototype.nonHidEWidth;
    /** @type {?} */
    ActionPanelComponent.prototype.hiddenItemsDynamic;
    /** @type {?} */
    ActionPanelComponent.prototype.btnArray;
    /** @type {?} */
    ActionPanelComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/action-panel/action-panel.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionPanelModule = /** @class */ (function () {
    function ActionPanelModule() {
    }
    ActionPanelModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, DefaultButtonModule, MatCardModule$1],
                    declarations: [ActionPanelComponent],
                    exports: [ActionPanelComponent],
                },] }
    ];
    return ActionPanelModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/action-panel/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/chip/chip.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ChipComponent = /** @class */ (function () {
    function ChipComponent() {
        this.onClickHandler = new EventEmitter();
        this.text = this.text || stringConstants.DEFAULT_CHIP_TEXT;
    }
    /**
     * @return {?}
     */
    ChipComponent.prototype.clickEvent = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    ChipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-chip',
                    template: "<div *ngIf=\"!isLink\" class=\"itb-chip\">\n    <mat-chip ngClass=\"{{className}}\" matTooltip=\"{{tooltipText}}\" (click)=\"clickEvent()\"><span class=\"chip-text\">{{text}}</span><span class=\"add-ico\">+</span> </mat-chip>\n</div>\n\n<div *ngIf=\"isLink\" class=\"itb-chip\">\n        <a routerLink=\"{{link}}\"><mat-chip ngClass=\"{{className}}\" matTooltip=\"{{tooltipText}}\" (click)=\"clickEvent()\"><span class=\"chip-text\">{{text}}</span><span class=\"add-ico\">+</span> </mat-chip></a>\n</div>"
                }] }
    ];
    /** @nocollapse */
    ChipComponent.ctorParameters = function () { return []; };
    ChipComponent.propDecorators = {
        className: [{ type: Input }],
        tooltipText: [{ type: Input }],
        text: [{ type: Input }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return ChipComponent;
}());
if (false) {
    /** @type {?} */
    ChipComponent.prototype.className;
    /** @type {?} */
    ChipComponent.prototype.tooltipText;
    /** @type {?} */
    ChipComponent.prototype.text;
    /** @type {?} */
    ChipComponent.prototype.isLink;
    /** @type {?} */
    ChipComponent.prototype.link;
    /** @type {?} */
    ChipComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/chip/chip.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ChipModule = /** @class */ (function () {
    function ChipModule() {
    }
    ChipModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatChipsModule, MatTooltipModule, RouterModule],
                    declarations: [ChipComponent],
                    exports: [ChipComponent, MatChipsModule, MatTooltipModule],
                },] }
    ];
    return ChipModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/chip/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/image/image.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ImageComponent = /** @class */ (function () {
    function ImageComponent() {
        this.onClickHandler = new EventEmitter();
        this.imageWidth = 150;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    ImageComponent.prototype.onImageError = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.src = this.srcNotFound;
    };
    /**
     * @return {?}
     */
    ImageComponent.prototype.imgClick = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit('image clicked');
    };
    ImageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-image',
                    template: "\n<ng-container *ngIf=\"canShowErrorImage\">\n  <img [matTooltip]=\"tooltipText\" width=\"{{imageWidth}}\" height=\"{{imageHeight}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\" *ngIf=\"!isLink && imageHeight\" (error)=\"onImageError($event)\">\n  <img [matTooltip]=\"tooltipText\" width=\"{{imageWidth}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\" *ngIf=\"!isLink && !imageHeight\" (error)=\"onImageError($event)\">\n  <a [matTooltip]=\"tooltipText\" *ngIf=\"isLink && imageHeight\" routerLink=\"{{link}}\" routerLinkActive=\"active\"><img width=\"{{imageWidth}}\" height=\"{{imageHeight}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\" (error)=\"onImageError($event)\"></a>\n  <a [matTooltip]=\"tooltipText\" *ngIf=\"isLink && !imageHeight\" routerLink=\"{{link}}\" routerLinkActive=\"active\"><img width=\"{{imageWidth}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\" (error)=\"onImageError($event)\"></a>\n</ng-container>\n<ng-container *ngIf=\"!canShowErrorImage\">\n  <img [matTooltip]=\"tooltipText\" width=\"{{imageWidth}}\" height=\"{{imageHeight}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\" *ngIf=\"!isLink && imageHeight\">\n  <img [matTooltip]=\"tooltipText\" width=\"{{imageWidth}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\" *ngIf=\"!isLink && !imageHeight\">\n  <a [matTooltip]=\"tooltipText\" *ngIf=\"isLink && imageHeight\" routerLink=\"{{link}}\" routerLinkActive=\"active\"><img width=\"{{imageWidth}}\" height=\"{{imageHeight}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\"></a>\n  <a [matTooltip]=\"tooltipText\" *ngIf=\"isLink && !imageHeight\" routerLink=\"{{link}}\" routerLinkActive=\"active\"><img width=\"{{imageWidth}}\" src=\"{{src}}\" ngClass=\"{{className}}\" (click)=\"imgClick()\"></a>\n</ng-container>\n"
                }] }
    ];
    /** @nocollapse */
    ImageComponent.ctorParameters = function () { return []; };
    ImageComponent.propDecorators = {
        className: [{ type: Input }],
        src: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        imageWidth: [{ type: Input }],
        imageHeight: [{ type: Input }],
        tooltipText: [{ type: Input }],
        srcNotFound: [{ type: Input }],
        canShowErrorImage: [{ type: Input }]
    };
    return ImageComponent;
}());
if (false) {
    /** @type {?} */
    ImageComponent.prototype.className;
    /** @type {?} */
    ImageComponent.prototype.src;
    /** @type {?} */
    ImageComponent.prototype.onClickHandler;
    /** @type {?} */
    ImageComponent.prototype.isLink;
    /** @type {?} */
    ImageComponent.prototype.link;
    /** @type {?} */
    ImageComponent.prototype.imageWidth;
    /** @type {?} */
    ImageComponent.prototype.imageHeight;
    /** @type {?} */
    ImageComponent.prototype.tooltipText;
    /** @type {?} */
    ImageComponent.prototype.srcNotFound;
    /** @type {?} */
    ImageComponent.prototype.canShowErrorImage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/image/image.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ImageModule = /** @class */ (function () {
    function ImageModule() {
    }
    ImageModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, RouterModule, MatTooltipModule$1],
                    declarations: [ImageComponent],
                    exports: [ImageComponent],
                },] }
    ];
    return ImageModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/image/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/color-bar/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/empty-state-image/empty-state-image.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmptyStateImageComponent = /** @class */ (function () {
    function EmptyStateImageComponent() {
        this.onClickHandler = new EventEmitter();
        this.imageClass = stringConstants.DEFAULT_EMPTY_STATE_IMAGE_CLASSNAME;
        this.isHidden = false;
    }
    /**
     * @return {?}
     */
    EmptyStateImageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.button = this.buttonText ? true : false;
    };
    /**
     * @param {?} text
     * @return {?}
     */
    EmptyStateImageComponent.prototype.onClickEvent = /**
     * @param {?} text
     * @return {?}
     */
    function (text) {
        this.onClickHandler.emit(text);
    };
    EmptyStateImageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-empty-state-image',
                    template: "<div class=\"empty-state\">\n    <div [className]=\"imageClass\"></div>\n    <itb-text [className]=\"headingClass\" [text]=\"headingText\"></itb-text>\n    <itb-text [className]=\"subHeadingClass\" [text]=\"subHeadingText\"></itb-text>\n    <itb-default-button *ngIf=\"button\" [isHidden]=\"isHidden\" [iconClassName]=\"iconClassName\" [text]=\"buttonText\" [className]=\"buttonClass\" (click)=\"onClickEvent(buttonText)\"></itb-default-button>\n</div>"
                }] }
    ];
    /** @nocollapse */
    EmptyStateImageComponent.ctorParameters = function () { return []; };
    EmptyStateImageComponent.propDecorators = {
        imageClass: [{ type: Input }],
        buttonClass: [{ type: Input }],
        buttonText: [{ type: Input }],
        headingText: [{ type: Input }],
        subHeadingText: [{ type: Input }],
        headingClass: [{ type: Input }],
        subHeadingClass: [{ type: Input }],
        iconClassName: [{ type: Input }],
        isHidden: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return EmptyStateImageComponent;
}());
if (false) {
    /** @type {?} */
    EmptyStateImageComponent.prototype.imageClass;
    /** @type {?} */
    EmptyStateImageComponent.prototype.buttonClass;
    /** @type {?} */
    EmptyStateImageComponent.prototype.buttonText;
    /** @type {?} */
    EmptyStateImageComponent.prototype.headingText;
    /** @type {?} */
    EmptyStateImageComponent.prototype.subHeadingText;
    /** @type {?} */
    EmptyStateImageComponent.prototype.headingClass;
    /** @type {?} */
    EmptyStateImageComponent.prototype.subHeadingClass;
    /** @type {?} */
    EmptyStateImageComponent.prototype.iconClassName;
    /** @type {?} */
    EmptyStateImageComponent.prototype.isHidden;
    /** @type {?} */
    EmptyStateImageComponent.prototype.onClickHandler;
    /** @type {?} */
    EmptyStateImageComponent.prototype.button;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/empty-state-image/empty-state-image.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmptyStateImageModule = /** @class */ (function () {
    function EmptyStateImageModule() {
    }
    EmptyStateImageModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, DefaultButtonModule, TextModule],
                    declarations: [EmptyStateImageComponent],
                    exports: [EmptyStateImageComponent],
                },] }
    ];
    return EmptyStateImageModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/empty-state-image/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/page-wrapper/page-wrapper.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PageWrapperComponent = /** @class */ (function () {
    function PageWrapperComponent() {
    }
    PageWrapperComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-page-wrapper',
                    template: "<div class=\"{{className}}\">\n    <ng-content></ng-content>\n</div>\n"
                }] }
    ];
    PageWrapperComponent.propDecorators = {
        className: [{ type: Input }]
    };
    return PageWrapperComponent;
}());
if (false) {
    /** @type {?} */
    PageWrapperComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/page-wrapper/page-wrapper.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PageWrapperModule = /** @class */ (function () {
    function PageWrapperModule() {
    }
    PageWrapperModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [PageWrapperComponent],
                    exports: [PageWrapperComponent],
                },] }
    ];
    return PageWrapperModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/page-wrapper/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/alphabet-filter/alphabet-filter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AlphabetFilterComponent = /** @class */ (function () {
    function AlphabetFilterComponent() {
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AlphabetFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.itemsList = [
            { label: 'All' }, { label: 'A' }, { label: 'B' }, { label: 'C' }, { label: 'D' }, { label: 'E' },
            { label: 'F' }, { label: 'G' }, { label: 'H' }, { label: 'I' }, { label: 'J' }, { label: 'K' },
            { label: 'L' }, { label: 'M' }, { label: 'N' }, { label: 'O' }, { label: 'P' }, { label: 'Q' },
            { label: 'R' }, { label: 'S' }, { label: 'T' }, { label: 'U' }, { label: 'V' }, { label: 'W' },
            { label: 'X' }, { label: 'Y' }, { label: 'Z' },
        ];
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    AlphabetFilterComponent.prototype.clickEvent = /**
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        this.selectedItem = selected;
        this.onClickHandler.emit(selected);
    };
    AlphabetFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-alphabet-filter',
                    template: "<div class=\"{{className}}\">\n    <mat-button-toggle-group class=\"alphabet-filter\" name=\"alphabetfilter\" aria-label=\"Alphabet Filter\">\n        <mat-button-toggle *ngFor=\"let item of itemsList\" (click)=\"clickEvent(item.label)\">{{item.label}}</mat-button-toggle>\n    </mat-button-toggle-group>\n</div>"
                }] }
    ];
    AlphabetFilterComponent.propDecorators = {
        className: [{ type: Input }],
        selectedItem: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        itemsList: [{ type: Input }]
    };
    return AlphabetFilterComponent;
}());
if (false) {
    /** @type {?} */
    AlphabetFilterComponent.prototype.className;
    /** @type {?} */
    AlphabetFilterComponent.prototype.selectedItem;
    /** @type {?} */
    AlphabetFilterComponent.prototype.onClickHandler;
    /** @type {?} */
    AlphabetFilterComponent.prototype.itemsList;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/alphabet-filter/alphabet-filter.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AlphabetFilterModule = /** @class */ (function () {
    function AlphabetFilterModule() {
    }
    AlphabetFilterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonToggleModule],
                    declarations: [AlphabetFilterComponent],
                    exports: [AlphabetFilterComponent],
                },] }
    ];
    return AlphabetFilterModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/alphabet-filter/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/table/table.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TableComponent = /** @class */ (function () {
    function TableComponent() {
        this.onActionClickHandler = new EventEmitter();
        this.onTextClickHandler = new EventEmitter();
        this.onSwitchClickHandler = new EventEmitter();
        this.onChangeHandler = new EventEmitter();
        this.onSimpleChangeHandler = new EventEmitter();
        this.disableColHeaders = false;
        this.hasInnerHTML = false;
        this.openInNewTab = false;
    }
    /**
     * @param {?} user
     * @param {?} action
     * @return {?}
     */
    TableComponent.prototype.actionClickEvent = /**
     * @param {?} user
     * @param {?} action
     * @return {?}
     */
    function (user, action) {
        this.onActionClickHandler.emit({ user: user, action: action });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.textClickEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onTextClickHandler.emit(event);
    };
    /**
     * @param {?} user
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.switchClickEvent = /**
     * @param {?} user
     * @param {?} event
     * @return {?}
     */
    function (user, event) {
        this.onSwitchClickHandler.emit({ user: user, event: event });
    };
    /**
     * @param {?} str
     * @return {?}
     */
    TableComponent.prototype.getSplit = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        if (str.includes('↵'))
            return str.replace(/↵/g, '<br>');
        return str.replace(/\r|\n/g, '<br>');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.selectClickEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onChangeHandler.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.simpleSelectEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onSimpleChangeHandler.emit(event);
    };
    TableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-table',
                    template: "<div class=\"{{className}}\">\n<table mat-table [dataSource]=\"dataSource\" class=\"itb-table\">\n    <ng-container *ngFor=\"let col of displayedColumns\" matColumnDef=\"{{col}}\" >\n        <th class=\"table-h\" mat-header-cell *matHeaderCellDef mat-sort-header> {{col}} </th>\n        <div [ngSwitch]=\"col\">\n            <div *ngSwitchCase=\"'hand'\">\n                <td mat-cell *matCellDef=\"let element\">\n                    <itb-image [src]=\"element.hand.imagePath\" [imageHeight]=\"element.hand.imageHeight\" [imageWidth]=\"element.hand.imageWidth\"></itb-image>\n                </td>\n            </div>\n            <div *ngSwitchCase=\"'permissions'\">\n                <td mat-cell *matCellDef=\"let element\">\n                    <mat-chip-list>\n                        <itb-chip *ngFor=\"let chip of element.permissions\" [tooltipText]=\"chip.tooltipText\"\n                                  [className]=\"chip.className\" [text]=\"chip.text\">\n                        </itb-chip>\n                    </mat-chip-list>\n                </td>\n            </div>\n            <div *ngSwitchCase=\"'actions'\">\n                <td mat-cell *matCellDef=\"let element\">\n                    <itb-icon *ngFor=\"let action of element.actions\" [tooltipText]=\"action.tooltipText\"\n                              [className]=\"action.className\" (click)=\"actionClickEvent(element, action.name)\">\n                    </itb-icon>\n                </td>\n            </div>\n            <div *ngSwitchCase=\"'ticket'\"> \n                <td mat-cell *matCellDef=\"let element\">\n                    <a href=\"{{element.link}}\" [target]=\"openInNewTab ? '_blank' : '_self'\" rel=\"noopener\">{{element[col]}}</a>\n                </td>\n            </div>\n            <div *ngSwitchCase=\"'show as popup'\">\n                <td mat-cell *matCellDef=\"let element\">\n                    <itb-switch [isReactive]=\"false\" [hasDivider]=\"false\" [isDisabled]=\"element.switch.isDisabled\" [value]=\"element.switch.value\" (onChangeHandler)=\"switchClickEvent(element, $event.checked)\">\n                    </itb-switch>\n                </td>\n            </div>\n            <div *ngSwitchCase=\"'group'\">\n                <td mat-cell *matCellDef=\"let element\">\n                    <itb-select [isReactive]=\"false\" [isDisabled]=\"element.group.isDisabled\" [label]=\"element.group.label\" [items]=\"element.group.items\" [isMultiple]=\"element.group.isMultiple\" [itemsStringArray]=\"element.group.itemsStringArray\" [isDataInStrings]=\"element.group.isDataInStrings\" [selected]=\"element.group.selected\" [isSelectWithObjects]=\"element.group.isSelectWithObjects\" [isRequired]=\"element.group.isRequired\" [isSorted]=\"element.group.isSorted\" (onChangeHandler)=\"selectClickEvent($event)\" (onSimpleChangeHandler)=\"simpleSelectEvent($event)\" >\n                    </itb-select>\n                </td>\n            </div>\n            <div *ngSwitchDefault>\n                <ng-container *ngIf=\"!hasInnerHTML\">\n                    <td mat-cell *matCellDef=\"let element\" (click)=\"textClickEvent(element)\"> {{element[col]}} </td>\n                </ng-container>\n                <ng-container *ngIf=\"hasInnerHTML\">\n                    <td mat-cell *matCellDef=\"let element\" [innerHTML]=\"getSplit(element[col])\" (click)=\"textClickEvent(element)\"></td>\n                </ng-container>\n            </div>\n        </div>\n    </ng-container>\n\n    <ng-container *ngIf=\"!disableColHeaders\">\n        <tr mat-header-row *matHeaderRowDef= \"displayedColumns; sticky: true\"></tr>\n    </ng-container>\n    <tr mat-row *matRowDef=\"let row; columns: displayedColumns\" [ngClass]=\"{'table-row-color': row.color}\"></tr>\n</table>\n</div>"
                }] }
    ];
    /** @nocollapse */
    TableComponent.ctorParameters = function () { return []; };
    TableComponent.propDecorators = {
        dataSource: [{ type: Input }],
        displayedColumns: [{ type: Input }],
        className: [{ type: Input }],
        disableColHeaders: [{ type: Input }],
        hasInnerHTML: [{ type: Input }],
        openInNewTab: [{ type: Input }],
        onActionClickHandler: [{ type: Output }],
        onTextClickHandler: [{ type: Output }],
        onSwitchClickHandler: [{ type: Output }],
        onChangeHandler: [{ type: Output }],
        onSimpleChangeHandler: [{ type: Output }]
    };
    return TableComponent;
}());
if (false) {
    /** @type {?} */
    TableComponent.prototype.dataSource;
    /** @type {?} */
    TableComponent.prototype.displayedColumns;
    /** @type {?} */
    TableComponent.prototype.className;
    /** @type {?} */
    TableComponent.prototype.disableColHeaders;
    /** @type {?} */
    TableComponent.prototype.hasInnerHTML;
    /** @type {?} */
    TableComponent.prototype.openInNewTab;
    /** @type {?} */
    TableComponent.prototype.onActionClickHandler;
    /** @type {?} */
    TableComponent.prototype.onTextClickHandler;
    /** @type {?} */
    TableComponent.prototype.onSwitchClickHandler;
    /** @type {?} */
    TableComponent.prototype.onChangeHandler;
    /** @type {?} */
    TableComponent.prototype.onSimpleChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/switch/switch.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SwitchComponent = /** @class */ (function () {
    function SwitchComponent() {
        this.onChangeHandler = new EventEmitter();
        this.isReactive = true;
        this.hasDivider = true;
    }
    /**
     * Emits the change each time switch is toggled.
     * @param event The value to emit.
     */
    /**
     * Emits the change each time switch is toggled.
     * @param {?} event The value to emit.
     * @return {?}
     */
    SwitchComponent.prototype.changeEvent = /**
     * Emits the change each time switch is toggled.
     * @param {?} event The value to emit.
     * @return {?}
     */
    function (event) {
        this.onChangeHandler.emit(event);
    };
    SwitchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-switch',
                    template: "<div *ngIf=\"isReactive\" class=\"itb-switch\" [formGroup]=\"parentForm\">\n  <mat-slide-toggle [checked]=\"value\" ngClass=\"{{className}}\" [labelPosition]=\"labelPosition\"\n    [formControlName]=\"formFieldName\" (change)=\"changeEvent($event)\">\n    {{label}}</mat-slide-toggle>\n    <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n\n<div *ngIf=\"!isReactive && hasDivider\" class=\"itb-switch\">\n  <mat-slide-toggle [disabled]=\"isDisabled\" [checked]=\"value\" ngClass=\"{{className}}\" [labelPosition]=\"labelPosition\"\n    (change)=\"changeEvent($event)\">\n    {{label}}</mat-slide-toggle>\n    <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n\n<div *ngIf=\"!isReactive && !hasDivider\" class=\"itb-switch\">\n  <mat-slide-toggle [disabled]=\"isDisabled\" [checked]=\"value\" ngClass=\"{{className}}\" [labelPosition]=\"labelPosition\"\n    (change)=\"changeEvent($event)\">\n    {{label}}</mat-slide-toggle>\n</div>"
                }] }
    ];
    /** @nocollapse */
    SwitchComponent.ctorParameters = function () { return []; };
    SwitchComponent.propDecorators = {
        value: [{ type: Input }],
        label: [{ type: Input }],
        labelPosition: [{ type: Input }],
        className: [{ type: Input }],
        formFieldName: [{ type: Input }],
        parentForm: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isReactive: [{ type: Input }],
        hasDivider: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return SwitchComponent;
}());
if (false) {
    /** @type {?} */
    SwitchComponent.prototype.value;
    /** @type {?} */
    SwitchComponent.prototype.label;
    /** @type {?} */
    SwitchComponent.prototype.labelPosition;
    /** @type {?} */
    SwitchComponent.prototype.className;
    /** @type {?} */
    SwitchComponent.prototype.formFieldName;
    /** @type {?} */
    SwitchComponent.prototype.parentForm;
    /** @type {?} */
    SwitchComponent.prototype.isDisabled;
    /** @type {?} */
    SwitchComponent.prototype.isReactive;
    /** @type {?} */
    SwitchComponent.prototype.hasDivider;
    /** @type {?} */
    SwitchComponent.prototype.onChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/switch/switch.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SwitchModule = /** @class */ (function () {
    function SwitchModule() {
    }
    SwitchModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatSlideToggleModule, ReactiveFormsModule, FormsModule, DividerModule],
                    declarations: [SwitchComponent],
                    exports: [SwitchComponent],
                },] }
    ];
    return SwitchModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/table/table.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TableModule = /** @class */ (function () {
    function TableModule() {
    }
    TableModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatTableModule, ChipModule, IconModule, MatChipsModule$1, ImageModule, SwitchModule, SelectModule],
                    declarations: [TableComponent],
                    exports: [TableComponent],
                },] }
    ];
    return TableModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/table/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/button-group/button-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonGroupComponent = /** @class */ (function () {
    function ButtonGroupComponent() {
        var _this = this;
        this.onClickHandler = new EventEmitter();
        this.clickEvent = (/**
         * @param {?} buttonName
         * @return {?}
         */
        function (buttonName) {
            _this.onClickHandler.emit(buttonName);
        });
    }
    /**
     * @return {?}
     */
    ButtonGroupComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = this.className || stringConstants.DEFAULT_BUTTON_GROUP_CLASSNAME;
    };
    ButtonGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-button-group',
                    template: "<div [class]=\"this.className\">\n    <div *ngFor=\"let button of buttons\" class=\"btn-group-item\">\n        <itb-icon [tooltipText]=\"button.tooltipText\" [className]=\"button.iconClassName\" (click)=\"clickEvent(button.buttonName)\" ></itb-icon>\n    </div>\n</div>\n"
                }] }
    ];
    ButtonGroupComponent.propDecorators = {
        className: [{ type: Input }],
        buttons: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return ButtonGroupComponent;
}());
if (false) {
    /** @type {?} */
    ButtonGroupComponent.prototype.className;
    /** @type {?} */
    ButtonGroupComponent.prototype.buttons;
    /** @type {?} */
    ButtonGroupComponent.prototype.onClickHandler;
    /** @type {?} */
    ButtonGroupComponent.prototype.clickEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/button-group/button-group.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonGroupModule = /** @class */ (function () {
    function ButtonGroupModule() {
    }
    ButtonGroupModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, IconModule,
                    ],
                    declarations: [ButtonGroupComponent],
                    exports: [ButtonGroupComponent],
                },] }
    ];
    return ButtonGroupModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/expansion-panel-list-item/expansion-panel-list-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ExpansionPanelListItemComponent = /** @class */ (function () {
    function ExpansionPanelListItemComponent() {
        this.onClickHandler = new EventEmitter();
        this.onTextClickHandler = new EventEmitter();
        this.className = stringConstants.DEFAULT_ANCHORTAG_CLASSNAME;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    ExpansionPanelListItemComponent.prototype.onClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onClickHandler.emit(item);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ExpansionPanelListItemComponent.prototype.onTextClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onTextClickHandler.emit(event);
    };
    ExpansionPanelListItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-expansion-panel-list-item',
                    template: "<li class=\"left-side-bar-li\" *ngFor=\"let item of itemList\">\n    <a *ngIf=\"item.isLink\" routerLink=\"{{ item.link }}\" [queryParams]=\"item.queryParams\" class=\"{{className}}\" [ngClass]=\"item.isActive ? 'active' : ''\">\n        <itb-icon [className]=\"item.iconClassName\" [tooltipText]=\"item.tooltipText\" (onClickHandler)=\"onTextClick(item)\"></itb-icon>\n        <itb-text [className]=\"item.textClassName\" [text]=\"item.text\" (onClickHandler)=\"onTextClick(item)\"></itb-text>\n        <!-- <itb-chip *ngIf=\"!item.isChipDisabled && !item.isAddChipHidden\" [className]=\"item.chipClassName\" [tooltipText]=\"item.chipTooltipText\" [text]=\"item.chipText\"\n            (onClickHandler)=\"onClick(item)\"></itb-chip>\n        <itb-chip *ngIf=\"!item.isChipDisabled && item.isAddChipHidden\" class=\"chip-disabled\" [className]=\"item.chipClassName\" [tooltipText]=\"item.chipTooltipText\" [text]=\"item.chipText\"></itb-chip> -->\n    </a>\n    <a *ngIf=\"!item.isLink\" class=\"{{className}}\" [ngClass]=\"item.isActive ? 'active' : ''\">\n        <itb-icon [className]=\"item.iconClassName\" [tooltipText]=\"item.tooltipText\" (onClickHandler)=\"onTextClick(item)\"></itb-icon>\n        <itb-text [className]=\"item.textClassName\" [text]=\"item.text\" (onClickHandler)=\"onTextClick(item)\"></itb-text>\n    </a>\n    <itb-chip *ngIf=\"!item.isChipDisabled && !item.isAddChipHidden\" [className]=\"item.chipClassName\" [tooltipText]=\"item.chipTooltipText\" [text]=\"item.chipText\"\n        (onClickHandler)=\"onClick(item)\"></itb-chip>\n    <itb-chip *ngIf=\"!item.isChipDisabled && item.isAddChipHidden\" class=\"chip-disabled\" [className]=\"item.chipClassName\" [tooltipText]=\"item.chipTooltipText\" [text]=\"item.chipText\"></itb-chip>\n</li>"
                }] }
    ];
    /** @nocollapse */
    ExpansionPanelListItemComponent.ctorParameters = function () { return []; };
    ExpansionPanelListItemComponent.propDecorators = {
        itemList: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onTextClickHandler: [{ type: Output }]
    };
    return ExpansionPanelListItemComponent;
}());
if (false) {
    /** @type {?} */
    ExpansionPanelListItemComponent.prototype.className;
    /** @type {?} */
    ExpansionPanelListItemComponent.prototype.itemList;
    /** @type {?} */
    ExpansionPanelListItemComponent.prototype.onClickHandler;
    /** @type {?} */
    ExpansionPanelListItemComponent.prototype.onTextClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/expansion-panel-list-item/expansion-panel-list-item.component.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ExpansionListItemModule = /** @class */ (function () {
    function ExpansionListItemModule() {
    }
    ExpansionListItemModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ExpansionPanelListItemComponent],
                    imports: [CommonModule, ChipModule, MatChipsModule$1, TextModule, IconModule, RouterModule],
                    exports: [ExpansionPanelListItemComponent],
                },] }
    ];
    return ExpansionListItemModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-item-list/rsb-item-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RsbItemListComponent = /** @class */ (function () {
    function RsbItemListComponent() {
        this.onClickHandler = new EventEmitter();
        this.className = stringConstants.DEFAULT_RSB_ITEM_LIST_CLASSNAME;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RsbItemListComponent.prototype.onClick = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onClickHandler.emit(value);
    };
    RsbItemListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-rsb-item-list',
                    template: "<mat-accordion class=\"rsb-list-item\">\n    <mat-expansion-panel class=\"rsb-list-item-xp\"  *ngFor=\"let listItem of rsbListItems\">\n        <mat-expansion-panel-header class=\"rsb-list-item-hd\" [collapsedHeight]=\"'42px'\" [expandedHeight]=\"'42px'\" >\n            <span>            \n                <itb-color-bar *ngIf=\"listItem.hasColorBar\" [className]=\"listItem.colorBarClassName\"></itb-color-bar>\n                <itb-text [className]=\"listItem.textClassName\" [text]=\"listItem.text\"></itb-text>\n            </span>\n            <itb-dropdown-list [dropDownButton]=\"listItem.dropDownButton\" [items]=\"listItem.dropdownItems\" (onClickHandler)=\"onClick($event)\"></itb-dropdown-list>\n        </mat-expansion-panel-header>\n        <ng-content></ng-content>\n    </mat-expansion-panel>\n</mat-accordion>"
                }] }
    ];
    /** @nocollapse */
    RsbItemListComponent.ctorParameters = function () { return []; };
    RsbItemListComponent.propDecorators = {
        rsbListItems: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return RsbItemListComponent;
}());
if (false) {
    /** @type {?} */
    RsbItemListComponent.prototype.rsbListItems;
    /** @type {?} */
    RsbItemListComponent.prototype.onClickHandler;
    /** @type {?} */
    RsbItemListComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-item-list/rsb-item-list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RsbItemListModule = /** @class */ (function () {
    function RsbItemListModule() {
    }
    RsbItemListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RsbItemListComponent],
                    imports: [CommonModule, ColorBarModule, MatButtonModule, MatIconModule, MatMenuModule, TextModule,
                        DropdownListModule, MatExpansionModule],
                    exports: [RsbItemListComponent],
                },] }
    ];
    return RsbItemListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/expansion-panel/expansion-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ExpansionPanelComponent = /** @class */ (function () {
    function ExpansionPanelComponent(ref) {
        this.ref = ref;
        this.textClickHandler = new EventEmitter();
        this.clickHandler = new EventEmitter();
        this.footerClickHandler = new EventEmitter();
        this.headerClickHandler = new EventEmitter();
        this.className = stringConstants.DEFAULT_RSB_EXP_PANEL_FOOTER_CLASSNAME;
    }
    /**
     * @return {?}
     */
    ExpansionPanelComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.ref.detectChanges();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ExpansionPanelComponent.prototype.onClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.clickHandler.emit(event);
    };
    /**
     * @return {?}
     */
    ExpansionPanelComponent.prototype.expFooterClickHandler = /**
     * @return {?}
     */
    function () {
        this.footerClickHandler.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ExpansionPanelComponent.prototype.onTextClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.textClickHandler.emit(event);
    };
    /**
     * @return {?}
     */
    ExpansionPanelComponent.prototype.openedEvent = /**
     * @return {?}
     */
    function () {
        this.expander = true;
    };
    /**
     * @return {?}
     */
    ExpansionPanelComponent.prototype.closedEvent = /**
     * @return {?}
     */
    function () {
        this.expander = false;
    };
    /**
     * @param {?} panel
     * @return {?}
     */
    ExpansionPanelComponent.prototype.expansionClickEvent = /**
     * @param {?} panel
     * @return {?}
     */
    function (panel) {
        this.headerClickHandler.emit({ panel: panel, isExpanded: this.expander });
    };
    ExpansionPanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-expansion-panel',
                    template: "<ng-container *ngIf=\"!rsbExpansionPanel\">\n    <mat-accordion class=\"left-side-bar\" [multi]=\"true\">\n        <mat-expansion-panel *ngFor=\"let panel of expansionPanels\" [expanded]=\"panel.isExpanded\" (opened)=\"openedEvent()\" (closed)=\"closedEvent()\" (click)=\"expansionClickEvent(panel)\">\n            <mat-expansion-panel-header *ngIf=\"panel.sectionItems\" [matTooltip]=\"panel.tooltipText\" [collapsedHeight]=\"'38px'\" [expandedHeight]=\"'38px'\">\n                <itb-icon class=\"lsb-group\" [className]=\"'icon-group2'\"></itb-icon>\n                <itb-text [className]=\"panel.textClassName\" [text]=\"panel.sectionName\"></itb-text>\n            </mat-expansion-panel-header>\n            <mat-expansion-panel-header *ngIf=\"!panel.sectionItems\" class=\"disable-lsb-expansion\" [collapsedHeight]=\"'38px'\" [expandedHeight]=\"'38px'\" #panelH (click)=\"panelH._toggle()\">\n                <itb-icon class=\"lsb-group\" [className]=\"'icon-group2'\"></itb-icon>\n                <itb-text [className]=\"panel.textClassName\" [text]=\"panel.sectionName\"></itb-text>\n            </mat-expansion-panel-header>\n            <itb-expansion-panel-list-item (onClickHandler)=\"onClick($event)\" (onTextClickHandler)=\"onTextClick($event)\" [itemList]=\"panel.sectionItems\">\n            </itb-expansion-panel-list-item>\n        </mat-expansion-panel>\n    </mat-accordion>\n</ng-container>\n\n<ng-container *ngIf=\"rsbExpansionPanel\">\n    <mat-accordion class=\"right-side-bar\">\n        <mat-expansion-panel *ngFor=\"let panel of expansionPanels\" [expanded]=\"panel.isExpanded\">\n            <mat-expansion-panel-header [matTooltip]=\"panel.tooltipText\" [collapsedHeight]=\"'42px'\" [expandedHeight]=\"'42px'\" (opened)=\"openedEvent()\" (closed)=\"closedEvent()\" (click)=\"expansionClickEvent(panel)\">\n                <itb-icon *ngIf=\"!isExpanded\" [className]=\"panel.iconClassName\" [tooltipText]=\"panel.tooltipText\">\n                </itb-icon>\n                <itb-text [className]=\"panel.textClassName\" [text]=\"panel.sectionName\"></itb-text>\n            </mat-expansion-panel-header>\n            <itb-rsb-item-list [rsbListItems]=\"panel.rsbListItems\" (onClickHandler)=\"onClick($event)\"></itb-rsb-item-list>\n        </mat-expansion-panel>\n    </mat-accordion>\n\n\n<div class=\"{{className}}\" (click)=\"expFooterClickHandler()\">\n    <itb-icon [className]=\"iconClassName\"></itb-icon>\n    <itb-text [className]=\"textClassName\" [text]=\"text\"></itb-text>\n    <itb-button-group [buttons]=\"buttons\" [className]=\"buttonGroupClassName\"></itb-button-group>\n</div>\n\n</ng-container>"
                }] }
    ];
    /** @nocollapse */
    ExpansionPanelComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    ExpansionPanelComponent.propDecorators = {
        expansionPanels: [{ type: Input }],
        isExpanded: [{ type: Input }],
        buttons: [{ type: Input }],
        buttonGroupClassName: [{ type: Input }],
        iconClassName: [{ type: Input }],
        textClassName: [{ type: Input }],
        text: [{ type: Input }],
        rsbExpansionPanel: [{ type: Input }],
        textClickHandler: [{ type: Output }],
        clickHandler: [{ type: Output }],
        footerClickHandler: [{ type: Output }],
        headerClickHandler: [{ type: Output }]
    };
    return ExpansionPanelComponent;
}());
if (false) {
    /** @type {?} */
    ExpansionPanelComponent.prototype.className;
    /** @type {?} */
    ExpansionPanelComponent.prototype.expansionPanels;
    /** @type {?} */
    ExpansionPanelComponent.prototype.isExpanded;
    /** @type {?} */
    ExpansionPanelComponent.prototype.buttons;
    /** @type {?} */
    ExpansionPanelComponent.prototype.buttonGroupClassName;
    /** @type {?} */
    ExpansionPanelComponent.prototype.iconClassName;
    /** @type {?} */
    ExpansionPanelComponent.prototype.textClassName;
    /** @type {?} */
    ExpansionPanelComponent.prototype.text;
    /** @type {?} */
    ExpansionPanelComponent.prototype.rsbExpansionPanel;
    /** @type {?} */
    ExpansionPanelComponent.prototype.textClickHandler;
    /** @type {?} */
    ExpansionPanelComponent.prototype.clickHandler;
    /** @type {?} */
    ExpansionPanelComponent.prototype.footerClickHandler;
    /** @type {?} */
    ExpansionPanelComponent.prototype.headerClickHandler;
    /** @type {?} */
    ExpansionPanelComponent.prototype.expander;
    /**
     * @type {?}
     * @private
     */
    ExpansionPanelComponent.prototype.ref;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/expansion-panel/expansion-panel.component.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ExpansionPanelModule = /** @class */ (function () {
    function ExpansionPanelModule() {
    }
    ExpansionPanelModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ExpansionPanelComponent],
                    imports: [CommonModule, IconModule, ExpansionListItemModule, TextModule, MatExpansionModule, RsbItemListModule, ButtonGroupModule],
                    exports: [ExpansionPanelComponent],
                },] }
    ];
    return ExpansionPanelModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/left-sidebar/left-sidebar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LeftSidebarComponent = /** @class */ (function () {
    function LeftSidebarComponent() {
        this.buttonEvent = new EventEmitter();
        this.clickHandler = new EventEmitter();
        this.buttonClickHandler = new EventEmitter();
        this.textClickHandler = new EventEmitter();
        this.headerClickHandler = new EventEmitter();
        this.lsbToggleHandler = new EventEmitter();
        this.defaultAnchorClass = stringConstants.DEFAULT_ANCHORTAG_CLASSNAME;
        this.isExpanded = false;
        this.isOpened = true;
    }
    /**
     * @return {?}
     */
    LeftSidebarComponent.prototype.onClickToggle = /**
     * @return {?}
     */
    function () {
        return this.isExpanded ? !this.isExpanded : this.isExpanded;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LeftSidebarComponent.prototype.onClickHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.buttonEvent.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LeftSidebarComponent.prototype.onClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.clickHandler.emit(event);
    };
    /**
     * @return {?}
     */
    LeftSidebarComponent.prototype.buttonClick = /**
     * @return {?}
     */
    function () {
        this.buttonClickHandler.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LeftSidebarComponent.prototype.onTextClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.textClickHandler.emit(event);
    };
    /**
     * @return {?}
     */
    LeftSidebarComponent.prototype.toggleLSB = /**
     * @return {?}
     */
    function () {
        this.isOpened = !this.isOpened;
        this.lsbToggleHandler.emit(this.isOpened);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LeftSidebarComponent.prototype.onHeaderClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.headerClickHandler.emit(event);
    };
    LeftSidebarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-left-sidebar',
                    template: "<mat-drawer-container ngClass=\"{{matDrawerContainerClass}}\" autosize class=\"left-side-bar-cont\">\n    <mat-drawer #drawer ngClass=\"{{matDrawerClass}}\" mode=\"{{matDrawerMode}}\" [opened]=\"isOpened\">\n            <div class=\"left-side-bar-header\" *ngIf=\"!isAdminDashboard\">\n                <div class=\"company-name\">\n                    <span class=\"dash-c\">Dashboard</span>\n                    <span class=\"collasp\" title=\"Toggle sidebar\" (click)=\"toggleLSB()\">\n                            <!-- <itb-text [className]=\"'text-small'\" [text]=\"'Collapse sidebar'\"></itb-text> -->\n                            <itb-icon *ngIf=\"isOpened\" [tooltipText]=\"''\" [className]=\"'angle-left'\" ></itb-icon>\n                            <itb-icon *ngIf=\"isOpened\" [tooltipText]=\"''\" [className]=\"'angle-left'\" ></itb-icon>\n                            <itb-icon *ngIf=\"!isOpened\" [tooltipText]=\"''\" [className]=\"'angle-right'\" ></itb-icon>\n                            <itb-icon *ngIf=\"!isOpened\" [tooltipText]=\"''\" [className]=\"'angle-right'\" ></itb-icon>\n                    </span>\n                    \n                </div>\n                <!-- <itb-icon [className]=\"matDrawerIconClassName\" [tooltipText]=\"matDrawerIconTooltipText\"></itb-icon> -->\n                <div class=\"company-detail\">\n                    <span class=\"lsb-btn\"><a routerLink=\"{{headerLink}}\"><itb-icon [className]=\"headerClassName\" [tooltipText]=\"matDrawerIconTooltipText\"></itb-icon></a></span>\n                    <a class=\"{{defaultAnchorClass}}\" routerLink=\"{{headerLink}}\"><itb-text [className]=\"matDrawerTexClassName\" [text]=\"matDrawerTextValue\"></itb-text></a>\n                    \n                </div>\n                \n            </div>\n            <div *ngIf=\"expansionPanels.length === 0\" class=\"left-sidebar-spinner\">\n                <itb-spinner [spinnerType]=\"'m'\"></itb-spinner>\n            </div>\n            <span class=\"collasp\" title=\"Toggle sidebar\" (click)=\"toggleLSB()\" *ngIf=\"isAdminDashboard\" >\n                <!-- <itb-text [className]=\"'text-small'\" [text]=\"'Collapse sidebar'\"></itb-text> -->\n                <itb-icon *ngIf=\"isOpened\" [tooltipText]=\"''\" [className]=\"'angle-left'\" ></itb-icon>\n                <itb-icon *ngIf=\"isOpened\" [tooltipText]=\"''\" [className]=\"'angle-left'\" ></itb-icon>\n                <itb-icon *ngIf=\"!isOpened\" [tooltipText]=\"''\" [className]=\"'angle-right'\" ></itb-icon>\n                <itb-icon *ngIf=\"!isOpened\" [tooltipText]=\"''\" [className]=\"'angle-right'\" ></itb-icon>\n        </span>\n        <itb-expansion-panel *ngIf=\"expansionPanels.length > 0\" (clickHandler)=\"onClick($event)\" (textClickHandler)=\"onTextClick($event)\" (headerClickHandler)=\"onHeaderClick($event)\" [expansionPanels]=\"expansionPanels\"\n            [isExpanded]=\"isExpanded\"></itb-expansion-panel>\n            <a class=\"left-side-bar-button\" *ngIf=\"routerLink && !isAdminDashboard\" routerLink=\"{{buttonLink}}\"><itb-icon [tooltipText]=\"'Customize Sidebar'\" [className]=\"'setting'\" ></itb-icon><span>Customize Sidebar</span></a>\n            <a class=\"left-side-bar-button\" *ngIf=\"!routerLink && !isAdminDashboard\" (click)=\"buttonClick()\"><itb-icon [tooltipText]=\"'Customize Sidebar'\" [className]=\"'setting'\" ></itb-icon><span>Customize Sidebar</span></a>\n    </mat-drawer>\n    <!-- <div class=\"left-side-bar-menu-btn\" (click)=\"drawer.toggle()\">\n        <itb-icon [className]=\"'icon_menu'\"></itb-icon>\n    </div> -->\n</mat-drawer-container>"
                }] }
    ];
    /** @nocollapse */
    LeftSidebarComponent.ctorParameters = function () { return []; };
    LeftSidebarComponent.propDecorators = {
        isExpanded: [{ type: Input }],
        expansionPanels: [{ type: Input }],
        iconClassName: [{ type: Input }],
        iconTooltipText: [{ type: Input }],
        matDrawerContainerClass: [{ type: Input }],
        matDrawerClass: [{ type: Input }],
        matDrawerIconClassName: [{ type: Input }],
        matDrawerIconTooltipText: [{ type: Input }],
        matDrawerTexClassName: [{ type: Input }],
        matDrawerTextValue: [{ type: Input }],
        matDrawerMode: [{ type: Input }],
        toggleIconClassName: [{ type: Input }],
        headerClassName: [{ type: Input }],
        isOpened: [{ type: Input }],
        buttonLink: [{ type: Input }],
        headerLink: [{ type: Input }],
        routerLink: [{ type: Input }],
        isAdminDashboard: [{ type: Input }],
        buttonEvent: [{ type: Output }],
        clickHandler: [{ type: Output }],
        buttonClickHandler: [{ type: Output }],
        textClickHandler: [{ type: Output }],
        headerClickHandler: [{ type: Output }],
        lsbToggleHandler: [{ type: Output }]
    };
    return LeftSidebarComponent;
}());
if (false) {
    /** @type {?} */
    LeftSidebarComponent.prototype.isExpanded;
    /** @type {?} */
    LeftSidebarComponent.prototype.expansionPanels;
    /** @type {?} */
    LeftSidebarComponent.prototype.iconClassName;
    /** @type {?} */
    LeftSidebarComponent.prototype.iconTooltipText;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerContainerClass;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerClass;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerIconClassName;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerIconTooltipText;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerTexClassName;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerTextValue;
    /** @type {?} */
    LeftSidebarComponent.prototype.matDrawerMode;
    /** @type {?} */
    LeftSidebarComponent.prototype.toggleIconClassName;
    /** @type {?} */
    LeftSidebarComponent.prototype.headerClassName;
    /** @type {?} */
    LeftSidebarComponent.prototype.isOpened;
    /** @type {?} */
    LeftSidebarComponent.prototype.buttonLink;
    /** @type {?} */
    LeftSidebarComponent.prototype.headerLink;
    /** @type {?} */
    LeftSidebarComponent.prototype.routerLink;
    /** @type {?} */
    LeftSidebarComponent.prototype.isAdminDashboard;
    /** @type {?} */
    LeftSidebarComponent.prototype.buttonEvent;
    /** @type {?} */
    LeftSidebarComponent.prototype.clickHandler;
    /** @type {?} */
    LeftSidebarComponent.prototype.buttonClickHandler;
    /** @type {?} */
    LeftSidebarComponent.prototype.textClickHandler;
    /** @type {?} */
    LeftSidebarComponent.prototype.headerClickHandler;
    /** @type {?} */
    LeftSidebarComponent.prototype.lsbToggleHandler;
    /** @type {?} */
    LeftSidebarComponent.prototype.defaultAnchorClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/left-sidebar/left-sidebar.component.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LeftSideBarModule = /** @class */ (function () {
    function LeftSideBarModule() {
    }
    LeftSideBarModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LeftSidebarComponent],
                    imports: [CommonModule, IconModule, RouterModule, TextModule, ExpansionPanelModule,
                        MatChipsModule$1, MatSidenavModule, RoundButtonModule, SpinnerModule],
                    exports: [LeftSidebarComponent],
                },] }
    ];
    return LeftSideBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/left-sidebar/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/tabs/tabs.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TabsComponent = /** @class */ (function () {
    function TabsComponent() {
        this.className = 'itb-tabs';
        this.onClickHandler = new EventEmitter();
        this.selectedIndex = 0;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    TabsComponent.prototype.clickEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onClickHandler.emit(value);
    };
    TabsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-tabs',
                    template: "<div [class]=\"className\">\n  <mat-tab-group\n    [selectedIndex]=\"selectedIndex\"\n    (selectedTabChange)=\"clickEvent($event)\"\n  >\n    <ng-container *ngFor=\"let tab of tabs\">\n      <mat-tab [disabled]=\"tab.isDisabled\" label=\"{{ tab.label }}\"> </mat-tab>\n    </ng-container>\n  </mat-tab-group>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    TabsComponent.ctorParameters = function () { return []; };
    TabsComponent.propDecorators = {
        tabs: [{ type: Input }],
        className: [{ type: Input }],
        selectedIndex: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return TabsComponent;
}());
if (false) {
    /** @type {?} */
    TabsComponent.prototype.tabs;
    /** @type {?} */
    TabsComponent.prototype.className;
    /** @type {?} */
    TabsComponent.prototype.selectedIndex;
    /** @type {?} */
    TabsComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/tabs/tabs.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TabsModule = /** @class */ (function () {
    function TabsModule() {
    }
    TabsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatTabsModule],
                    declarations: [TabsComponent],
                    exports: [TabsComponent],
                },] }
    ];
    return TabsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/tabs/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/expansion-panel/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/expansion-panel-list-item/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dropdown-list/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-item-list/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/list-item/list-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListItemComponent = /** @class */ (function () {
    function ListItemComponent() {
        this.onActionButtonClickhandler = new EventEmitter();
        this.onInfoButtonClickHandler = new EventEmitter();
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @param {?} item
     * @return {?}
     */
    ListItemComponent.prototype.defaultButtonClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onActionButtonClickhandler.emit({
            text: item.actionButtonText,
            id: item.id,
        });
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListItemComponent.prototype.roundButtonClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onInfoButtonClickHandler.emit({
            id: item.id,
        });
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListItemComponent.prototype.onClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onClickHandler.emit({
            text: item.text,
            id: item.id,
        });
    };
    ListItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-list-item',
                    template: "<div *ngIf=\"!item.isActivity\" (click)=\"onClick(item)\" class=\"itb-list-items\" [ngClass]=\"{'with-button':item.actionButtonClassName, 'simple-list':item.isSimple}\" >\n  <div class=\"left\">\n      <itb-icon *ngIf=\"item.iconClassName\" [className]=\"item.iconClassName\"></itb-icon>\n      <itb-text *ngIf=\"!isLinkItem\" [className]=\"item.textClassName\" [text]=\"item.text\"></itb-text>\n      <a *ngIf=\"isLinkItem\" routerLink=\"{{item.link}}\"><itb-text [className]=\"item.textClassName\" [text]=\"item.text\"></itb-text></a>\n  </div>\n  <div class=\"right\">    \n      <div class=\"let-go\" *ngIf=\"item.actionButtonClassName\" (onClickHandler)=\"defaultButtonClick(item)\" >Let's Go!</div>\n      <itb-round-button *ngIf=\"item.roundButtonClassName\" (onClickHandler)=\"roundButtonClick(item)\" [className]=\"item.roundButtonClassName\" [iconClassName]=\"item.roundButtonIconClassName\"></itb-round-button>\n  </div>\n  <itb-text *ngIf=\"item.tagText\" class=\"tagText\" [className]=\"'text-small'\" [text]=\"item.tagText\"></itb-text>\n</div>\n\n<li class=\"itb-activity-list\" *ngIf=\"item.isActivity\">\n  <span class=\"activity-icon\">\n    <itb-icon *ngIf=\"item.iconClassName\" [className]=\"item.iconClassName\"></itb-icon>\n  </span>\n  <span class=\"activity-text\">\n    <span class=\"asset-name\"><b>SSLLabs</b></span>\n    <b class=\"\">google.com</b>\n    <span class=\"act-up\"><i>updated </i></span><span> by </span>\n    <span class=\"act-user\">Rukhsar Irshad</span><br>\n    <span class=\"act-date\">Nov 16, 2019 5:00:09 AM</span> - \n    <span class=\"act-text\"><b class=\"ng-binding\">1quicka2322323</b></span>\n  </span>\n</li>"
                }] }
    ];
    ListItemComponent.propDecorators = {
        item: [{ type: Input }],
        isLinkItem: [{ type: Input }],
        onActionButtonClickhandler: [{ type: Output }],
        onInfoButtonClickHandler: [{ type: Output }],
        onClickHandler: [{ type: Output }]
    };
    return ListItemComponent;
}());
if (false) {
    /** @type {?} */
    ListItemComponent.prototype.item;
    /** @type {?} */
    ListItemComponent.prototype.isLinkItem;
    /** @type {?} */
    ListItemComponent.prototype.onActionButtonClickhandler;
    /** @type {?} */
    ListItemComponent.prototype.onInfoButtonClickHandler;
    /** @type {?} */
    ListItemComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/list-item/list-item.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListItemModule = /** @class */ (function () {
    function ListItemModule() {
    }
    ListItemModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ListItemComponent],
                    imports: [CommonModule, IconModule, TextModule, DefaultButtonModule, RoundButtonModule, RouterModule],
                    exports: [ListItemComponent],
                },] }
    ];
    return ListItemModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/list-item/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/submenu-button/submenu-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SubmenuButtonComponent = /** @class */ (function () {
    function SubmenuButtonComponent() {
        var _this = this;
        this.onLinkEmitter = new EventEmitter();
        this.onClickHandler = new EventEmitter();
        this.onCrossHandler = new EventEmitter();
        this.onEditHandler = new EventEmitter();
        this.clickEvent = (/**
         * @return {?}
         */
        function () {
            _this.onClickHandler.emit();
            _this.onLinkEmitter.emit(_this.link);
        });
        this.closeEvent = (/**
         * @return {?}
         */
        function () {
            _this.onCrossHandler.emit();
        });
        this.editEvent = (/**
         * @return {?}
         */
        function () {
            _this.onEditHandler.emit();
        });
        this.className = 'submenu-button';
        this.hasCloseButton = false;
        this.hasEditButton = false;
        this.isActive = false;
        this.isLink = false;
    }
    /**
     * @return {?}
     */
    SubmenuButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.isActive) {
            this.onLinkEmitter.emit(this.link);
        }
    };
    SubmenuButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-submenu-button',
                    template: "<li class=\"{{className}}\" [ngClass]=\"{'active':isActive}\" (click)=\"clickEvent()\" *ngIf=\"!isLink\">\n  <span  class=\"bt-icon\"><itb-icon [tooltipText]=\"''\" [className]=\"iconClassName\"></itb-icon></span>\n  <span class=\"bt-txt\"><itb-text [className]=\"'text-small'\" [text]=\"text\"></itb-text></span>\n  <span *ngIf=\"hasEditButton\" class=\"bt-edit\"><itb-icon [tooltipText]=\"\" [className]=\"'edit icon-disabled'\" (click)=\"editEvent()\"></itb-icon></span>\n  <span *ngIf=\"hasCloseButton\" class=\"bt-cross\"><itb-icon [tooltipText]=\"'Close'\" [className]=\"'cross icon-disabled'\" (click)=\"closeEvent()\"></itb-icon></span>\n</li>\n\n\n<a *ngIf=\"isLink\" [routerLink]=\"link\">\n<li class=\"{{className}}\" [ngClass]=\"{'active':isActive}\"  routerLinkActive=\"active\"  (click)=\"clickEvent()\">\n    <span  class=\"bt-icon\"><itb-icon [tooltipText]=\"''\" [className]=\"iconClassName\"></itb-icon></span>\n    <span class=\"bt-txt\"><itb-text [className]=\"'text-small'\" [text]=\"text\"></itb-text></span>\n    <span *ngIf=\"hasEditButton\" class=\"bt-edit\"><itb-icon [tooltipText]=\"\" [className]=\"'edit icon-disabled'\" (click)=\"editEvent()\"></itb-icon></span>\n    <span *ngIf=\"hasCloseButton\" class=\"bt-cross\"><itb-icon [tooltipText]=\"'Close'\" [className]=\"'cross icon-disabled'\" (click)=\"closeEvent()\"></itb-icon></span>\n</li>\n</a>\n"
                }] }
    ];
    /** @nocollapse */
    SubmenuButtonComponent.ctorParameters = function () { return []; };
    SubmenuButtonComponent.propDecorators = {
        iconClassName: [{ type: Input }],
        className: [{ type: Input }],
        text: [{ type: Input }],
        hasCloseButton: [{ type: Input }],
        hasEditButton: [{ type: Input }],
        isActive: [{ type: Input }],
        isLink: [{ type: Input }],
        link: [{ type: Input }],
        onLinkEmitter: [{ type: Output }],
        onClickHandler: [{ type: Output }],
        onCrossHandler: [{ type: Output }],
        onEditHandler: [{ type: Output }]
    };
    return SubmenuButtonComponent;
}());
if (false) {
    /** @type {?} */
    SubmenuButtonComponent.prototype.iconClassName;
    /** @type {?} */
    SubmenuButtonComponent.prototype.className;
    /** @type {?} */
    SubmenuButtonComponent.prototype.text;
    /** @type {?} */
    SubmenuButtonComponent.prototype.hasCloseButton;
    /** @type {?} */
    SubmenuButtonComponent.prototype.hasEditButton;
    /** @type {?} */
    SubmenuButtonComponent.prototype.isActive;
    /** @type {?} */
    SubmenuButtonComponent.prototype.isLink;
    /** @type {?} */
    SubmenuButtonComponent.prototype.link;
    /** @type {?} */
    SubmenuButtonComponent.prototype.onLinkEmitter;
    /** @type {?} */
    SubmenuButtonComponent.prototype.onClickHandler;
    /** @type {?} */
    SubmenuButtonComponent.prototype.onCrossHandler;
    /** @type {?} */
    SubmenuButtonComponent.prototype.onEditHandler;
    /** @type {?} */
    SubmenuButtonComponent.prototype.clickEvent;
    /** @type {?} */
    SubmenuButtonComponent.prototype.closeEvent;
    /** @type {?} */
    SubmenuButtonComponent.prototype.editEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/submenu-button/submenu-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SubmenuButtonModule = /** @class */ (function () {
    function SubmenuButtonModule() {
    }
    SubmenuButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, IconModule, TextModule, RouterModule],
                    declarations: [SubmenuButtonComponent],
                    exports: [SubmenuButtonComponent],
                },] }
    ];
    return SubmenuButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/menu-button/menu-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuButtonComponent = /** @class */ (function () {
    function MenuButtonComponent() {
        this.onClickHandler = new EventEmitter();
        this.onSubmenuClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MenuButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = this.className || stringConstants.DEFAULT_MENU_BUTTON_CLASSNAME;
    };
    /**
     * @param {?} button
     * @return {?}
     */
    MenuButtonComponent.prototype.onClick = /**
     * @param {?} button
     * @return {?}
     */
    function (button) {
        this.onClickHandler.emit({
            text: button.text,
            id: button.id,
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MenuButtonComponent.prototype.onSubmenuClickEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onSubmenuClick.emit(event);
    };
    /**
     * @return {?}
     */
    MenuButtonComponent.prototype.toggelSubMenu = /**
     * @return {?}
     */
    function () {
        this.isSubMenuOpen = !this.isSubMenuOpen;
    };
    MenuButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-menu-button',
                    template: "<li class=\"itb-menu-button\" [ngClass]=\"{'cursor-notallowed': menuButton.isDisabled}\" routerLinkActive=\"active\">\n    <a *ngIf=\"isLink\" class=\"menu-button {{className}}\" routerLink=\"{{link}}\" routerLinkActive=\"active\" [ngClass]=\"{'disabled-menu': menuButton.isDisabled}\" (click)=\"onClick(menuButton)\">\n        <itb-icon [className]=\"menuButton.iconClassName\"></itb-icon>\n        <itb-text [className]=\"menuButton.textClassName\" [text]=\"menuButton.name\"></itb-text>\n      </a>\n\n  <a *ngIf=\"!isLink\" class=\"menu-button {{className}}\" [ngClass]=\"{'disabled-menu': menuButton.isDisabled}\" (click)=\"onClick(menuButton)\">\n    <itb-icon [className]=\"menuButton.iconClassName\"></itb-icon>\n    <itb-text [className]=\"menuButton.textClassName\" [text]=\"menuButton.name\"></itb-text>\n  </a>\n  <itb-icon *ngIf=\"subMenu\" class=\"sub-menu-arrow\" [className]=\"'angle-down'\" (click)=\"toggelSubMenu()\"></itb-icon>\n  <ul *ngIf=\"subMenu\" class=\"sm-sub-menu\" [ngClass]=\"{'open': isSubMenuOpen}\">\n    <a *ngFor=\"let menu of subMenu\" routerLink=\"{{menu.linkPath}}\" routerLinkActive=\"active\"><itb-submenu-button [className]=\"'itb-submenu-btn'\" [iconClassName] =\"menu.submenuIconClassName\" [text]=\"menu.submenuText\" [hasCloseButton]=false (onClickHandler)=\"onSubmenuClickEvent($event)\"></itb-submenu-button></a>\n  </ul>\n</li>\n"
                }] }
    ];
    MenuButtonComponent.propDecorators = {
        className: [{ type: Input }],
        menuButton: [{ type: Input }],
        subMenu: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onSubmenuClick: [{ type: Output }],
        isLink: [{ type: Input }],
        link: [{ type: Input }]
    };
    return MenuButtonComponent;
}());
if (false) {
    /** @type {?} */
    MenuButtonComponent.prototype.className;
    /** @type {?} */
    MenuButtonComponent.prototype.menuButton;
    /** @type {?} */
    MenuButtonComponent.prototype.subMenu;
    /** @type {?} */
    MenuButtonComponent.prototype.onClickHandler;
    /** @type {?} */
    MenuButtonComponent.prototype.onSubmenuClick;
    /** @type {?} */
    MenuButtonComponent.prototype.isLink;
    /** @type {?} */
    MenuButtonComponent.prototype.link;
    /** @type {?} */
    MenuButtonComponent.prototype.isSubMenuOpen;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/menu-button/menu-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuButtonModule = /** @class */ (function () {
    function MenuButtonModule() {
    }
    MenuButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MenuButtonComponent],
                    imports: [CommonModule, IconModule, TextModule, SubmenuButtonModule, RouterModule],
                    exports: [MenuButtonComponent],
                },] }
    ];
    return MenuButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/menu-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/popover/popover.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PopoverComponent = /** @class */ (function () {
    function PopoverComponent() {
        this.isPopover = false;
    }
    /**
     * @return {?}
     */
    PopoverComponent.prototype.onMouseEnter = /**
     * @return {?}
     */
    function () {
        this.isPopover = true;
    };
    /**
     * @return {?}
     */
    PopoverComponent.prototype.onMouseLeave = /**
     * @return {?}
     */
    function () {
        this.isPopover = false;
    };
    PopoverComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-popover',
                    template: "<div  (mouseenter)=\"onMouseEnter()\" (mouseout)=\"onMouseLeave()\">\n  <ng-content select=\"[popoverObject]\" ></ng-content>\n</div>\n<div *ngIf=\"isPopover===true\">\n  <ng-content select=\"[popoverBody]\"></ng-content>\n</div>\n  \n\n\n  "
                }] }
    ];
    /** @nocollapse */
    PopoverComponent.ctorParameters = function () { return []; };
    PopoverComponent.propDecorators = {
        className: [{ type: Input }]
    };
    return PopoverComponent;
}());
if (false) {
    /** @type {?} */
    PopoverComponent.prototype.className;
    /** @type {?} */
    PopoverComponent.prototype.isPopover;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/popover/popover.component.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PopOverModule = /** @class */ (function () {
    function PopOverModule() {
    }
    PopOverModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatCardModule$1],
                    declarations: [PopoverComponent],
                    exports: [PopoverComponent],
                },] }
    ];
    return PopOverModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/popover/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/survey-option/survey-option.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SurveyOptionComponent = /** @class */ (function () {
    function SurveyOptionComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.onChangeHandler = new EventEmitter();
        this.onDeleteHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SurveyOptionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} value
     * @return {?}
     */
    SurveyOptionComponent.prototype.onSubmit = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onChangeHandler.emit(value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SurveyOptionComponent.prototype.onDelete = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onDeleteHandler.emit(event);
    };
    SurveyOptionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-survey-option',
                    template: "<div class=\"survey-option\">\n  <div class=\"pointer\">\n    <mat-radio-button [disabled]=\"surveyOptions.disabled\"></mat-radio-button>\n  </div>\n  <div [formGroup]=\"parentForm\" class=\"input-filed\">\n    <itb-input\n      [formFieldName]=\"formFieldName\"\n      [parentForm]=\"parentForm\"\n      [label]=\"surveyOptions.label\"\n      (onChangeHandler)=\"onSubmit(parentForm.value)\"\n      [placeholder]=\"surveyOptions.placeholder\"\n      [type]=\"surveyOptions.type\"\n      [maxlength]=\"30\"\n    ></itb-input>\n  </div>\n  <div class=\"btn-cont\">\n    <itb-icon\n      [hidden]=\"isDisabled\"\n      [tooltipText]=\"surveyOptions.tooltipText\"\n      [className]=\"surveyOptions.iconClassName\"\n      (onClickHandler)=\"onDelete($event)\"\n    ></itb-icon>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SurveyOptionComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    SurveyOptionComponent.propDecorators = {
        onChangeHandler: [{ type: Output }],
        onDeleteHandler: [{ type: Output }],
        surveyOptions: [{ type: Input }],
        formFieldName: [{ type: Input }],
        parentForm: [{ type: Input }],
        isDisabled: [{ type: Input }]
    };
    return SurveyOptionComponent;
}());
if (false) {
    /** @type {?} */
    SurveyOptionComponent.prototype.onChangeHandler;
    /** @type {?} */
    SurveyOptionComponent.prototype.onDeleteHandler;
    /** @type {?} */
    SurveyOptionComponent.prototype.surveyOptions;
    /** @type {?} */
    SurveyOptionComponent.prototype.formFieldName;
    /** @type {?} */
    SurveyOptionComponent.prototype.parentForm;
    /** @type {?} */
    SurveyOptionComponent.prototype.isDisabled;
    /** @type {?} */
    SurveyOptionComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/input/input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputComponent = /** @class */ (function () {
    function InputComponent() {
        var _this = this;
        this.onChangeHandler = new EventEmitter();
        this.onBlurHandler = new EventEmitter();
        this.onFocusHandler = new EventEmitter();
        this.onIconClickHandler = new EventEmitter();
        this.onFocusOutHandler = new EventEmitter();
        this.secondaryIconHandler = new EventEmitter();
        this.changeEvent = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.onChangeHandler.emit(event);
        });
        this.focusOutEvent = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.onFocusOutHandler.emit(event);
        });
        this.blurEvent = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.onBlurHandler.emit(event);
        });
        this.focusEvent = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.onFocusHandler.emit(event);
        });
        this.iconClickEvent = (/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            _this.onIconClickHandler.emit(item);
        });
        this.secondaryIconEvent = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.secondaryIconHandler.emit(event);
        });
        this.isReactive = true;
        this.isReadOnly = false;
        this.value = '';
        this.isMaskEnabled = false;
        this.isMaskShown = false;
    }
    /**
     * @return {?}
     */
    InputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.pattern && this.type !== 'password')
            this.pattern = '^[^`|;<>"\'$\/^*~{}!\\[\\]+]*$';
        this.appearance = this.appearance !== stringConstants.DEFAULT_INPUT_APPEARENCE_OUTLINE ?
            stringConstants.DEFAULT_INPUT_APPEARENCE_LEGACY : stringConstants.DEFAULT_INPUT_APPEARENCE_OUTLINE;
        this.type = this.type || stringConstants.DEFAULT_INPUT_TYPE;
        // this.isAutofocus = this.isAutofocus ? false : this.isAutofocus
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    InputComponent.prototype.restrictEvent = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.type === 'number') {
            if (event.keyCode === 69 || event.keyCode === 101 || event.keyCode === 46 || event.keyCode === 45 || event.keyCode === 43)
                event.preventDefault();
            if (event.target.value.length >= this.maxlength) {
                if (window.getSelection().type === 'Range') {
                    if (window.getSelection().toString().length >= this.maxlength) {
                        this.inputfield.nativeElement.value = '';
                    }
                }
                else {
                    event.preventDefault();
                }
            }
        }
    };
    InputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-input',
                    template: "<div *ngIf=\"isReactive && !isMaskEnabled\" class=\"itb-input\" [ngClass]=\"{'has-icons':icons}\" [formGroup]=\"parentForm\">\n    <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\" [appearance]=\"appearance\">\n        <mat-label>{{label}}<span class=\"label-required\">*</span></mat-label>\n        <input #inputfield [id]=\"id\" [ngClass]=\"className\" matInput [type]=\"type\" [readonly]=\"isReadOnly\" [autocomplete]=\"isAutocomplete\" [pattern]=\"pattern\"\n            [name]=\"name\" [placeholder]=\"placeholder\" [formControlName]=\"formFieldName\" [autofocus]=\"isAutofocus\"\n            (blur)=\"blurEvent($event)\" (focus)=\"focusEvent($event)\" (focusout)=\"focusOutEvent($event)\"\n            (keyup)=\"changeEvent($event)\" (keypress)=\"restrictEvent($event)\" [required]=\"isRequired\" maxlength=\"{{maxlength}}\" minlength=\"{{minlength}}\" min={{minValue}} max={{maxValue}}>\n        </mat-form-field>\n            <span *ngIf=\"icons\" class=\"input-icon\">\n                <itb-icon #inner *ngFor=\"let icon of icons\" [tooltipText]=\"icon.tooltipText\" [className]=\"icon.className\"\n                    (onClickHandler)=\"iconClickEvent(icon.className)\" (click)=\"secondaryIconEvent(inner)\"></itb-icon>\n            </span>\n</div>\n\n<div *ngIf=\"isReactive && isMaskEnabled\" class=\"itb-input\" [ngClass]=\"{'has-icons':icons}\" [formGroup]=\"parentForm\">\n    <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\" [appearance]=\"appearance\">\n        <mat-label>{{label}}<span class=\"label-required\">*</span></mat-label>\n        <input #inputfield [id]=\"id\" [ngClass]=\"className\" matInput [type]=\"type\" [readonly]=\"isReadOnly\" [autocomplete]=\"isAutocomplete\" [pattern]=\"pattern\"\n            [name]=\"name\" [placeholder]=\"placeholder\" [formControlName]=\"formFieldName\" [autofocus]=\"isAutofocus\" [mask]=\"mask\" [specialCharacters]=\"specialCharacters\" [patterns]=\"inputPattern\" [showMaskTyped]=\"isMaskShown\"\n            (blur)=\"blurEvent($event)\" (focus)=\"focusEvent($event)\" (focusout)=\"focusOutEvent($event)\"\n            (keyup)=\"changeEvent($event)\" (keypress)=\"restrictEvent($event)\" [required]=\"isRequired\" maxlength=\"{{maxlength}}\" minlength=\"{{minlength}}\" min={{minValue}} max={{maxValue}}>\n        </mat-form-field>\n            <span *ngIf=\"icons\" class=\"input-icon\">\n                <itb-icon #inner *ngFor=\"let icon of icons\" [tooltipText]=\"icon.tooltipText\" [className]=\"icon.className\"\n                    (onClickHandler)=\"iconClickEvent(icon.className)\" (click)=\"secondaryIconEvent(inner)\"></itb-icon>\n            </span>\n</div>\n\n<div *ngIf=\"!isReactive && !isMaskEnabled\" class=\"itb-input\" [ngClass]=\"{'has-icons':icons}\" >\n    <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\" [appearance]=\"appearance\">\n        <mat-label>{{label}}<span class=\"label-required\">*</span></mat-label>\n        <input #inputfield [id]=\"id\" [ngClass]=\"className\" matInput [type]=\"type\" [disabled]=\"isDisabled\" [readonly]=\"isReadOnly\" [autocomplete]=\"isAutocomplete\" [pattern]=\"pattern\"\n            [name]=\"name\" [placeholder]=\"placeholder\" [value]=\"value\" [autofocus]=\"isAutofocus\" (blur)=\"blurEvent($event)\" (focus)=\"focusEvent($event)\" (focusout)=\"focusOutEvent($event)\" (keyup)=\"changeEvent($event)\" [required]=\"isRequired\" min={{minValue}} max={{maxValue}}>\n        </mat-form-field>\n            <span *ngIf=\"icons\" class=\"input-icon\">\n                <itb-icon *ngFor=\"let icon of icons\" [tooltipText]=\"icon.tooltipText\" [className]=\"icon.className\"\n                    (onClickHandler)=\"iconClickEvent(icon.className)\"></itb-icon>\n            </span>    \n</div>\n\n<div *ngIf=\"!isReactive && isMaskEnabled\" class=\"itb-input\" [ngClass]=\"{'has-icons':icons}\" >\n    <mat-form-field [ngClass]=\"isDisabled && isRequired ? 'field-required-disabled' : ''\" [appearance]=\"appearance\">\n        <mat-label>{{label}}<span class=\"label-required\">*</span></mat-label>\n        <input #inputfield [id]=\"id\" [ngClass]=\"className\" matInput [type]=\"type\" [disabled]=\"isDisabled\" [readonly]=\"isReadOnly\" [autocomplete]=\"isAutocomplete\" [pattern]=\"pattern\"\n            [name]=\"name\" [placeholder]=\"placeholder\" [value]=\"value\" [autofocus]=\"isAutofocus\" [mask]=\"mask\" [specialCharacters]=\"specialCharacters\" [patterns]=\"inputPattern\" [showMaskTyped]=\"isMaskShown\" (blur)=\"blurEvent($event)\" (focus)=\"focusEvent($event)\" (focusout)=\"focusOutEvent($event)\" (keyup)=\"changeEvent($event)\" [required]=\"isRequired\" min={{minValue}} max={{maxValue}}>\n        </mat-form-field>\n            <span *ngIf=\"icons\" class=\"input-icon\">\n                <itb-icon *ngFor=\"let icon of icons\" [tooltipText]=\"icon.tooltipText\" [className]=\"icon.className\"\n                    (onClickHandler)=\"iconClickEvent(icon.className)\"></itb-icon>\n            </span>    \n</div>"
                }] }
    ];
    /** @nocollapse */
    InputComponent.ctorParameters = function () { return []; };
    InputComponent.propDecorators = {
        isRequired: [{ type: Input }],
        appearance: [{ type: Input }],
        className: [{ type: Input }],
        label: [{ type: Input }],
        type: [{ type: Input }],
        icons: [{ type: Input }],
        name: [{ type: Input }],
        pattern: [{ type: Input }],
        isAutocomplete: [{ type: Input }],
        placeholder: [{ type: Input }],
        formFieldName: [{ type: Input }],
        isAutofocus: [{ type: Input }],
        parentForm: [{ type: Input }],
        isReactive: [{ type: Input }],
        value: [{ type: Input }],
        maxlength: [{ type: Input }],
        minlength: [{ type: Input }],
        minValue: [{ type: Input }],
        maxValue: [{ type: Input }],
        id: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        isMaskEnabled: [{ type: Input }],
        isMaskShown: [{ type: Input }],
        mask: [{ type: Input }],
        specialCharacters: [{ type: Input }],
        inputPattern: [{ type: Input }],
        onChangeHandler: [{ type: Output }],
        onBlurHandler: [{ type: Output }],
        onFocusHandler: [{ type: Output }],
        onIconClickHandler: [{ type: Output }],
        onFocusOutHandler: [{ type: Output }],
        secondaryIconHandler: [{ type: Output }],
        inputfield: [{ type: ViewChild, args: ['inputfield', { static: false },] }]
    };
    return InputComponent;
}());
if (false) {
    /** @type {?} */
    InputComponent.prototype.isRequired;
    /** @type {?} */
    InputComponent.prototype.appearance;
    /** @type {?} */
    InputComponent.prototype.className;
    /** @type {?} */
    InputComponent.prototype.label;
    /** @type {?} */
    InputComponent.prototype.type;
    /** @type {?} */
    InputComponent.prototype.icons;
    /** @type {?} */
    InputComponent.prototype.name;
    /** @type {?} */
    InputComponent.prototype.pattern;
    /** @type {?} */
    InputComponent.prototype.isAutocomplete;
    /** @type {?} */
    InputComponent.prototype.placeholder;
    /** @type {?} */
    InputComponent.prototype.formFieldName;
    /** @type {?} */
    InputComponent.prototype.isAutofocus;
    /** @type {?} */
    InputComponent.prototype.parentForm;
    /** @type {?} */
    InputComponent.prototype.isReactive;
    /** @type {?} */
    InputComponent.prototype.value;
    /** @type {?} */
    InputComponent.prototype.maxlength;
    /** @type {?} */
    InputComponent.prototype.minlength;
    /** @type {?} */
    InputComponent.prototype.minValue;
    /** @type {?} */
    InputComponent.prototype.maxValue;
    /** @type {?} */
    InputComponent.prototype.id;
    /** @type {?} */
    InputComponent.prototype.isDisabled;
    /** @type {?} */
    InputComponent.prototype.isReadOnly;
    /** @type {?} */
    InputComponent.prototype.isMaskEnabled;
    /** @type {?} */
    InputComponent.prototype.isMaskShown;
    /** @type {?} */
    InputComponent.prototype.mask;
    /** @type {?} */
    InputComponent.prototype.specialCharacters;
    /** @type {?} */
    InputComponent.prototype.inputPattern;
    /** @type {?} */
    InputComponent.prototype.onChangeHandler;
    /** @type {?} */
    InputComponent.prototype.onBlurHandler;
    /** @type {?} */
    InputComponent.prototype.onFocusHandler;
    /** @type {?} */
    InputComponent.prototype.onIconClickHandler;
    /** @type {?} */
    InputComponent.prototype.onFocusOutHandler;
    /** @type {?} */
    InputComponent.prototype.secondaryIconHandler;
    /** @type {?} */
    InputComponent.prototype.inputfield;
    /** @type {?} */
    InputComponent.prototype.changeEvent;
    /** @type {?} */
    InputComponent.prototype.focusOutEvent;
    /** @type {?} */
    InputComponent.prototype.blurEvent;
    /** @type {?} */
    InputComponent.prototype.focusEvent;
    /** @type {?} */
    InputComponent.prototype.iconClickEvent;
    /** @type {?} */
    InputComponent.prototype.secondaryIconEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/input/input.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputModule = /** @class */ (function () {
    function InputModule() {
    }
    InputModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule,
                        MatFormFieldModule$1,
                        FormsModule,
                        ReactiveFormsModule,
                        MatIconModule,
                        MatInputModule$1,
                        IconModule,
                        NgxMaskModule.forRoot()],
                    declarations: [InputComponent],
                    exports: [InputComponent, IconModule],
                },] }
    ];
    return InputModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/survey-option/survey-option.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SurveyOptionModule = /** @class */ (function () {
    function SurveyOptionModule() {
    }
    SurveyOptionModule.decorators = [
        { type: NgModule, args: [{
                    imports: [IconModule, CommonModule, MatRadioModule, InputModule, FormsModule, ReactiveFormsModule],
                    declarations: [SurveyOptionComponent],
                    exports: [SurveyOptionComponent],
                },] }
    ];
    return SurveyOptionModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/survey-option/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pagination/pagination.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent() {
        this.paginatorValueHandler = new EventEmitter();
        this.counter = [];
        this.isPrevDisabled = false;
        this.isNextDisabled = false;
        this.currentValue = 0;
        this.selectedValue = 0;
        this.initialValue = 0;
        this.pageSize = 10;
    }
    /**
     * @return {?}
     */
    PaginationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.currentValue--;
        this.count = this.records / this.pageSize;
        this.makeArray();
        this.initialValue = this.currentValue;
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (this.currentValue > 0) {
            this.currentElemClass = document.getElementById(String(this.initialValue));
            this.previousElemClass = this.currentElemClass;
            this.currentElemClass.classList.add('selected');
        }
        else if (this.currentValue <= 0) {
            this.currentElemClass = document.getElementById(String(0));
            this.previousElemClass = this.currentElemClass;
            this.currentElemClass.classList.add('selected');
        }
        if (this.count < 1) {
            this.isPrevDisabled = true;
            this.isNextDisabled = true;
        }
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.makeArray = /**
     * @return {?}
     */
    function () {
        for (var i = 0; i < this.count; i++) {
            this.counter.push(i);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    PaginationComponent.prototype.paginatorValueEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        switch (value) {
            case 'first':
                this.currentValue = this.counter[0];
                // tslint:disable-next-line: restrict-plus-operands
                if (this.previousElemClass) {
                    this.previousElemClass.classList.remove('selected');
                }
                this.currentElemClass = document.getElementById(String(this.currentValue));
                this.previousElemClass = this.currentElemClass;
                this.currentElemClass.classList.add('selected');
                // tslint:disable-next-line: restrict-plus-operands
                this.selectedValue = this.counter[0] + 1;
                this.paginatorValueHandler.emit(this.selectedValue);
                this.isNextDisabled = false;
                if (this.currentValue === 0) {
                    this.isPrevDisabled = true;
                    this.isNextDisabled = false;
                }
                break;
            case 'previous':
                // tslint:disable-next-line: restrict-plus-operands
                if (this.currentValue >= this.counter[0] + 1) {
                    this.currentValue--;
                    // tslint:disable-next-line: restrict-plus-operands
                    if (this.previousElemClass) {
                        this.previousElemClass.classList.remove('selected');
                    }
                    this.currentElemClass = document.getElementById(String(this.currentValue));
                    this.previousElemClass = this.currentElemClass;
                    this.currentElemClass.classList.add('selected');
                    // tslint:disable-next-line: restrict-plus-operands
                    this.selectedValue = this.counter[this.currentValue] + 1;
                    this.paginatorValueHandler.emit(this.selectedValue);
                    this.isNextDisabled = false;
                }
                if (this.currentValue === 0) {
                    this.isPrevDisabled = true;
                }
                break;
            case 'next':
                if (this.currentValue < this.counter.length - 1) {
                    this.currentValue++;
                    // tslint:disable-next-line: restrict-plus-operands
                    if (this.previousElemClass) {
                        this.previousElemClass.classList.remove('selected');
                    }
                    this.currentElemClass = document.getElementById(String(this.currentValue));
                    this.previousElemClass = this.currentElemClass;
                    this.currentElemClass.classList.add('selected');
                    // tslint:disable-next-line: restrict-plus-operands
                    this.selectedValue = this.counter[this.currentValue] + 1;
                    this.paginatorValueHandler.emit(this.selectedValue);
                    this.isPrevDisabled = false;
                }
                if (this.currentValue.toString() === this.count.toFixed()) {
                    this.isNextDisabled = true;
                }
                break;
            case 'last':
                this.currentValue = this.counter[this.counter.length - 1];
                // tslint:disable-next-line: restrict-plus-operands
                if (this.previousElemClass) {
                    this.previousElemClass.classList.remove('selected');
                }
                this.currentElemClass = document.getElementById(String(this.currentValue));
                this.previousElemClass = this.currentElemClass;
                this.currentElemClass.classList.add('selected');
                // tslint:disable-next-line: restrict-plus-operands
                this.selectedValue = this.counter[this.counter.length - 1] + 1;
                this.paginatorValueHandler.emit(this.selectedValue);
                this.isPrevDisabled = false;
                this.isNextDisabled = true;
                break;
            default:
                return;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    PaginationComponent.prototype.currentValueEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value.toString() === this.count.toFixed()) {
            this.isPrevDisabled = false;
            this.isNextDisabled = true;
        }
        else if (value === 0) {
            this.isNextDisabled = false;
            this.isPrevDisabled = true;
        }
        else {
            this.isPrevDisabled = false;
            this.isNextDisabled = false;
        }
        if (this.count < 1) {
            this.isNextDisabled = true;
        }
        if (this.previousElemClass) {
            this.previousElemClass.classList.remove('selected');
        }
        this.currentElemClass = document.getElementById(value);
        this.previousElemClass = this.currentElemClass;
        this.currentElemClass.classList.add('selected');
        this.currentValue = value;
        // tslint:disable-next-line: restrict-plus-operands
        this.paginatorValueHandler.emit(value + 1);
    };
    PaginationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-pagination',
                    template: "<div class=\"s-paginator\">\n  <button [disabled]=\"isPrevDisabled\" [ngStyle]=\"{'cursor': isPrevDisabled ? 'not-allowed' : ''}\" (click)=\"paginatorValueEvent('first')\">First</button>\n  <button [disabled]=\"isPrevDisabled\" [ngStyle]=\"{'cursor': isPrevDisabled ? 'not-allowed' : ''}\" (click)=\"paginatorValueEvent('previous')\">Previous</button>\n  <button class=\"num\" (click)=\"currentValueEvent(myIndex)\" *ngFor=\"let item of counter; let myIndex= index\" [id]=\"myIndex\">{{myIndex + 1}}</button>\n  <button [disabled]=\"isNextDisabled\" [ngStyle]=\"{'cursor': isNextDisabled ? 'not-allowed' : ''}\" (click)=\"paginatorValueEvent('next')\">Next</button>\n  <button [disabled]=\"isNextDisabled\" [ngStyle]=\"{'cursor': isNextDisabled ? 'not-allowed' : ''}\" (click)=\"paginatorValueEvent('last')\">Last</button>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    PaginationComponent.ctorParameters = function () { return []; };
    PaginationComponent.propDecorators = {
        records: [{ type: Input }],
        currentValue: [{ type: Input }],
        pageSize: [{ type: Input }],
        paginatorValueHandler: [{ type: Output }]
    };
    return PaginationComponent;
}());
if (false) {
    /** @type {?} */
    PaginationComponent.prototype.records;
    /** @type {?} */
    PaginationComponent.prototype.currentValue;
    /** @type {?} */
    PaginationComponent.prototype.pageSize;
    /** @type {?} */
    PaginationComponent.prototype.paginatorValueHandler;
    /** @type {?} */
    PaginationComponent.prototype.selectedValue;
    /** @type {?} */
    PaginationComponent.prototype.count;
    /** @type {?} */
    PaginationComponent.prototype.counter;
    /** @type {?} */
    PaginationComponent.prototype.initialValue;
    /** @type {?} */
    PaginationComponent.prototype.currentElemClass;
    /** @type {?} */
    PaginationComponent.prototype.previousElemClass;
    /** @type {?} */
    PaginationComponent.prototype.isPrevDisabled;
    /** @type {?} */
    PaginationComponent.prototype.isNextDisabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pagination/pagination.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationModule = /** @class */ (function () {
    function PaginationModule() {
    }
    PaginationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [PaginationComponent],
                    exports: [PaginationComponent],
                },] }
    ];
    return PaginationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pagination/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/survey-count/survey-count.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SurveyCountComponent = /** @class */ (function () {
    function SurveyCountComponent() {
        this.onDeleteHandler = new EventEmitter();
        this.onClickHandler = new EventEmitter();
        this.countArray = [
            { label: '1' },
            { label: '2' },
            { label: '3' },
            { label: '4' },
            { label: '5' },
            { label: '6' },
            { label: '7' },
            { label: '8' },
            { label: '9' },
            { label: '10' },
        ];
        this.isViewOnly = this.isViewOnly || stringConstants.DEFAULT_TRUE;
        this.className =
            this.className || stringConstants.DEFAULT_SURVEYCOUNT_CLASSNAME;
        this.tooltipText =
            this.tooltipText || stringConstants.DEFAULT_TOOLTIP_TEXT_DELETEICON;
    }
    /**
     * @return {?}
     */
    SurveyCountComponent.prototype.onDelete = /**
     * @return {?}
     */
    function () {
        this.onDeleteHandler.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SurveyCountComponent.prototype.clickEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onClickHandler.emit(event);
    };
    SurveyCountComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-survey-count',
                    template: "<style>\n  .disabled {\n    pointer-events: none;\n  }\n</style>\n\n<div class=\"{{ className }}\" [ngClass]=\"{ disabled: isViewOnly === true }\">\n  <div class=\"survey-number\">\n    <strong>{{ sequenceNumber }}</strong>\n  </div>\n  <div class=\"survey-details\">\n    <p>\n      <strong>{{ questionHead }}</strong> | {{ questionDescription }}\n    </p>\n    <ng-content *ngIf=\"!hasNumbers\"></ng-content>\n    <mat-button-toggle-group\n      *ngIf=\"hasNumbers\"\n      name=\"Survey Count\"\n      aria-label=\"Survey Count\"\n    >\n      <mat-button-toggle\n        *ngFor=\"let item of countArray\"\n        (click)=\"clickEvent(item.label)\"\n        >{{ item.label }}</mat-button-toggle\n      >\n    </mat-button-toggle-group>\n  </div>\n  <div class=\"survey-delete-btn\">\n    <itb-icon\n      *ngIf=\"!isViewOnly\"\n      [tooltipText]=\"tooltipText\"\n      [className]=\"'delete-r'\"\n      (onClickHandler)=\"onDelete()\"\n    ></itb-icon>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SurveyCountComponent.ctorParameters = function () { return []; };
    SurveyCountComponent.propDecorators = {
        isViewOnly: [{ type: Input }],
        tooltipText: [{ type: Input }],
        hasNumbers: [{ type: Input }],
        className: [{ type: Input }],
        onDeleteHandler: [{ type: Output }],
        onClickHandler: [{ type: Output }],
        sequenceNumber: [{ type: Input }],
        questionHead: [{ type: Input }],
        questionDescription: [{ type: Input }]
    };
    return SurveyCountComponent;
}());
if (false) {
    /** @type {?} */
    SurveyCountComponent.prototype.isViewOnly;
    /** @type {?} */
    SurveyCountComponent.prototype.tooltipText;
    /** @type {?} */
    SurveyCountComponent.prototype.hasNumbers;
    /** @type {?} */
    SurveyCountComponent.prototype.className;
    /** @type {?} */
    SurveyCountComponent.prototype.onDeleteHandler;
    /** @type {?} */
    SurveyCountComponent.prototype.onClickHandler;
    /** @type {?} */
    SurveyCountComponent.prototype.sequenceNumber;
    /** @type {?} */
    SurveyCountComponent.prototype.questionHead;
    /** @type {?} */
    SurveyCountComponent.prototype.questionDescription;
    /** @type {?} */
    SurveyCountComponent.prototype.countArray;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/survey-count/survey-count.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SurveyCountModule = /** @class */ (function () {
    function SurveyCountModule() {
    }
    SurveyCountModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonToggleModule, IconModule],
                    declarations: [SurveyCountComponent],
                    exports: [SurveyCountComponent],
                },] }
    ];
    return SurveyCountModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/survey-count/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dynamic-action-panel/dynamic-action-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicActionPanelComponent = /** @class */ (function () {
    function DynamicActionPanelComponent() {
        this.nonHidEWidth = 0;
        this.hiddenItemsDynamic = [];
    }
    /**
     * @return {?}
     */
    DynamicActionPanelComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.container = document.querySelector('.d-action-panel .adaptive-buttons');
        this.primary = this.container.querySelector('.-primary');
        this.primaryItems = this.container.querySelectorAll('.-primary > .hide-mobile');
        if (!this.primaryItems.length) {
            // this.primary.querySelector('itb-default-button').classList.add('hide-mobile')
            this.primaryItems = this.container.querySelectorAll('.-primary > itb-default-button');
            this.primaryItems.forEach((/**
             * @param {?} item
             * @param {?} i
             * @return {?}
             */
            function (item, i) {
                item.classList.add('hide-mobile');
            }));
        }
        this.allPrimaryItems =
            this.container.querySelectorAll('.-primary > itb-default-button:not(.hide-mobile), .-primary > itb-dropup-button:not(.hide-mobile)');
        this.allPrimaryItems.forEach((/**
         * @param {?} item
         * @param {?} i
         * @return {?}
         */
        function (item, i) { _this.nonHidEWidth = _this.nonHidEWidth + item.offsetWidth; }));
        this.container.classList.add('--jsfied');
        this.primary.insertAdjacentHTML('beforeend', "\n      <span class=\"-more\">\n        <span aria-haspopup=\"true\" aria-expanded=\"false\">\n        <button class=\"mat-flat-button edit-dots btn btn-primary\" type=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n        <span>More</span></button>\n        </span>\n        <ul class=\"-secondary\">\n        </ul>\n      </itb-default-button>\n    ");
        this.secondary = this.container.querySelector('.-secondary');
        this.secondaryItems = this.secondary.querySelectorAll('.hide-mobile');
        this.moreLi = this.primary.querySelector('span.-more');
        this.moreBtn = this.moreLi.querySelector('button');
        this.moreBtn.addEventListener('click', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            e.preventDefault();
            _this.container.classList.toggle('--show-secondary');
            _this.moreBtn.setAttribute('aria-expanded', _this.container.classList.contains('--show-secondary').toString());
        }));
        this.container.querySelectorAll('.-primary > *').forEach((/**
         * @param {?} item
         * @param {?} i
         * @return {?}
         */
        function (item, i) {
            item.setAttribute('data-order', "" + i);
        }));
        this.doAdapt();
    };
    /**
     * @return {?}
     */
    DynamicActionPanelComponent.prototype.doAdapt = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.moreLi.classList.remove('--hidden');
        this.secondaryItems = this.secondary.querySelectorAll('.hide-mobile');
        /** @type {?} */
        var stopWidth = this.moreBtn.offsetWidth + this.nonHidEWidth + 100;
        if (this.primary.offsetWidth <= stopWidth + (this.primaryItems.length * (this.moreBtn.offsetWidth + 20))) {
            this.primaryItems.forEach((/**
             * @param {?} item
             * @param {?} i
             * @return {?}
             */
            function (item, i) {
                if (_this.primary.offsetWidth >= (stopWidth + _this.moreBtn.offsetWidth + 20)) {
                    stopWidth += _this.moreBtn.offsetWidth + 20;
                }
                else {
                    if (!_this.hiddenItemsDynamic.includes(i)) {
                        _this.hiddenItemsDynamic.push(i);
                        _this.secondary.insertAdjacentElement('beforeend', item);
                    }
                }
            }));
        }
        if (this.primary.offsetWidth >= (stopWidth + this.moreBtn.offsetWidth + 20)) {
            this.secondaryItems.forEach((/**
             * @param {?} item
             * @param {?} i
             * @return {?}
             */
            function (item, i) {
                if (_this.primary.offsetWidth >= (stopWidth + _this.moreBtn.offsetWidth + 20)) {
                    _this.primary.insertAdjacentElement('afterbegin', item);
                    _this.hiddenItemsDynamic.pop();
                    _this.sortElements();
                }
            }));
        }
        if (!this.hiddenItemsDynamic.length) {
            this.moreLi.classList.add('--hidden');
            this.container.classList.remove('--show-secondary');
            this.moreBtn.setAttribute('aria-expanded', 'false');
        }
    };
    /**
     * @return {?}
     */
    DynamicActionPanelComponent.prototype.sortElements = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line: max-line-length
        Array.prototype.slice.call(document.querySelectorAll('.d-action-panel .-primary > itb-default-button[data-order], .d-action-panel .-primary > itb-dropup-button[data-order], .d-action-panel .-primary > span.-more[data-order]')).sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            a = a.getAttribute('data-order');
            b = b.getAttribute('data-order');
            return a.localeCompare(b);
        })).forEach((/**
         * @param {?} node
         * @return {?}
         */
        function (node) {
            node.parentNode.appendChild(node);
        }));
    };
    DynamicActionPanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-dynamic-action-panel',
                    template: "<div class=\"d-action-panel\" (window:resize)=\"doAdapt()\">\n  <nav class=\"tabs adaptive-buttons\">\n    <ul class=\"-primary\">\n      <ng-content></ng-content>\n    </ul>\n  </nav>\n</div>"
                }] }
    ];
    return DynamicActionPanelComponent;
}());
if (false) {
    /** @type {?} */
    DynamicActionPanelComponent.prototype.container;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.primary;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.primaryItems;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.allPrimaryItems;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.secondary;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.secondaryItems;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.allItems;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.moreLi;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.moreBtn;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.nonHidEWidth;
    /** @type {?} */
    DynamicActionPanelComponent.prototype.hiddenItemsDynamic;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dynamic-action-panel/dynamic-action-panel.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicActionPanelModule = /** @class */ (function () {
    function DynamicActionPanelModule() {
    }
    DynamicActionPanelModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatDividerModule],
                    declarations: [DynamicActionPanelComponent],
                    exports: [DynamicActionPanelComponent],
                },] }
    ];
    return DynamicActionPanelModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dynamic-action-panel/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pricing-column/pricing-column.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PricingColumnComponent = /** @class */ (function () {
    function PricingColumnComponent() {
    }
    /**
     * @return {?}
     */
    PricingColumnComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.priceString = this.price.split('.');
        if (this.priceString.length < 2) {
            // Set Default Price if price is not passed in the correct format i.e. 1.99
            this.priceString = ('0.00').split('.');
        }
    };
    PricingColumnComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-pricing-column',
                    template: "\n    <div class=\"pricing-column\">\n            <div class=\"pc-header border\">\n                <h4>{{title}}</h4>\n            </div>\n            <div class=\"pc-detail border\" *ngIf=\"!this.isCustomPlan\">\n                <div class=\"pc-per-user\">\n                    <span class=\"pr-symbol\">$</span><span class=\"pr-amount\">{{this.priceString[0]}}</span><span class=\"pr-am-deci\">.{{this.priceString[1]}}</span><span class=\"pr-txt\">/user/month</span>\n                </div>\n                <div class=\"min-user-txt\">{{subtitle}}</div>\n            </div>\n            <div class=\"pc-selection border\"  *ngIf=\"!this.isCustomPlan\">\n                <itb-default-button\u00A0[text]=\"this.buttonText\"\u00A0[className]=\"'primary'\"\u00A0[iconClassName]=\"'tick'\"></itb-default-button>\n            </div>  \n            <div class=\"pc-feature\" [ngClass]=\"{'small':this.isCustomPlan }\">\n                <ul>\n                    <li *ngFor=\"let feature of featuresList\">\n                        <itb-icon [className]=\"'tick'\" ></itb-icon> {{feature}}\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        \n"
                }] }
    ];
    /** @nocollapse */
    PricingColumnComponent.ctorParameters = function () { return []; };
    PricingColumnComponent.propDecorators = {
        title: [{ type: Input }],
        subtitle: [{ type: Input }],
        price: [{ type: Input }],
        buttonText: [{ type: Input }],
        isCustomPlan: [{ type: Input }],
        featuresList: [{ type: Input }]
    };
    return PricingColumnComponent;
}());
if (false) {
    /** @type {?} */
    PricingColumnComponent.prototype.title;
    /** @type {?} */
    PricingColumnComponent.prototype.subtitle;
    /** @type {?} */
    PricingColumnComponent.prototype.price;
    /** @type {?} */
    PricingColumnComponent.prototype.buttonText;
    /** @type {?} */
    PricingColumnComponent.prototype.isCustomPlan;
    /** @type {?} */
    PricingColumnComponent.prototype.priceString;
    /** @type {?} */
    PricingColumnComponent.prototype.featuresList;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pricing-column/pricing-column.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PricingColumnModule = /** @class */ (function () {
    function PricingColumnModule() {
    }
    PricingColumnModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonModule, DefaultButtonModule, DividerModule, IconModule, PageTitleModule],
                    declarations: [PricingColumnComponent],
                    exports: [PricingColumnComponent],
                },] }
    ];
    return PricingColumnModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pricing-column/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pricing-panel/pricing-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PricingPanelComponent = /** @class */ (function () {
    function PricingPanelComponent() {
    }
    /**
     * @return {?}
     */
    PricingPanelComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    PricingPanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-pricing-panel',
                    template: "<div class=\"pricing-panel-container\">\n    <div class=\"pricing-panel-header\">\n        <h4>Plan Details</h4>\n        <div class=\"action-btn\">\n            <itb-round-button [className]=\"'light'\" [iconClassName]=\"'edit'\" ></itb-round-button>\n            <itb-round-button [className]=\"'light'\" [iconClassName]=\"'delete'\" ></itb-round-button>\n        </div>\n    </div>\n    <div fxLayout=\"row\" class=\"pricing-panel-detail-cont\">\n        <div class=\"pricing-panel-col pr-panel-1\">\n            <div class=\"item item-header\">\n                <h4>Premium Monthly</h4>\n            </div>\n            <div class=\"item\">\n                <span class=\"item-label\">Licenses Included</span>\n                <div  class=\"item-feature\">\n                    <span class=\"license-num\">45</span>\n                </div>\n                <div class=\"item-feature-type\">\n                    <span>Managed Licenses</span>\n                </div>               \n            </div>\n            <div class=\"item\">\n                <span class=\"item-date-txt\">Date Activated</span>\n                <span class=\"item-date\">Mar 23rd, 2018</span>\n            </div>\n        </div>\n        <div class=\"pricing-panel-col pr-panel-2\">\n            <div class=\"item item-header\">\n                <h4>Amount | $0</h4>\n            </div>\n            <div class=\"item\">\n                <span class=\"item-label\">Licenses Included</span>\n                <div  class=\"item-feature\">\n                    <span class=\"license-num\"> 20</span>\n                    <span class=\"license-info\">of 45 entries</span>\n                </div>\n                <div class=\"item-feature-type\">\n                    <span>Managed Users</span>\n                </div>               \n            </div>\n            <div class=\"item\">\n                <span class=\"item-date-txt\">Date Activated</span>\n                <span class=\"item-date\">Mar 23rd, 2018</span>\n            </div>\n        </div>\n        <div class=\"pricing-panel-col pr-panel-3\">\n            <div class=\"item item-header\">\n                <h4>Status | <span>Active</span></h4>\n            </div>\n            <div class=\"item\">\n                <span class=\"item-label\">Licenses Included</span>\n                <div  class=\"item-feature\">\n                    <span class=\"if-1\">ITBSUPZERO</span>\n                    <span class=\"if-2\">Coupon Applied</span>\n                </div>\n                <div class=\"item-feature-type\">\n                    <span>Add Coupon</span>\n                </div>               \n            </div>\n            <div class=\"item\">\n                <span class=\"item-date-txt\">Date Activated</span>\n                <span class=\"item-date\">Mar 23rd, 2018</span>\n            </div>\n        </div>\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    PricingPanelComponent.ctorParameters = function () { return []; };
    return PricingPanelComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pricing-panel/pricing-panel.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PricingPanelModule = /** @class */ (function () {
    function PricingPanelModule() {
    }
    PricingPanelModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [PricingPanelComponent],
                    imports: [CommonModule, MatButtonModule, RoundButtonModule],
                    exports: [PricingPanelComponent],
                },] }
    ];
    return PricingPanelModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/pricing-panel/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/inpage-heading/inpage-heading.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InpageHeadingComponent = /** @class */ (function () {
    function InpageHeadingComponent() {
        this.hasButton = this.hasButton || true;
        this.hasDivider = this.hasDivider || true;
        this.className =
            stringConstants.DEFAULT_CLASSNAME_INPUT_HEADING || this.className;
        this.tooltipText =
            stringConstants.DEFAULT_TOOLTIP_TEXT_SQUAREBUTTON || this.tooltipText;
    }
    InpageHeadingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-inpage-heading',
                    template: "<!-- <div class=\"{{ className }}\">\n  <div class=\"heading-secondary\">\n    <span>{{ text }}</span>\n  </div>\n  <button class=\"btn-square-sm\" *ngIf=\"hasButton\">\n    <div matTooltip=\"{{ tooltipText }}\" ngClass=\"plus-bold\"></div>\n  </button>\n  <mat-divider *ngIf=\"hasDivider\" class=\"divider-themed\"></mat-divider>\n</div> -->\n\n<div *ngIf=\"!isHyperLink\" class=\"inpage-heading\">\n  <div class=\"inpage-header\">\n      <h5>{{ text }}</h5>\n      <span class=\"right-btn\">\n          <itb-square-button [tooltipText]=\"tooltipText\" [iconClassName]=\"iconClassName\" [className]=\"'btn-square-sm'\" *ngIf=\"hasButton\" ></itb-square-button>\n      </span>     \n      <!-- <button class=\"btn-square-sm\" *ngIf=\"hasButton\"></button> -->\n  </div>\n  <itb-divider [className]=\"'mat-divider divider-themed'\" *ngIf=\"hasDivider\" ></itb-divider>\n</div>\n\n<div *ngIf=\"isHyperLink\" class=\"inpage-heading\">\n  <div class=\"inpage-header\">\n    <a href=\"{{link}}\" target=\"_blank\" rel=\"noopener\"> <h5>{{ text }}</h5> </a>\n      <span class=\"right-btn\">\n          <itb-square-button [tooltipText]=\"tooltipText\" [iconClassName]=\"iconClassName\" [className]=\"'btn-square-sm'\" *ngIf=\"hasButton\" ></itb-square-button>\n      </span>     \n      <!-- <button class=\"btn-square-sm\" *ngIf=\"hasButton\"></button> -->\n  </div>\n  <itb-divider [className]=\"'mat-divider divider-themed'\" *ngIf=\"hasDivider\" ></itb-divider>\n</div>"
                }] }
    ];
    /** @nocollapse */
    InpageHeadingComponent.ctorParameters = function () { return []; };
    InpageHeadingComponent.propDecorators = {
        text: [{ type: Input }],
        hasButton: [{ type: Input }],
        hasDivider: [{ type: Input }],
        className: [{ type: Input }],
        tooltipText: [{ type: Input }],
        iconClassName: [{ type: Input }],
        isHyperLink: [{ type: Input }],
        link: [{ type: Input }]
    };
    return InpageHeadingComponent;
}());
if (false) {
    /** @type {?} */
    InpageHeadingComponent.prototype.text;
    /** @type {?} */
    InpageHeadingComponent.prototype.hasButton;
    /** @type {?} */
    InpageHeadingComponent.prototype.hasDivider;
    /** @type {?} */
    InpageHeadingComponent.prototype.className;
    /** @type {?} */
    InpageHeadingComponent.prototype.tooltipText;
    /** @type {?} */
    InpageHeadingComponent.prototype.iconClassName;
    /** @type {?} */
    InpageHeadingComponent.prototype.isHyperLink;
    /** @type {?} */
    InpageHeadingComponent.prototype.link;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/square-button/square-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SquareButtonComponent = /** @class */ (function () {
    function SquareButtonComponent() {
        var _this = this;
        this.onClickHandler = new EventEmitter();
        this.clickEvent = (/**
         * @return {?}
         */
        function () {
            _this.onClickHandler.emit();
        });
    }
    SquareButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-square-button',
                    template: "<button *ngIf=\"!isLinkButton\"\n        class=\"{{className}}\"\n        (click)=\"clickEvent()\"\n        matTooltip=\"{{tooltipText}}\"\n        type=\"button\">\n  <itb-icon [tooltipText]=\"\"\n            [className]=\"iconClassName\"> </itb-icon>\n</button>\n\n<a *ngIf=\"isLinkButton\"\n   routerLink=\"{{link}}\"><button class=\"{{className}}\"\n          (click)=\"clickEvent()\"\n          matTooltip=\"{{tooltipText}}\"\n          type=\"button\">\n    <itb-icon [tooltipText]=\"\"\n              [className]=\"iconClassName\"> </itb-icon>\n  </button></a>"
                }] }
    ];
    SquareButtonComponent.propDecorators = {
        tooltipText: [{ type: Input }],
        iconClassName: [{ type: Input }],
        className: [{ type: Input }],
        isLinkButton: [{ type: Input }],
        link: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return SquareButtonComponent;
}());
if (false) {
    /** @type {?} */
    SquareButtonComponent.prototype.tooltipText;
    /** @type {?} */
    SquareButtonComponent.prototype.iconClassName;
    /** @type {?} */
    SquareButtonComponent.prototype.className;
    /** @type {?} */
    SquareButtonComponent.prototype.isLinkButton;
    /** @type {?} */
    SquareButtonComponent.prototype.link;
    /** @type {?} */
    SquareButtonComponent.prototype.onClickHandler;
    /** @type {?} */
    SquareButtonComponent.prototype.clickEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/square-button/square-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SquareButtonModule = /** @class */ (function () {
    function SquareButtonModule() {
    }
    SquareButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonModule$1, MatTooltipModule$1, IconModule, RouterModule],
                    declarations: [SquareButtonComponent],
                    exports: [SquareButtonComponent],
                },] }
    ];
    return SquareButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/inpage-heading/inpage-heading.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InpageHeadingModule = /** @class */ (function () {
    function InpageHeadingModule() {
    }
    InpageHeadingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatTooltipModule, SquareButtonModule, DividerModule],
                    declarations: [InpageHeadingComponent],
                    exports: [InpageHeadingComponent],
                },] }
    ];
    return InpageHeadingModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/inpage-heading/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/json-viewer/json-viewer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var JsonViewerComponent = /** @class */ (function () {
    function JsonViewerComponent() {
    }
    JsonViewerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-json-viewer',
                    template: "<div class=\"itb-json-viewer\">\n    <ngx-json-viewer [json]=\"jsonObject\" [expanded]=\"isExpanded\"></ngx-json-viewer>\n</div>\n"
                }] }
    ];
    JsonViewerComponent.propDecorators = {
        isExpanded: [{ type: Input }],
        jsonObject: [{ type: Input }]
    };
    return JsonViewerComponent;
}());
if (false) {
    /** @type {?} */
    JsonViewerComponent.prototype.isExpanded;
    /** @type {?} */
    JsonViewerComponent.prototype.jsonObject;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/json-viewer/json-viewer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var JsonViewerModule = /** @class */ (function () {
    function JsonViewerModule() {
    }
    JsonViewerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, NgxJsonViewerModule],
                    declarations: [JsonViewerComponent],
                    exports: [JsonViewerComponent, NgxJsonViewerModule],
                },] }
    ];
    return JsonViewerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/json-viewer/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/widget-footer/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/email-template/email-template.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmailTemplateComponent = /** @class */ (function () {
    function EmailTemplateComponent() {
        this.onChangeHandler = new EventEmitter();
        this.editForm = false;
    }
    /**
     * @return {?}
     */
    EmailTemplateComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tempEmailField = this.parentForm.get(this.formFieldName).value;
        this.temp2EmailField = this.parentForm.get(this.formFieldName).value;
    };
    /**
     * @return {?}
     */
    EmailTemplateComponent.prototype.updateInput = /**
     * @return {?}
     */
    function () {
        this.editForm = false;
        this.temp2EmailField = this.tempEmailField;
        this.onChangeHandler.emit(this.tempEmailField);
    };
    /**
     * @return {?}
     */
    EmailTemplateComponent.prototype.toggleEvent = /**
     * @return {?}
     */
    function () {
        this.tempEmailField = this.temp2EmailField;
        this.editForm = !this.editForm;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    EmailTemplateComponent.prototype.onEmailChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.tempEmailField = value;
    };
    EmailTemplateComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-email-template',
                    template: "<div class=\"itb-feedback-container\">\n  <div class=\"feedback-browser\">\n    <div class=\"browser-top\">\n      <strong class=\"header-text\"\n        ><itb-text\n          [className]=\"'text-default'\"\n          [text]=\"'Email Application'\"\n        ></itb-text\n      ></strong>\n      <div class=\"browser-icons\">\n        <div class=\"red\"></div>\n        <div class=\"yellow\"></div>\n        <div class=\"green\"></div>\n      </div>\n    </div>\n    <div class=\"browser-fields\">\n      <span><strong>From:&nbsp;</strong> support@organization.com</span>\n      <span><strong>To:&nbsp;</strong> client@organization.com</span>\n      <span\n        ><strong>Subject:&nbsp;</strong> Service Ticket #12345/has been\n        completed</span\n      >\n    </div>\n    <div class=\"browser-body email-t\">\n        <p class=\"dummy-data dMedium\"></p>\n        <p class=\"dummy-data dLarge\"></p>\n  \n      <div *ngIf=\"editForm === false\">\n        <p>\n          <itb-text [className]=\"'text-default'\" [text]=\"tempEmailField\"></itb-text>\n          <itb-icon [hidden]=\"isDisabled\"\n            [tooltipText]=\"'Update'\"\n            [className]=\"'edit'\"\n            (onClickHandler)=\"toggleEvent()\"\n          ></itb-icon>\n        </p>\n      </div>\n\n      <div class=\"text-edit\" *ngIf=\"editForm === true\">\n        <div>\n          <form>\n            <itb-textarea\n              [isReactive]=false\n              [rows]=\"'10'\"\n              [placeholder]=\"\"\n              [maxlength]=\"emailMaxLength\"\n              [value]=\"tempEmailField\"\n              (onTextChangeHandler)=\"onEmailChange($event)\"\n            >\n            </itb-textarea>\n          </form>\n        </div>\n        <div class=\"edit-icon\">          \n          <itb-icon\n            [hidden]=\"tempEmailField.trim().length === 0\"\n            [tooltipText]=\"'Save'\"\n            [className]=\"'save'\"\n            (onClickHandler)=\"updateInput()\"\n          ></itb-icon>\n          <itb-icon\n            [tooltipText]=\"'Cancel'\"\n            [className]=\"'cross'\"\n            (onClickHandler)=\"toggleEvent()\"\n          ></itb-icon>\n        </div>\n      </div>\n      <div class=\"tem-smily\"> \n          <img class=\"img-responsive\" src=\"images-library/smiley-happy.png\" width=\"55px\">\n          <img class=\"img-responsive\" src=\"images-library/smiley-satified.png\" width=\"55px\">\n          <img class=\"img-responsive\" src=\"images-library/smiley-neutral.png\" width=\"55px\">\n          <img class=\"img-responsive\" src=\"images-library/smiley-confuse.png\" width=\"55px\">\n          <img class=\"img-responsive\" src=\"images-library/smiley-poor.png\" width=\"55px\">\n      </div>\n      <p class=\"dummy-data dMedium\"></p>\n      <p class=\"dummy-data dLarge\"></p>\n      <p class=\"dummy-data dSmall\"></p>\n\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    EmailTemplateComponent.ctorParameters = function () { return []; };
    EmailTemplateComponent.propDecorators = {
        parentForm: [{ type: Input }],
        formFieldName: [{ type: Input }],
        isDisabled: [{ type: Input }],
        emailMaxLength: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return EmailTemplateComponent;
}());
if (false) {
    /** @type {?} */
    EmailTemplateComponent.prototype.parentForm;
    /** @type {?} */
    EmailTemplateComponent.prototype.formFieldName;
    /** @type {?} */
    EmailTemplateComponent.prototype.isDisabled;
    /** @type {?} */
    EmailTemplateComponent.prototype.emailMaxLength;
    /** @type {?} */
    EmailTemplateComponent.prototype.onChangeHandler;
    /** @type {?} */
    EmailTemplateComponent.prototype.editForm;
    /** @type {?} */
    EmailTemplateComponent.prototype.tempEmailField;
    /** @type {?} */
    EmailTemplateComponent.prototype.temp2EmailField;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox/checkbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxComponent = /** @class */ (function () {
    function CheckboxComponent() {
        this.onChangeHandler = new EventEmitter();
        this.isReactive = true;
        this.isDisabled = false;
    }
    /**
     * Emits a value either true/false on selecting/unselecting a checkbox.
     * @param change The value to emit.
     */
    /**
     * Emits a value either true/false on selecting/unselecting a checkbox.
     * @param {?} change The value to emit.
     * @return {?}
     */
    CheckboxComponent.prototype.changeEvent = /**
     * Emits a value either true/false on selecting/unselecting a checkbox.
     * @param {?} change The value to emit.
     * @return {?}
     */
    function (change) {
        this.onChangeHandler.emit(change);
    };
    CheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-checkbox',
                    template: "<div *ngIf=\"isReactive\" [formGroup]=\"parentForm\" class=\"itb-checkbox\">\n  <mat-checkbox  [labelPosition]=\"position\" [formControlName]=\"formFieldName\" [checked]=\"isChecked\"\n    (change)=\"changeEvent($event)\">\n    {{label}}\n  </mat-checkbox>\n</div>\n\n<div *ngIf=\"!isReactive\" class=\"'itb-checkbox'\">\n<mat-checkbox [labelPosition]=\"position\" [checked]=\"isChecked\" [disabled]=\"isDisabled\" (change)=\"changeEvent($event)\">\n  {{label}}\n</mat-checkbox>\n</div>"
                }] }
    ];
    /** @nocollapse */
    CheckboxComponent.ctorParameters = function () { return []; };
    CheckboxComponent.propDecorators = {
        label: [{ type: Input }],
        isChecked: [{ type: Input }],
        className: [{ type: Input }],
        formFieldName: [{ type: Input }],
        position: [{ type: Input }],
        parentForm: [{ type: Input }],
        isReactive: [{ type: Input }],
        isDisabled: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return CheckboxComponent;
}());
if (false) {
    /** @type {?} */
    CheckboxComponent.prototype.label;
    /** @type {?} */
    CheckboxComponent.prototype.isChecked;
    /** @type {?} */
    CheckboxComponent.prototype.className;
    /** @type {?} */
    CheckboxComponent.prototype.formFieldName;
    /** @type {?} */
    CheckboxComponent.prototype.position;
    /** @type {?} */
    CheckboxComponent.prototype.parentForm;
    /** @type {?} */
    CheckboxComponent.prototype.isReactive;
    /** @type {?} */
    CheckboxComponent.prototype.isDisabled;
    /** @type {?} */
    CheckboxComponent.prototype.onChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox/checkbox.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxModule = /** @class */ (function () {
    function CheckboxModule() {
    }
    CheckboxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, ReactiveFormsModule, MatCheckboxModule],
                    declarations: [CheckboxComponent],
                    exports: [CheckboxComponent],
                },] }
    ];
    return CheckboxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/textarea/textarea.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextareaComponent = /** @class */ (function () {
    function TextareaComponent() {
        this.onTextChangeHandler = new EventEmitter();
        this.isReactive = true;
        this.value = '';
        this.isRequired = false;
        this.isResizeable = true;
    }
    /**
     * @return {?}
     */
    TextareaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.maxlength = this.maxlength || stringConstants.DEFAULT_TEXTAREA_MAXLENGTH;
    };
    /**
     * @return {?}
     */
    TextareaComponent.prototype.getResizeable = /**
     * @return {?}
     */
    function () {
        return !this.isResizeable ? { resize: 'none' } : '';
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TextareaComponent.prototype.textValue = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onTextChangeHandler.emit(event.target.value);
    };
    TextareaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-textarea',
                    template: "<div *ngIf=\"isReactive\" class=\"itb-textarea\" [formGroup]=\"parentForm\">\n  <mat-form-field>\n    <textarea [ngStyle]=\"getResizeable()\" [required]=\"isRequired\" matInput [placeholder]=\"placeholder\" [rows]=\"rows\" [formControlName]=\"formFieldName\" [maxlength]=\"maxlength\" *ngIf=\"!this.isReadOnly\"></textarea>\n    <textarea [ngStyle]=\"getResizeable()\" [required]=\"isRequired\" matInput [placeholder]=\"placeholder\" [rows]=\"rows\" [formControlName]=\"formFieldName\" [maxlength]=\"maxlength\" *ngIf=\"this.isReadOnly\" readonly></textarea>\n  </mat-form-field>\n</div>\n\n<div *ngIf=\"!isReactive\" class=\"itb-textarea\">\n    <mat-form-field>\n        <textarea [ngStyle]=\"getResizeable()\" [required]=\"isRequired\" matInput [value]=\"value\"\n        [attr.maxlength]=\"maxlength\" [placeholder]=\"placeholder\" [rows]=\"rows\" *ngIf=\"!this.isReadOnly\" (keyup)=\"textValue($event)\"></textarea>\n        <textarea [ngStyle]=\"getResizeable()\" [required]=\"isRequired\" matInput [value]=\"value\"\n        [attr.maxlength]=\"maxlength\" [placeholder]=\"placeholder\" [rows]=\"rows\" *ngIf=\"this.isReadOnly\" (keyup)=\"textValue($event)\" readonly></textarea>\n      </mat-form-field>\n</div>"
                }] }
    ];
    /** @nocollapse */
    TextareaComponent.ctorParameters = function () { return []; };
    TextareaComponent.propDecorators = {
        rows: [{ type: Input }],
        placeholder: [{ type: Input }],
        formFieldName: [{ type: Input }],
        maxlength: [{ type: Input }],
        parentForm: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        isReactive: [{ type: Input }],
        value: [{ type: Input }],
        isRequired: [{ type: Input }],
        isResizeable: [{ type: Input }],
        onTextChangeHandler: [{ type: Output }]
    };
    return TextareaComponent;
}());
if (false) {
    /** @type {?} */
    TextareaComponent.prototype.rows;
    /** @type {?} */
    TextareaComponent.prototype.placeholder;
    /** @type {?} */
    TextareaComponent.prototype.formFieldName;
    /** @type {?} */
    TextareaComponent.prototype.maxlength;
    /** @type {?} */
    TextareaComponent.prototype.parentForm;
    /** @type {?} */
    TextareaComponent.prototype.isReadOnly;
    /** @type {?} */
    TextareaComponent.prototype.isReactive;
    /** @type {?} */
    TextareaComponent.prototype.value;
    /** @type {?} */
    TextareaComponent.prototype.isRequired;
    /** @type {?} */
    TextareaComponent.prototype.isResizeable;
    /** @type {?} */
    TextareaComponent.prototype.onTextChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/textarea/textarea.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextareaModule = /** @class */ (function () {
    function TextareaModule() {
    }
    TextareaModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, MatFormFieldModule$1, MatInputModule$1, ReactiveFormsModule],
                    declarations: [TextareaComponent],
                    exports: [TextareaComponent],
                },] }
    ];
    return TextareaModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/email-template/email-template.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmailTemplateModule = /** @class */ (function () {
    function EmailTemplateModule() {
    }
    EmailTemplateModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule,
                        TextareaModule,
                        ReactiveFormsModule,
                        FormsModule,
                        TextModule,
                        CheckboxModule,
                    ],
                    declarations: [EmailTemplateComponent],
                    exports: [EmailTemplateComponent],
                },] }
    ];
    return EmailTemplateModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/email-template/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/feedback-page/feedback-page.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FeedbackPageComponent = /** @class */ (function () {
    function FeedbackPageComponent(changeDetectionRef) {
        this.changeDetectionRef = changeDetectionRef;
        this.editTitleText = false;
        this.editDetailsText = false;
        this.editCopyrightText = false;
        this.onChangeHandler = new EventEmitter();
        this.isDisabled = false;
    }
    /**
     * @return {?}
     */
    FeedbackPageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tempTitle = this.parentForm.get(this.titleTextForms).value;
        this.tempDetails = this.parentForm.get(this.detailsTextForm).value;
        this.tempCopyrights = this.parentForm.get(this.copyrightTextForm).value;
        this.temp2Title = this.parentForm.get(this.titleTextForms).value;
        this.temp2Details = this.parentForm.get(this.detailsTextForm).value;
        this.temp2Copyrights = this.parentForm.get(this.copyrightTextForm).value;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FeedbackPageComponent.prototype.onChangeEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        switch (value) {
            case 'titleTextForms':
                this.editTitleText = false;
                this.temp2Title = this.tempTitle;
                this.onChangeHandler.emit({ titleText: this.tempTitle, detailsText: this.tempDetails, copyrightText: this.tempCopyrights });
                break;
            case 'copyrightTextForm':
                this.editCopyrightText = false;
                this.temp2Copyrights = this.tempCopyrights;
                this.onChangeHandler.emit({ titleText: this.tempTitle, detailsText: this.tempDetails, copyrightText: this.tempCopyrights });
                break;
            case 'detailsTextForm':
                this.editDetailsText = false;
                this.temp2Details = this.tempDetails;
                this.onChangeHandler.emit({ titleText: this.tempTitle, detailsText: this.tempDetails, copyrightText: this.tempCopyrights });
                break;
            default:
        }
    };
    /**
     * @return {?}
     */
    FeedbackPageComponent.prototype.editTitleTextFunc = /**
     * @return {?}
     */
    function () {
        this.tempTitle = this.temp2Title;
        this.editTitleText = this.editTitleText ? false : true;
    };
    /**
     * @return {?}
     */
    FeedbackPageComponent.prototype.editDetailTextFunc = /**
     * @return {?}
     */
    function () {
        this.tempDetails = this.temp2Details;
        this.editDetailsText = !this.editDetailsText;
        // this.changeDetectionRef.detectChanges()
    };
    /**
     * @return {?}
     */
    FeedbackPageComponent.prototype.editCopyrightTextFunc = /**
     * @return {?}
     */
    function () {
        this.tempCopyrights = this.temp2Copyrights;
        this.editCopyrightText = this.editCopyrightText ? false : true;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FeedbackPageComponent.prototype.onTitleTextChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.tempTitle = event;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FeedbackPageComponent.prototype.onDetailsTextChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.tempDetails = event;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FeedbackPageComponent.prototype.onCopyrightsTextChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.tempCopyrights = event;
    };
    FeedbackPageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-feedback-page',
                    template: "<div class=\"itb-feedback-container\">\n  <div class=\"feedback-browser\">\n    <div class=\"browser-top\">\n      <strong class=\"header-text\">\n        <itb-text [className]=\"'text-default'\" [text]=\"'Feedback Page'\"></itb-text>\n      </strong>\n      <div class=\"browser-icons\">\n        <div class=\"red\"></div>\n        <div class=\"yellow\"></div>\n        <div class=\"green\"></div>\n      </div>\n    </div>\n    <div class=\"browser-body\">\n      <div class=\"display-center\">\n          <div class=\"feedback-header\">\n              <div class=\"header-image\">\n                <img src=\"{{imagePath}}\" width=\"150\" />\n              </div>\n            </div>\n            <div>\n              <div *ngIf=\"editTitleText === false\">\n                <h4>\n                  {{ tempTitle }}\n                  <itb-icon [hidden]=\"isDisabled\" [tooltipText]=\"'Update'\" [className]=\"'edit'\" (onClickHandler)=\"editTitleTextFunc()\"></itb-icon>\n                </h4>\n              </div>\n      \n              <div class=\"text-edit\" *ngIf=\"editTitleText === true\">\n                <div>\n                  <form class=\"form-horizontal\">\n                      <itb-textarea [isReactive]=false [rows]=\"'10'\" [placeholder]=\"\" [value]= \"tempTitle\"\n                      [maxlength]=\"titleTextFormsMaxLength\" (onTextChangeHandler)=\"onTitleTextChange($event)\"></itb-textarea>\n                  </form>\n                </div>\n                <div class=\"edit-icon\">\n                  <itb-icon [hidden]=\"tempTitle.trim().length === 0\" [tooltipText]=\"'Save'\" [className]=\"'save'\"\n                    (onClickHandler)=\"onChangeEvent('titleTextForms')\"></itb-icon>\n                  <itb-icon [tooltipText]=\"'Cancel'\" [className]=\"'cross'\" (onClickHandler)=\"editTitleTextFunc()\"></itb-icon>\n                </div>\n              </div>\n            </div>\n            <div>\n              <div *ngIf=\"editDetailsText === false\">\n                <p class=\"text-default fd\">\n                  <itb-text [className]=\"'text-default'\" [text]=\"tempDetails\"></itb-text>\n                  <itb-icon [hidden]=\"isDisabled\" [tooltipText]=\"'Update'\" [className]=\"'edit'\" (onClickHandler)=\"editDetailTextFunc()\"></itb-icon>\n                </p>\n              </div>\n      \n              <div class=\"text-edit\" *ngIf=\"editDetailsText\">\n                <div>\n                  <form class=\"form-horizontal\">\n                    <itb-textarea [isReactive]=false [rows]=\"'10'\" [placeholder]=\"\" [value]=\"tempDetails\"\n                      [maxlength]=\"detailsTextFormMaxLength\" (onTextChangeHandler)=\"onDetailsTextChange($event)\"></itb-textarea>\n                  </form>\n                </div>\n                <div class=\"edit-icon\">\n                  <itb-icon [hidden]=\"tempDetails.trim().length === 0\" [tooltipText]=\"'Save'\" [className]=\"'save'\"\n                    (onClickHandler)=\"onChangeEvent('detailsTextForm')\"></itb-icon>\n                  <itb-icon [tooltipText]=\"'Cancel'\" [className]=\"'cross'\" (onClickHandler)=\"editDetailTextFunc()\"></itb-icon>\n                </div>\n              </div>\n            </div>\n            <div class=\"fdt-ng-content\">\n                <ng-content ></ng-content>\n            </div>            \n            <div>\n              <div *ngIf=\"editCopyrightText === false\">\n                <p class=\"text-default\">\n                  <itb-text [className]=\"'text-default'\" [text]=\"tempCopyrights\"></itb-text>\n                  <itb-icon [hidden]=\"isDisabled\" [tooltipText]=\"'Update'\" [className]=\"'edit'\" (onClickHandler)=\"editCopyrightTextFunc()\"></itb-icon>\n                </p>\n              </div>\n      \n              <div class=\"text-edit\" *ngIf=\"editCopyrightText === true\">\n                <div>\n                  <form class=\"form-horizontal\">\n                    <itb-textarea [isReactive]=false [rows]=\"'10'\" [placeholder]=\"\" [value]=\"tempCopyrights\"\n                      [maxlength]=\"copyrightTextFormMaxLength\" (onTextChangeHandler)=\"onCopyrightsTextChange($event)\"></itb-textarea>\n                  </form>\n                </div>\n                <div class=\"edit-icon\">\n                  <itb-icon [hidden]=\"tempCopyrights.trim().length === 0\" [tooltipText]=\"'Save'\" [className]=\"'save'\"\n                    (onClickHandler)=\"onChangeEvent('copyrightTextForm')\"></itb-icon>\n                  <itb-icon [tooltipText]=\"'Cancel'\" [className]=\"'cross'\" (onClickHandler)=\"editCopyrightTextFunc()\"></itb-icon>\n                </div>\n              </div>\n            </div>\n      </div>\n      \n    </div>\n  </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    FeedbackPageComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    FeedbackPageComponent.propDecorators = {
        parentForm: [{ type: Input }],
        titleTextForms: [{ type: Input }],
        detailsTextForm: [{ type: Input }],
        copyrightTextForm: [{ type: Input }],
        imagePath: [{ type: Input }],
        isDisabled: [{ type: Input }],
        titleTextFormsMaxLength: [{ type: Input }],
        detailsTextFormMaxLength: [{ type: Input }],
        copyrightTextFormMaxLength: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return FeedbackPageComponent;
}());
if (false) {
    /** @type {?} */
    FeedbackPageComponent.prototype.parentForm;
    /** @type {?} */
    FeedbackPageComponent.prototype.titleTextForms;
    /** @type {?} */
    FeedbackPageComponent.prototype.detailsTextForm;
    /** @type {?} */
    FeedbackPageComponent.prototype.copyrightTextForm;
    /** @type {?} */
    FeedbackPageComponent.prototype.imagePath;
    /** @type {?} */
    FeedbackPageComponent.prototype.isDisabled;
    /** @type {?} */
    FeedbackPageComponent.prototype.titleTextFormsMaxLength;
    /** @type {?} */
    FeedbackPageComponent.prototype.detailsTextFormMaxLength;
    /** @type {?} */
    FeedbackPageComponent.prototype.copyrightTextFormMaxLength;
    /** @type {?} */
    FeedbackPageComponent.prototype.editTitleText;
    /** @type {?} */
    FeedbackPageComponent.prototype.editDetailsText;
    /** @type {?} */
    FeedbackPageComponent.prototype.editCopyrightText;
    /** @type {?} */
    FeedbackPageComponent.prototype.tempTitle;
    /** @type {?} */
    FeedbackPageComponent.prototype.tempDetails;
    /** @type {?} */
    FeedbackPageComponent.prototype.tempCopyrights;
    /** @type {?} */
    FeedbackPageComponent.prototype.temp2Title;
    /** @type {?} */
    FeedbackPageComponent.prototype.temp2Details;
    /** @type {?} */
    FeedbackPageComponent.prototype.temp2Copyrights;
    /** @type {?} */
    FeedbackPageComponent.prototype.onChangeHandler;
    /** @type {?} */
    FeedbackPageComponent.prototype.changeDetectionRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/feedback-page/feedback-page.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FeedbackPageModule = /** @class */ (function () {
    function FeedbackPageModule() {
    }
    FeedbackPageModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [FeedbackPageComponent],
                    imports: [
                        CommonModule,
                        TextareaModule,
                        ReactiveFormsModule,
                        IconModule,
                        FormsModule,
                        TextModule,
                        CheckboxModule,
                    ],
                    exports: [FeedbackPageComponent],
                },] }
    ];
    return FeedbackPageModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/feedback-page/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/circle-progress-bar/circle-progress-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CircleProgressBarComponent = /** @class */ (function () {
    function CircleProgressBarComponent() {
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    CircleProgressBarComponent.prototype.clickEvent = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    CircleProgressBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-circle-progress-bar',
                    template: "\n<div class=\"{{circleClassName}}\">\n  <div class=\"header\">\n      <itb-text [className]=\"'text-default'\" [text]=\"title\"></itb-text>\n  </div>  \n  <div class=\"itb-progress-circle\" [attr.data-progress]=\"percentage | number: '1.0-0'\" (click)=\"clickEvent()\" >\n    <div class=\"itb-circle\">\n      <div class=\"full itb-progress-circle__slice\" >\n        <div class=\"itb-progress-circle__fill\"></div>\n      </div>\n      <div class=\"itb-progress-circle__slice\">\n        <div class=\"itb-progress-circle__fill\"></div>\n        <div *ngIf=\"isTooltip\" class=\"itb-progress-circle__fill itb-progress-circle__bar\" matTooltip=\" {{percentage | number: '1.0-1'}}% \" [matTooltipPosition]=\"'above'\" matTooltipClass=\"circle-progress-tooltip\"></div>\n        <div *ngIf=\"!isTooltip\" class=\"itb-progress-circle__fill itb-progress-circle__bar\" ></div>\n      </div>\n    </div>\n    <div class=\"itb-progress-circle__overlay\" [ngClass]=\"{'with-icon': percentImageClass && percentProgress}\">\n        <span *ngIf=\"percentImageClass && percentProgress\">\n            <itb-icon [className]=\"percentImageClass\" ></itb-icon>\n        </span>\n        <span *ngIf=\"!percentProgress\" class=\"perc\">{{ progress | number: '1.0-1'}}</span>\n        <span *ngIf=\"percentProgress\" class=\"perc\"   >{{ progress | number: '1.0-1'}}%</span>\n        <span class=\"text\">{{ innerTitle }} {{score}}</span>\n    </div>\n  </div>\n</div>\n\n"
                }] }
    ];
    CircleProgressBarComponent.propDecorators = {
        title: [{ type: Input }],
        percentage: [{ type: Input }],
        innerTitle: [{ type: Input }],
        score: [{ type: Input }],
        circleClassName: [{ type: Input }],
        progress: [{ type: Input }],
        percentProgress: [{ type: Input }],
        percentImageClass: [{ type: Input }],
        isTooltip: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return CircleProgressBarComponent;
}());
if (false) {
    /** @type {?} */
    CircleProgressBarComponent.prototype.title;
    /** @type {?} */
    CircleProgressBarComponent.prototype.percentage;
    /** @type {?} */
    CircleProgressBarComponent.prototype.innerTitle;
    /** @type {?} */
    CircleProgressBarComponent.prototype.score;
    /** @type {?} */
    CircleProgressBarComponent.prototype.circleClassName;
    /** @type {?} */
    CircleProgressBarComponent.prototype.progress;
    /** @type {?} */
    CircleProgressBarComponent.prototype.percentProgress;
    /** @type {?} */
    CircleProgressBarComponent.prototype.percentImageClass;
    /** @type {?} */
    CircleProgressBarComponent.prototype.isTooltip;
    /** @type {?} */
    CircleProgressBarComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/circle-progress-bar/circle-progress-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CircleProgressBarModule = /** @class */ (function () {
    function CircleProgressBarModule() {
    }
    CircleProgressBarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, TextModule, IconModule],
                    declarations: [CircleProgressBarComponent],
                    exports: [CircleProgressBarComponent],
                },] }
    ];
    return CircleProgressBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/circle-progress-bar/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/search-widget/search-widget.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchWidgetComponent = /** @class */ (function () {
    function SearchWidgetComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.onClickHandler = new EventEmitter();
        this.onChangeHandler = new EventEmitter();
        this.searchBar = false;
    }
    /**
     * @return {?}
     */
    SearchWidgetComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.input();
    };
    /**
     * @return {?}
     */
    SearchWidgetComponent.prototype.clickEvent = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    /**
     * @return {?}
     */
    SearchWidgetComponent.prototype.searchIconClicked = /**
     * @return {?}
     */
    function () {
        this.searchBar = this.searchBar ? false : true;
    };
    /**
     * @return {?}
     */
    SearchWidgetComponent.prototype.input = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.inputForm = this.formBuilder.group({
            firstName: [''],
        });
        this.inputForm.valueChanges.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return _this.onChangeHandler.emit(data);
        }));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SearchWidgetComponent.prototype.updateInput = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onChangeHandler.emit(value);
    };
    SearchWidgetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-search-widget',
                    template: "<div [className]=\"'itb-search-widget'\">\n  <div class=\"search-widget-header\">\n    <div class=\"left\">\n        <itb-heading [className]=\"headingClassName\" [text]=\"headingText\"></itb-heading> &nbsp;\n        <itb-text [className]=\"textClassName\" [text]=\"'('+searchedItems+' '+text +')'\"></itb-text>\n    </div>\n    <div class=\"right\">\n        <itb-icon [tooltipText]=\"'search'\" [className]=\"'search'\" (click)=\"searchIconClicked()\"  *ngIf=\"hasSearchIcon\"></itb-icon>    \n        <itb-spinner [spinnerType]=\"'s'\" *ngIf=\"hasLoader\"></itb-spinner>\n    </div>\n    \n  </div>\n  <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n  <div class=\"search-item-list-cont\">\n          <ng-content></ng-content>\n  </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    SearchWidgetComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    SearchWidgetComponent.propDecorators = {
        headingClassName: [{ type: Input }],
        headingText: [{ type: Input }],
        textClassName: [{ type: Input }],
        text: [{ type: Input }],
        hasLoader: [{ type: Input }],
        searchedItems: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onChangeHandler: [{ type: Output }],
        hasKbIcon: [{ type: Input }],
        hasSearchIcon: [{ type: Input }]
    };
    return SearchWidgetComponent;
}());
if (false) {
    /** @type {?} */
    SearchWidgetComponent.prototype.headingClassName;
    /** @type {?} */
    SearchWidgetComponent.prototype.headingText;
    /** @type {?} */
    SearchWidgetComponent.prototype.textClassName;
    /** @type {?} */
    SearchWidgetComponent.prototype.text;
    /** @type {?} */
    SearchWidgetComponent.prototype.hasLoader;
    /** @type {?} */
    SearchWidgetComponent.prototype.searchedItems;
    /** @type {?} */
    SearchWidgetComponent.prototype.onClickHandler;
    /** @type {?} */
    SearchWidgetComponent.prototype.onChangeHandler;
    /** @type {?} */
    SearchWidgetComponent.prototype.hasKbIcon;
    /** @type {?} */
    SearchWidgetComponent.prototype.hasSearchIcon;
    /** @type {?} */
    SearchWidgetComponent.prototype.inputForm;
    /** @type {?} */
    SearchWidgetComponent.prototype.searchBar;
    /** @type {?} */
    SearchWidgetComponent.prototype.formInput;
    /** @type {?} */
    SearchWidgetComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/search-widget/search-widget.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchWidgetModule = /** @class */ (function () {
    function SearchWidgetModule() {
    }
    SearchWidgetModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SearchWidgetComponent],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        TextModule,
                        PageWrapperModule,
                        HeadingModule,
                        DividerModule,
                        SpinnerModule,
                        IconModule,
                        InputModule,
                        ReactiveFormsModule,
                    ],
                    exports: [SearchWidgetComponent],
                },] }
    ];
    return SearchWidgetModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/search-widget/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dropdown/dropdown.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropdownComponent = /** @class */ (function () {
    function DropdownComponent() {
    }
    DropdownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-dropdown',
                    template: "<div class=\"itb-dropdown-container\">\n  <itb-default-button *ngIf=\"buttonType === 'defaultBtn'\" [text]=\"buttonText\" [matMenuTriggerFor]=\"menu\" [className]=\"className\" [isDisabled]=\"'false'\"></itb-default-button>\n  <itb-progress-button *ngIf=\"buttonType === 'progressBtn'\" [className]=\"className\" [progressButton]=\"progressButton\" [matMenuTriggerFor]=\"menu\"></itb-progress-button>\n  <itb-round-button [matMenuTriggerFor]=\"menu\" *ngIf=\"buttonType === 'roundBtn'\" [className]=\"progressButton.roundButtonType\" [iconClassName]=\"progressButton.iconClassName\"></itb-round-button>\n  <itb-icon *ngIf=\"buttonType === 'iconBtn'\" [className]=\"className\" [matMenuTriggerFor]=\"menu\"></itb-icon>\n  <button [matMenuTriggerFor]=\"menu\" *ngIf=\"buttonType === 'profileBtn'\" class=\"profile-dropdown-toggle\">\n    <img [src]=\"progressButton.imagePath\" />\n  </button>\n  <mat-menu class=\"itb-dropdown\" #menu=\"matMenu\" xPosition='before'>\n    <ng-content></ng-content>\n  </mat-menu>\n</div>"
                }] }
    ];
    DropdownComponent.propDecorators = {
        className: [{ type: Input }],
        buttonText: [{ type: Input }],
        progressButton: [{ type: Input }],
        buttonType: [{ type: Input }]
    };
    return DropdownComponent;
}());
if (false) {
    /** @type {?} */
    DropdownComponent.prototype.className;
    /** @type {?} */
    DropdownComponent.prototype.buttonText;
    /** @type {?} */
    DropdownComponent.prototype.progressButton;
    /** @type {?} */
    DropdownComponent.prototype.buttonType;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/progress-button/progress-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProgressButtonComponent = /** @class */ (function () {
    function ProgressButtonComponent() {
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ProgressButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = this.className || stringConstants.DEFAULT_PROGRESS_BUTTON_CLASSNAME;
    };
    /**
     * @return {?}
     */
    ProgressButtonComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    ProgressButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-progress-button',
                    template: "<div *ngIf=\"!isLinkButton\" class=\"{{className}}\" (click)=\"onClick()\"> \n  <div class=\"itb-pulse\"></div>\n  <div class=\"itb-progress-circle\" [attr.data-progress]=\"progressButton.progressBarValue\">\n    <div class=\"itb-circle\">\n      <div class=\"full itb-progress-circle__slice\">\n        <div class=\"itb-progress-circle__fill\"></div>\n      </div>\n      <div class=\"itb-progress-circle__slice\">\n        <div class=\"itb-progress-circle__fill\"></div>\n        <div class=\"itb-progress-circle__fill itb-progress-circle__bar\"></div>\n      </div>\n    </div>\n    <div class=\"itb-progress-circle__overlay\">\n      <itb-icon [className]=\"progressButton.iconClassName\"></itb-icon>\n    </div>\n  </div>\n</div>\n\n<a *ngIf=\"isLinkButton\" class=\"{{className}}\" routerLink=\"{{link}}\"> \n    <div class=\"itb-pulse\"></div>\n    <div class=\"itb-progress-circle\" [attr.data-progress]=\"progressButton.progressBarValue\">\n      <div class=\"itb-circle\">\n        <div class=\"full itb-progress-circle__slice\">\n          <div class=\"itb-progress-circle__fill\"></div>\n        </div>\n        <div class=\"itb-progress-circle__slice\">\n          <div class=\"itb-progress-circle__fill\"></div>\n          <div class=\"itb-progress-circle__fill itb-progress-circle__bar\"></div>\n        </div>\n      </div>\n      <div class=\"itb-progress-circle__overlay\">\n        <itb-icon [className]=\"progressButton.iconClassName\"></itb-icon>\n      </div>\n    </div>\n</a>"
                }] }
    ];
    ProgressButtonComponent.propDecorators = {
        className: [{ type: Input }],
        progressButton: [{ type: Input }],
        link: [{ type: Input }],
        isLinkButton: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return ProgressButtonComponent;
}());
if (false) {
    /** @type {?} */
    ProgressButtonComponent.prototype.className;
    /** @type {?} */
    ProgressButtonComponent.prototype.progressButton;
    /** @type {?} */
    ProgressButtonComponent.prototype.link;
    /** @type {?} */
    ProgressButtonComponent.prototype.isLinkButton;
    /** @type {?} */
    ProgressButtonComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/progress-button/progress-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProgressButtonModule = /** @class */ (function () {
    function ProgressButtonModule() {
    }
    ProgressButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ProgressButtonComponent],
                    imports: [CommonModule, IconModule, RouterModule],
                    exports: [ProgressButtonComponent],
                },] }
    ];
    return ProgressButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dropdown/dropdown.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropdownModule = /** @class */ (function () {
    function DropdownModule() {
    }
    DropdownModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatMenuModule, DefaultButtonModule, ProgressButtonModule, RoundButtonModule, IconModule],
                    declarations: [DropdownComponent],
                    exports: [DropdownComponent],
                },] }
    ];
    return DropdownModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/dropdown/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/notifications/notifications.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Notification() { }
if (false) {
    /** @type {?} */
    Notification.prototype.username;
    /** @type {?} */
    Notification.prototype.activity;
    /** @type {?} */
    Notification.prototype.exportType;
    /** @type {?} */
    Notification.prototype.updatingType;
}
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent() {
    }
    NotificationsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-notifications',
                    template: "<itb-text [className]=\"'text-default'\" [text]=\"'Notification'\"></itb-text>\n<div *ngFor=\"let items of notifications\">\n  <itb-text [className]=\"'text-small'\" [text]=\"items.activity\"></itb-text>\n  <itb-text [className]=\"'text-small'\" [text]=\"items.username\"></itb-text>\n  <itb-text [className]=\"'text-x-small'\" [text]=\"items.UpdatingTime\"></itb-text>\n  <itb-text [className]=\"'text-default'\" [text]=\"items.exportType\"></itb-text>\n</div>\n"
                }] }
    ];
    NotificationsComponent.propDecorators = {
        notifications: [{ type: Input }]
    };
    return NotificationsComponent;
}());
if (false) {
    /** @type {?} */
    NotificationsComponent.prototype.notifications;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/notifications/notification.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationModule = /** @class */ (function () {
    function NotificationModule() {
    }
    NotificationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NotificationsComponent],
                    imports: [CommonModule, TextModule],
                    exports: [NotificationsComponent],
                },] }
    ];
    return NotificationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/notifications/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/timeline/timeline.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimelineComponent = /** @class */ (function () {
    function TimelineComponent() {
        this.currentSelectedNodeIndex = 0;
        this.moveToNodeIndex = 0;
        this.scrollToRightOnLoad = false;
        this.defaultDistanceBetweenNodes = 150;
        this.distanceBetweenNodes = 150;
        this.currentLeft = 0;
        this.maxLeft = 0;
        this.minLeft = 0;
        this.pageSize = 2;
        this.offset = 0;
        this.timelineContentWidth = 0;
        this.timelineContainerWidth = 0;
        this.onClickHandler = new EventEmitter();
        this.onDisabledClickHandler = new EventEmitter();
        this.defaultNode = 0;
        this.isLoading = false;
        this.isAutoScroll = false;
        this.onPreviousButton = new EventEmitter();
        this.onNextButton = new EventEmitter();
        this.lastSizeOfArray = 0;
        this.previousButtonClass = 'btn-icon left-arrow-c';
        this.nextButtonClass = 'btn-icon right-arrow-c';
        this.transitionSeconds = 0.4;
    }
    /**
     * @return {?}
     */
    TimelineComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.lastSizeOfArray = this.nodes.length;
        if (!this.selectableNodes)
            this.selectableNodes = this.nodes.length;
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.setDistances = /**
     * @return {?}
     */
    function () {
        if (parseInt(this.timelineContainer.nativeElement.offsetWidth) !== 0) {
            this.timelineContainerWidth = this.timelineContainer.nativeElement.offsetWidth;
            this.timelineContentWidth = this.timelineContentDiv.nativeElement.offsetWidth;
            // this.maxLeft = (this.timelineContentWidth - this.timelineContainerWidth) + this.offset
            // console.log("nodes : ", this.nodes.length)
            // console.log("Container Width " + this.timelineContainer.nativeElement.offsetWidth)
            // console.log("Content Width " + this.timelineContentDiv.nativeElement.offsetWidth)
            this.pageSize = Math.ceil(this.timelineContainerWidth / this.distanceBetweenNodes) - 1;
            if (this.pageSize <= 0)
                this.pageSize = 1;
            this.timelineContentWidth = this.nodes.length * this.distanceBetweenNodes;
            this.maxLeft = (this.timelineContentWidth - (this.pageSize * this.distanceBetweenNodes));
            //  console.log("Max Left " + this.maxLeft)
            //  console.log("Page size " , this.pageSize)
        }
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.setDistancesIfChanged = /**
     * @return {?}
     */
    function () {
        if (this.timelineContainerWidth !== this.timelineContainer.nativeElement.offsetWidth) {
            // console.log("Width change detected - resetinng distaces")
            this.timelineContainerWidth = this.timelineContainer.nativeElement.offsetWidth;
            this.setDistances();
            // this.moveToNode(this.currentSelectedNodeIndex)
        }
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var e_1, _a;
        var _this = this;
        this.setDistances();
        /*** Make sure that default node is not greater than total nodes */
        if (this.defaultNode > this.nodes.length)
            this.defaultNode = 0;
        /*** If default node is set, then move to the selected node */
        if (this.defaultNode > 0) {
            this.moveToNode(this.currentSelectedNodeIndex);
            this.currentSelectedNodeIndex = this.defaultNode;
        }
        if (this.nodes.length > 0)
            this.lastFirstNode = this.nodes[0];
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.setButtonClasses();
        }), 150);
        if (this.scrollToRightOnLoad) {
            try {
                for (var _b = __values(this.nodes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var i = _c.value;
                    this.moveRight();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} changes
     * @return {?}
     */
    TimelineComponent.prototype.ngOnChanges = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        if (changes.nodes) {
            if (!changes.nodes.isFirstChange()) {
                // console.log(changes.nodes)
                if (this.lastSizeOfArray !== this.nodes.length) {
                    if (this.selectableNodes === this.lastSizeOfArray)
                        this.selectableNodes = this.nodes.length;
                    if (this.nodes.length > this.lastSizeOfArray) {
                        /** @type {?} */
                        var diff = this.nodes.length - this.lastSizeOfArray
                        // console.log("More nodes", diff)
                        ;
                        // console.log("More nodes", diff)
                        this.offset = diff * this.distanceBetweenNodes;
                        // console.log(this.maxLeft)
                        this.lastSizeOfArray = this.nodes.length;
                        if (this.nodes[0] !== this.lastFirstNode) {
                            // Added in the start
                            this.transitionSeconds = 0;
                            this.currentLeft = this.currentLeft - (diff * this.distanceBetweenNodes);
                            this.currentSelectedNodeIndex = this.currentSelectedNodeIndex + diff;
                            // console.log("Added nodes at the start")
                            setTimeout((/**
                             * @return {?}
                             */
                            function () {
                                _this.transitionSeconds = 0.4;
                                if (_this.isAutoScroll) {
                                    _this.moveLeft();
                                }
                            }), 100);
                        }
                        else {
                            // Added in the end
                            this.transitionSeconds = 0;
                            setTimeout((/**
                             * @return {?}
                             */
                            function () {
                                _this.transitionSeconds = 0.4;
                                if (_this.isAutoScroll) {
                                    _this.moveRight();
                                }
                            }), 100);
                        }
                        this.lastFirstNode = this.nodes[0];
                    }
                    else if (this.nodes.length < this.lastSizeOfArray) {
                        /** @type {?} */
                        var diff = this.lastSizeOfArray - this.nodes.length;
                        this.lastSizeOfArray = this.nodes.length;
                        this.currentLeft = this.currentLeft + (diff * this.distanceBetweenNodes);
                        this.currentSelectedNodeIndex = this.currentSelectedNodeIndex - diff;
                        this.lastFirstNode = this.nodes[0];
                    }
                    this.setDistances();
                }
                this.setButtonClasses();
            }
        }
        if (changes.moveToNodeIndex) {
            this.moveToNode(changes.moveToNodeIndex.currentValue);
            this.moveToNodeIndex = -1;
        }
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        this.setDistancesIfChanged();
    };
    /**
     * @param {?} nodeIndex
     * @return {?}
     */
    TimelineComponent.prototype.moveToNode = /**
     * @param {?} nodeIndex
     * @return {?}
     */
    function (nodeIndex) {
        this.currentLeft = -(this.distanceBetweenNodes * nodeIndex);
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.getNodeDistance = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line: restrict-plus-operands
        return { width: this.distanceBetweenNodes + 'px' };
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.getLeft = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line: restrict-plus-operands
        return { left: this.currentLeft + 'px',
            // tslint:disable-next-line: restrict-plus-operands
            width: (this.nodes.length * this.distanceBetweenNodes) + 'px',
            // tslint:disable-next-line: restrict-plus-operands
            transition: this.transitionSeconds + 's',
        };
    };
    /**
     * @param {?} i
     * @param {?} node
     * @return {?}
     */
    TimelineComponent.prototype.nodeClicked = /**
     * @param {?} i
     * @param {?} node
     * @return {?}
     */
    function (i, node) {
        if (node.isDisabled) {
            this.onDisabledClickHandler.emit(node);
            return;
        }
        if (i > this.selectableNodes) {
            this.onDisabledClickHandler.emit(node);
            return;
        }
        this.currentSelectedNodeIndex = i;
        this.onClickHandler.emit(node);
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.previous = /**
     * @return {?}
     */
    function () {
        if (this.currentLeft >= 0) {
            if (this.isPreviousDisabled) {
                this.previousButtonClass = 'btn-icon left-arrow-c icon-disabled';
                this.currentLeft = 0;
                return;
                // tslint:disable-next-line: unnecessary-else
            }
            else {
                this.previousButtonClass = 'btn-icon left-arrow-c';
                this.onPreviousButton.emit();
            }
        }
        else {
            this.moveLeft();
        }
        this.setButtonClasses();
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.moveLeft = /**
     * @return {?}
     */
    function () {
        this.currentLeft += (this.distanceBetweenNodes * this.pageSize);
        if (this.currentLeft >= 0)
            this.currentLeft = 0;
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.moveRight = /**
     * @return {?}
     */
    function () {
        if (this.maxLeft >= 0) {
            this.currentLeft -= (this.distanceBetweenNodes * this.pageSize);
            if (this.currentLeft <= -this.maxLeft)
                this.currentLeft = -this.maxLeft;
        }
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.next = /**
     * @return {?}
     */
    function () {
        if (this.currentLeft <= -this.maxLeft) {
            if (this.isNextDisabled) {
                this.nextButtonClass = 'btn-icon right-arrow-c icon-disabled';
                this.currentLeft = -this.maxLeft;
                return;
                // tslint:disable-next-line: unnecessary-else
            }
            else {
                this.nextButtonClass = 'btn-icon left-arrow-c';
                this.onNextButton.emit();
            }
        }
        else {
            this.moveRight();
        }
        this.setButtonClasses();
    };
    /**
     * @return {?}
     */
    TimelineComponent.prototype.setButtonClasses = /**
     * @return {?}
     */
    function () {
        // Max Right Reached
        if (this.currentLeft >= 0) {
            // tslint:disable-next-line: prefer-conditional-expression
            if (this.isPreviousDisabled)
                this.previousButtonClass = 'btn-icon left-arrow-c icon-disabled';
            else
                this.previousButtonClass = 'btn-icon left-arrow-c';
        }
        else {
            this.previousButtonClass = 'btn-icon left-arrow-c';
        }
        // console.log(this.maxLeft)
        // Max Left Reached
        if (this.currentLeft <= -this.maxLeft) {
            // tslint:disable-next-line: prefer-conditional-expression
            if (this.isNextDisabled)
                this.nextButtonClass = 'btn-icon right-arrow-c icon-disabled';
            else
                this.nextButtonClass = 'btn-icon right-arrow-c';
        }
        else {
            this.nextButtonClass = 'btn-icon right-arrow-c';
        }
    };
    TimelineComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-timeline',
                    template: "<div class=\"timeline-wrapper\" #timelineContainer>\n  <div *ngIf=\"isLoading\" >\n    <div class=\"timeline-loading\">\n    </div>\n    <div class=\"timeline-spinner\">\n      <itb-spinner [spinnerType]=\"'s'\"></itb-spinner>\n    </div>\n  </div>\n  <div>\n    <div class=\"timeline-content-wrapper\" #timeline >\n      <div class=\"timeline-content\" [ngStyle]=\"getLeft()\" #timelinecontent [ngStyle]=\"getTransitionValue()\">\n        <div class=\"node\" *ngFor=\"let node of nodes; let i = index\" [ngStyle]=\"getNodeDistance()\">\n          <div class=\"texts\">\n            <p class=\"title\">{{node.title}}</p>\n            <p class=\"subtitle\">{{node.subtitle}}</p>\n            <p class=\"date\">{{node.date}}</p>\n          </div>\n          <div class=\"selector-container\" (click)=\"nodeClicked(i, node)\" [matTooltip]='node.tooltipText'>\n            <div class=\"selector\" [ngClass]=\"{'selected': i==currentSelectedNodeIndex, 'unselected' : i!=currentSelectedNodeIndex, 'filled-selector': i<=currentSelectedNodeIndex, 'unfilled-selector' : i>currentSelectedNodeIndex || i>selectableNodes}\" *ngIf=\"!node.className || node.className==''\">\n              <span></span>\n            </div>\n            <div class=\"selector\" class='selector {{node.className}}' *ngIf=\"node.className && node.className!=''\">\n              <span></span>\n            </div>\n          </div>\n          <div class=\"line\" [ngStyle]=\"getNodeDistance()\" [ngClass]=\"{'filled': i<selectableNodes-1 && i<currentSelectedNodeIndex, 'unfilled' : i>=selectableNodes || i>=currentSelectedNodeIndex}\">\n          </div>\n          <div class=\"texts\">\n            <p class=\"status\">{{node.status}}</p>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"prev-button\">\n      <div (click)=\"previous()\" [ngClass]=\"previousButtonClass\"></div>\n    </div>\n    <div class=\"next-button\">\n      <div (click)=\"next()\" [ngClass]=\"nextButtonClass\"></div>\n    </div>\n  </div>\n</div>"
                }] }
    ];
    TimelineComponent.propDecorators = {
        timelineContainer: [{ type: ViewChild, args: ['timelineContainer', undefined,] }],
        timelineDiv: [{ type: ViewChild, args: ['timeline', undefined,] }],
        timelineContentDiv: [{ type: ViewChild, args: ['timelinecontent', undefined,] }],
        nodes: [{ type: Input }],
        currentSelectedNodeIndex: [{ type: Input }],
        moveToNodeIndex: [{ type: Input }],
        scrollToRightOnLoad: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onDisabledClickHandler: [{ type: Output }],
        defaultNode: [{ type: Input }],
        isPreviousDisabled: [{ type: Input }],
        isNextDisabled: [{ type: Input }],
        isLoading: [{ type: Input }],
        isAutoScroll: [{ type: Input }],
        selectableNodes: [{ type: Input }],
        onPreviousButton: [{ type: Output }],
        onNextButton: [{ type: Output }]
    };
    return TimelineComponent;
}());
if (false) {
    /** @type {?} */
    TimelineComponent.prototype.timelineContainer;
    /** @type {?} */
    TimelineComponent.prototype.timelineDiv;
    /** @type {?} */
    TimelineComponent.prototype.timelineContentDiv;
    /** @type {?} */
    TimelineComponent.prototype.nodes;
    /** @type {?} */
    TimelineComponent.prototype.currentSelectedNodeIndex;
    /** @type {?} */
    TimelineComponent.prototype.moveToNodeIndex;
    /** @type {?} */
    TimelineComponent.prototype.scrollToRightOnLoad;
    /** @type {?} */
    TimelineComponent.prototype.timelineContainerRef;
    /** @type {?} */
    TimelineComponent.prototype.defaultDistanceBetweenNodes;
    /** @type {?} */
    TimelineComponent.prototype.distanceBetweenNodes;
    /** @type {?} */
    TimelineComponent.prototype.currentLeft;
    /** @type {?} */
    TimelineComponent.prototype.maxLeft;
    /** @type {?} */
    TimelineComponent.prototype.minLeft;
    /** @type {?} */
    TimelineComponent.prototype.pageSize;
    /** @type {?} */
    TimelineComponent.prototype.offset;
    /** @type {?} */
    TimelineComponent.prototype.timelineContentWidth;
    /** @type {?} */
    TimelineComponent.prototype.timelineContainerWidth;
    /** @type {?} */
    TimelineComponent.prototype.onClickHandler;
    /** @type {?} */
    TimelineComponent.prototype.onDisabledClickHandler;
    /** @type {?} */
    TimelineComponent.prototype.defaultNode;
    /** @type {?} */
    TimelineComponent.prototype.isPreviousDisabled;
    /** @type {?} */
    TimelineComponent.prototype.isNextDisabled;
    /** @type {?} */
    TimelineComponent.prototype.isLoading;
    /** @type {?} */
    TimelineComponent.prototype.isAutoScroll;
    /** @type {?} */
    TimelineComponent.prototype.selectableNodes;
    /** @type {?} */
    TimelineComponent.prototype.onPreviousButton;
    /** @type {?} */
    TimelineComponent.prototype.onNextButton;
    /** @type {?} */
    TimelineComponent.prototype.lastSizeOfArray;
    /** @type {?} */
    TimelineComponent.prototype.lastFirstNode;
    /** @type {?} */
    TimelineComponent.prototype.previousButtonClass;
    /** @type {?} */
    TimelineComponent.prototype.nextButtonClass;
    /** @type {?} */
    TimelineComponent.prototype.transitionSeconds;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/timeline/timeline.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimelineModule = /** @class */ (function () {
    function TimelineModule() {
    }
    TimelineModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TimelineComponent],
                    imports: [CommonModule, MatTooltipModule, IconModule, SpinnerModule],
                    exports: [TimelineComponent, MatTooltipModule],
                },] }
    ];
    return TimelineModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/timeline/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-feedback/rsb-feedback.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RsbFeedbackComponent = /** @class */ (function () {
    function RsbFeedbackComponent() {
        this.onClickHandler = new EventEmitter();
        this.onChangeHandler = new EventEmitter();
        this.simileyHandler = new EventEmitter();
        this.filterChangeHandler = new EventEmitter();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    RsbFeedbackComponent.prototype.clickEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onClickHandler.emit(event);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RsbFeedbackComponent.prototype.submitForm = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onChangeHandler.emit(value);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RsbFeedbackComponent.prototype.simileyEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        switch (value) {
            case 'poor':
                this.ratingsObj.poorRating = !this.ratingsObj.poorRating;
                this.simileyHandler.emit(this.ratingsObj);
                break;
            case 'happy':
                this.ratingsObj.happyRating = !this.ratingsObj.happyRating;
                this.simileyHandler.emit(this.ratingsObj);
                break;
            case 'neutral':
                this.ratingsObj.neutralRating = !this.ratingsObj.neutralRating;
                this.simileyHandler.emit(this.ratingsObj);
                break;
            default:
                return;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RsbFeedbackComponent.prototype.filterHandler = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.filterChangeHandler.emit(value.source.value);
    };
    RsbFeedbackComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-rsb-feedback',
                    template: "\n<div class=\"itb-rsb-feedback-panel simple-widget\">\n  <div class=\"heading widget-h widget-header\">\n      <itb-round-button [tooltipText]=\"'Apply Filters'\" [className]=\"'light'\" [iconClassName]=\"'tick'\" (onClickHandler)=\"clickEvent('tick')\"></itb-round-button>\n      <itb-round-button [tooltipText]=\"'Save Filters'\" [className]=\"'light'\" [iconClassName]=\"'save'\" (onClickHandler)=\"clickEvent('save')\"></itb-round-button>\n      <itb-round-button [tooltipText]=\"'Clear Filters'\" [className]=\"'light'\" [iconClassName]=\"'cross'\" (onClickHandler)=\"clickEvent('cross')\"></itb-round-button>\n  </div>\n  <div class=\"rsb-feedback-body\">\n      <div class=\"smily-filter\">\n        <a [ngClass]=\"ratingsObj.poorRating ? 'smiley-fil-cont active' : 'smiley-fil-cont inactive'\" (click)=\"simileyEvent('poor')\">\n          <span class=\"smiley-img img-smiley-poor\"></span>  \n        </a>\n        <a [ngClass]=\"ratingsObj.neutralRating ? 'smiley-fil-cont active' : 'smiley-fil-cont inactive'\" (click)=\"simileyEvent('neutral')\">\n            <span class=\"smiley-img img-smiley-neutral\"></span>  \n        </a>\n        <a [ngClass]=\"ratingsObj.happyRating ? 'smiley-fil-cont active' : 'smiley-fil-cont inactive'\" (click)=\"simileyEvent('happy')\">\n              <span class=\"smiley-img img-smiley-happy\"></span>  \n        </a>\n      </div>\n      <div class=\"rsb-select-filter\">\n        <itb-select [formFieldName]=\"companiesField\" [isDisabled]=\"'false'\" [parentForm]=\"parentForm\"\n          [label]=\"'Select Companies'\" [isMultiple]=\"true\"\n          [itemsStringArray]=\"companiesList\" [isDataInStrings]=\"true\"></itb-select>\n        <itb-select [formFieldName]=\"resourcesField\" [isDisabled]=\"'false'\" [parentForm]=\"parentForm\"\n          [label]=\"'Select Resources'\" [isMultiple]=\"true\"\n          [itemsStringArray]=\"resourcesList\" [isDataInStrings]=\"true\"></itb-select>\n        <itb-select [formFieldName]=\"tagsField\" [isDisabled]=\"'false'\" [parentForm]=\"parentForm\" [label]=\"'Select Tags'\"\n          [isMultiple]=\"true\" [itemsStringArray]=\"tagsList\"\n          [isDataInStrings]=\"true\"></itb-select>\n      </div>\n      <itb-date-picker [placeholder]=\"'Start Date'\" [parentForm]=\"parentForm\" [formFieldName]=\"startDateField\"\n        [date]=\"parentForm.get(startDateField).value\"></itb-date-picker>\n\n      <itb-date-picker [placeholder]=\"'End Date'\" [parentForm]=\"parentForm\" [formFieldName]=\"endDateField\" \n        [date]=\"parentForm.get(endDateField).value\"></itb-date-picker>\n\n\n    <itb-select [formFieldName]=\"filtersField\" [parentForm]=\"parentForm\" [label]=\"'Select Filters'\"\n      [isMultiple]=false [itemsStringArray]=\"filtersList\"\n      [isDataInStrings]=\"true\" (onChangeHandler)=\"filterHandler($event)\">\n    </itb-select>\n  </div>\n</div>"
                }] }
    ];
    RsbFeedbackComponent.propDecorators = {
        parentForm: [{ type: Input }],
        companiesField: [{ type: Input }],
        resourcesField: [{ type: Input }],
        tagsField: [{ type: Input }],
        startDateField: [{ type: Input }],
        endDateField: [{ type: Input }],
        filtersField: [{ type: Input }],
        companiesList: [{ type: Input }],
        resourcesList: [{ type: Input }],
        tagsList: [{ type: Input }],
        filtersList: [{ type: Input }],
        ratingsObj: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onChangeHandler: [{ type: Output }],
        simileyHandler: [{ type: Output }],
        filterChangeHandler: [{ type: Output }]
    };
    return RsbFeedbackComponent;
}());
if (false) {
    /** @type {?} */
    RsbFeedbackComponent.prototype.parentForm;
    /** @type {?} */
    RsbFeedbackComponent.prototype.companiesField;
    /** @type {?} */
    RsbFeedbackComponent.prototype.resourcesField;
    /** @type {?} */
    RsbFeedbackComponent.prototype.tagsField;
    /** @type {?} */
    RsbFeedbackComponent.prototype.startDateField;
    /** @type {?} */
    RsbFeedbackComponent.prototype.endDateField;
    /** @type {?} */
    RsbFeedbackComponent.prototype.filtersField;
    /** @type {?} */
    RsbFeedbackComponent.prototype.companiesList;
    /** @type {?} */
    RsbFeedbackComponent.prototype.resourcesList;
    /** @type {?} */
    RsbFeedbackComponent.prototype.tagsList;
    /** @type {?} */
    RsbFeedbackComponent.prototype.filtersList;
    /** @type {?} */
    RsbFeedbackComponent.prototype.ratingsObj;
    /** @type {?} */
    RsbFeedbackComponent.prototype.onClickHandler;
    /** @type {?} */
    RsbFeedbackComponent.prototype.onChangeHandler;
    /** @type {?} */
    RsbFeedbackComponent.prototype.simileyHandler;
    /** @type {?} */
    RsbFeedbackComponent.prototype.filterChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-picker/date-picker.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DatePickerService = /** @class */ (function () {
    function DatePickerService() {
    }
    /**
     * @return {?}
     */
    DatePickerService.prototype.getFormat = /**
     * @return {?}
     */
    function () {
        return this.dateFormat;
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DatePickerService.prototype.setFormat = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        this.dateFormat = date || stringConstants.DEFAULT_DATEPICKER_FORMATE;
    };
    DatePickerService.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ DatePickerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DatePickerService_Factory() { return new DatePickerService(); }, token: DatePickerService, providedIn: "root" });
    return DatePickerService;
}());
if (false) {
    /** @type {?} */
    DatePickerService.prototype.dateFormat;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-picker/date-adapter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomDateAdapter = /** @class */ (function (_super) {
    __extends(CustomDateAdapter, _super);
    function CustomDateAdapter(dateService) {
        var _this = _super.call(this, 'en') || this;
        _this.dateService = dateService;
        return _this;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    CustomDateAdapter.prototype.format = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var format = this.dateService.getFormat();
        return date.format(format);
    };
    CustomDateAdapter.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CustomDateAdapter.ctorParameters = function () { return [
        { type: DatePickerService }
    ]; };
    return CustomDateAdapter;
}(MomentDateAdapter));
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomDateAdapter.prototype.dateService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-picker/date-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DatePickerComponent = /** @class */ (function () {
    function DatePickerComponent(dateService) {
        this.dateService = dateService;
        this.onChangeHandler = new EventEmitter();
        this.placeholder = stringConstants.DEFAULT_DATEPICKER_PLACEHOLDER;
        this.isReactive = true;
        this.isRequired = false;
    }
    /**
     * @return {?}
     */
    DatePickerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dateService.setFormat(this.dateFormat);
        this.date = new Date(this.date);
        this.tempPlaceholder = this.placeholder;
    };
    /**
     * Emits the new selected date.
     * @param date The selected date.
     */
    /**
     * Emits the new selected date.
     * @param {?} date The selected date.
     * @return {?}
     */
    DatePickerComponent.prototype.changeEvent = /**
     * Emits the new selected date.
     * @param {?} date The selected date.
     * @return {?}
     */
    function (date) {
        this.placeholder = this.tempPlaceholder;
        this.onChangeHandler.emit(date);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DatePickerComponent.prototype.checkForDate = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.enteredDate = new Date(event.target.value);
    };
    /**
     * @return {?}
     */
    DatePickerComponent.prototype.onFocusOut = /**
     * @return {?}
     */
    function () {
        if (this.enteredDate.toString() === 'Invalid Date') {
            this.placeholder = 'Invalid Date';
            this.date = new Date(undefined);
        }
        this.enteredDate = '';
    };
    /**
     * @return {?}
     */
    DatePickerComponent.prototype.onFocusIn = /**
     * @return {?}
     */
    function () {
        this.placeholder = this.tempPlaceholder;
    };
    DatePickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-date-picker',
                    template: "<div *ngIf=\"isReactive\" class=\"itb-datepicker\" [ngClass]=\"{'datepicker-disabled': isDisabled}\" [formGroup]=\"parentForm\">\n    <mat-form-field>\n        <input matInput [required]=\"isRequired\" [matDatepicker]=\"picker\"\n               placeholder=\"{{placeholder}}\"\n               [formControl]=\"formFieldName\"\n               [value]=\"date\"\n               (dateChange)=\"changeEvent($event)\"\n               (focus)=\"picker.open()\"\n               (focusout)=\"onFocusOut()\"\n               (keyup)=\"checkForDate($event)\"\n               (focus)=\"onFocusIn()\">\n        <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n        <mat-datepicker #picker></mat-datepicker>\n    </mat-form-field>\n</div>\n\n<div *ngIf=\"!isReactive\" class=\"itb-datepicker\" [ngClass]=\"{'datepicker-disabled': isDisabled,'datepicker-disabled-required': isRequired && isDisabled}\">\n    <mat-form-field>\n        <mat-label>{{placeholder}}<span *ngIf=\"isRequired\" class=\"label-required\">*</span></mat-label>\n        <input matInput [required]=\"isRequired\" [matDatepicker]=\"picker\"\n               [value]=\"date\"\n               [disabled]=\"isDisabled\"\n               (dateChange)=\"changeEvent($event)\"\n               (focus)=\"picker.open()\"\n               (focusout)=\"onFocusOut()\"\n               (keyup)=\"checkForDate($event)\"\n               (focus)=\"onFocusIn()\">\n        <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n        <mat-datepicker #picker></mat-datepicker>\n    </mat-form-field>\n</div>",
                    providers: [
                        { provide: DateAdapter, useClass: CustomDateAdapter },
                        DatePickerService,
                    ]
                }] }
    ];
    /** @nocollapse */
    DatePickerComponent.ctorParameters = function () { return [
        { type: DatePickerService }
    ]; };
    DatePickerComponent.propDecorators = {
        placeholder: [{ type: Input }],
        date: [{ type: Input }],
        parentForm: [{ type: Input }],
        formFieldName: [{ type: Input }],
        dateFormat: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isReactive: [{ type: Input }],
        isRequired: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return DatePickerComponent;
}());
if (false) {
    /** @type {?} */
    DatePickerComponent.prototype.placeholder;
    /** @type {?} */
    DatePickerComponent.prototype.date;
    /** @type {?} */
    DatePickerComponent.prototype.parentForm;
    /** @type {?} */
    DatePickerComponent.prototype.formFieldName;
    /** @type {?} */
    DatePickerComponent.prototype.dateFormat;
    /** @type {?} */
    DatePickerComponent.prototype.isDisabled;
    /** @type {?} */
    DatePickerComponent.prototype.isReactive;
    /** @type {?} */
    DatePickerComponent.prototype.isRequired;
    /** @type {?} */
    DatePickerComponent.prototype.onChangeHandler;
    /** @type {?} */
    DatePickerComponent.prototype.enteredDate;
    /** @type {?} */
    DatePickerComponent.prototype.tempPlaceholder;
    /**
     * @type {?}
     * @private
     */
    DatePickerComponent.prototype.dateService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-picker/date-picker.errorhandler.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomErrorHandler = /** @class */ (function () {
    function CustomErrorHandler() {
    }
    /**
     * @param {?} error
     * @return {?}
     */
    CustomErrorHandler.prototype.handleError = /**
     * @param {?} error
     * @return {?}
     */
    function (error) { };
    CustomErrorHandler.decorators = [
        { type: Injectable }
    ];
    return CustomErrorHandler;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-picker/date-picker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DatePickerModule = /** @class */ (function () {
    function DatePickerModule() {
    }
    DatePickerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        MatDatepickerModule,
                        MatFormFieldModule$1,
                        MatInputModule$1,
                        MatMomentDateModule,
                    ],
                    declarations: [DatePickerComponent],
                    exports: [DatePickerComponent],
                    providers: [CustomDateAdapter, { provide: ErrorHandler, useClass: CustomErrorHandler }],
                },] }
    ];
    return DatePickerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-feedback/rsb-feedback.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RsbFeedbackModule = /** @class */ (function () {
    function RsbFeedbackModule() {
    }
    RsbFeedbackModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RsbFeedbackComponent],
                    imports: [CommonModule, RoundButtonModule, SelectModule, DatePickerModule, ImageModule],
                    exports: [RsbFeedbackComponent],
                },] }
    ];
    return RsbFeedbackModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-feedback/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/thankyou-template/thankyou-template.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ThankyouTemplateComponent = /** @class */ (function () {
    function ThankyouTemplateComponent() {
        this.onChangeHandler = new EventEmitter();
        this.editText = false;
        this.isDisabled = false;
    }
    /**
     * @return {?}
     */
    ThankyouTemplateComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tempTemplateField = this.parentForm.get(this.templateField).value;
        this.temp2TemplateField = this.parentForm.get(this.templateField).value;
    };
    /**
     * @return {?}
     */
    ThankyouTemplateComponent.prototype.editCopyrightTextFunc = /**
     * @return {?}
     */
    function () {
        this.tempTemplateField = this.temp2TemplateField;
        this.editText = !this.editText;
    };
    /**
     * @return {?}
     */
    ThankyouTemplateComponent.prototype.onChange = /**
     * @return {?}
     */
    function () {
        this.editText = false;
        this.temp2TemplateField = this.tempTemplateField;
        this.onChangeHandler.emit(this.tempTemplateField);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ThankyouTemplateComponent.prototype.onTemplateChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.tempTemplateField = value;
    };
    ThankyouTemplateComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-thankyou-template',
                    template: " <div class=\"itb-feedback-container\">\n    <div class=\"feedback-browser\">\n      <div class=\"browser-top\">\n        <strong class=\"header-text\"\n          ><itb-text\n            [className]=\"'text-default'\"\n            [text]=\"'Email Template'\"\n          ></itb-text\n        ></strong>\n        <div class=\"browser-icons\">\n          <div class=\"red\"></div>\n          <div class=\"yellow\"></div>\n          <div class=\"green\"></div>\n        </div>\n      </div>\n      <div class=\"browser-body\">\n        <strong class=\"header-text\">\n          <itb-text [className]=\"'text-default'\" [text]=\"'Thank you for your feedback'\"></itb-text>\n        </strong>\n      \n        <div *ngIf=\"editText=== false\">\n          <p class=\"text-default\">\n            <itb-text [className]=\"'text-default'\" [text]=\"tempTemplateField\"></itb-text>\n            <itb-icon [hidden]=\"isDisabled\" [tooltipText]=\"'Update'\" [className]=\"'edit'\" (onClickHandler)=\"editCopyrightTextFunc()\"></itb-icon>\n          </p>\n        </div>\n        <div class=\"text-edit\" *ngIf=\"editText\">\n          <div>\n            <form class=\"form-horizontal\">\n              <itb-textarea [isReactive]=false  [rows]=\"'10'\" [placeholder]=\"\" [value]=\"tempTemplateField\"\n                [maxlength]=\"templateMaxLength\" (onTextChangeHandler)=\"onTemplateChange($event)\"></itb-textarea>\n            </form>\n          </div>\n          <div class=\"edit-icon\">\n            <itb-icon [hidden]=\"tempTemplateField.trim().length === 0\" [tooltipText]=\"'Save'\" [className]=\"'save'\" (onClickHandler)=\"onChange()\"></itb-icon>\n            <itb-icon [tooltipText]=\"'Cancel'\" [className]=\"'cross'\" (onClickHandler)=\"editCopyrightTextFunc()\"></itb-icon>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  "
                }] }
    ];
    /** @nocollapse */
    ThankyouTemplateComponent.ctorParameters = function () { return []; };
    ThankyouTemplateComponent.propDecorators = {
        parentForm: [{ type: Input }],
        templateField: [{ type: Input }],
        isDisabled: [{ type: Input }],
        templateMaxLength: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return ThankyouTemplateComponent;
}());
if (false) {
    /** @type {?} */
    ThankyouTemplateComponent.prototype.parentForm;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.templateField;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.isDisabled;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.templateMaxLength;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.onChangeHandler;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.editText;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.tempTemplateField;
    /** @type {?} */
    ThankyouTemplateComponent.prototype.temp2TemplateField;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/thankyou-template/thankyou-template.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ThankyouTemplateModule = /** @class */ (function () {
    function ThankyouTemplateModule() {
    }
    ThankyouTemplateModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, TextModule, IconModule, CheckboxModule, TextareaModule, ReactiveFormsModule, FormsModule],
                    declarations: [ThankyouTemplateComponent],
                    exports: [ThankyouTemplateComponent],
                },] }
    ];
    return ThankyouTemplateModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/thankyou-template/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-expansion-panel/rsb-expansion-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RsbExpansionPanelComponent = /** @class */ (function () {
    function RsbExpansionPanelComponent() {
        this.onClickHandler = new EventEmitter();
        this.onAddClickHandler = new EventEmitter();
        this.iconName = 'icon-white ' + this.iconName;
        this.isExpanded = false;
        this.isPanelExpanded = false;
        this.buttonTooltipText = 'Add';
        this.buttonText = 'Add New';
        this.buttonIconName = 'plus';
        this.isDisabled = false;
    }
    /**
     * @return {?}
     */
    RsbExpansionPanelComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.isPanelExpanded = this.isExpanded;
    };
    /**
     * @return {?}
     */
    RsbExpansionPanelComponent.prototype.onExpansionPanelClicked = /**
     * @return {?}
     */
    function () {
        this.isPanelExpanded = !this.isPanelExpanded;
        this.onClickHandler.emit(this.isPanelExpanded);
    };
    /**
     * @return {?}
     */
    RsbExpansionPanelComponent.prototype.onAddButtonClicked = /**
     * @return {?}
     */
    function () {
        this.onAddClickHandler.emit();
    };
    RsbExpansionPanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-rsb-expansion-panel',
                    template: "<ng-container>\n  <mat-accordion class=\"right-side-bar\" >\n    <mat-expansion-panel\n      [expanded]=\"isPanelExpanded\"\n    >\n      <mat-expansion-panel-header\n        [collapsedHeight]=\"'42px'\"\n        [expandedHeight]=\"'42px'\"\n        (click)=\"onExpansionPanelClicked()\"\n      >\n        <itb-icon [className]=\"iconName\"> </itb-icon>\n        <itb-text [className]=\"'text-default'\" [text]=\"text\"></itb-text>\n      </mat-expansion-panel-header>\n      <ng-content></ng-content>\n    </mat-expansion-panel>\n    <div\n      class=\"rsb-add-btn\"\n      (click)=\"onAddButtonClicked()\"\n      *ngIf=\"hasAddNewButton && !isDisabled\"\n    >\n      <itb-icon [tooltipText]=\"buttonTooltipText\" [className]=\"buttonIconName\"></itb-icon>\n      <span>{{buttonText}}</span>\n    </div>\n    <div\n      class=\"rsb-add-btn\"\n      *ngIf=\"hasAddNewButton && isDisabled\"\n    >\n      <itb-icon [tooltipText]=\"buttonTooltipText\" [className]=\"buttonIconName\"></itb-icon>\n      <span>{{buttonText}}</span>\n    </div>\n  </mat-accordion>\n</ng-container>\n"
                }] }
    ];
    /** @nocollapse */
    RsbExpansionPanelComponent.ctorParameters = function () { return []; };
    RsbExpansionPanelComponent.propDecorators = {
        iconName: [{ type: Input }],
        text: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onAddClickHandler: [{ type: Output }],
        hasAddNewButton: [{ type: Input }],
        isExpanded: [{ type: Input }],
        isPanelExpanded: [{ type: Input }],
        buttonTooltipText: [{ type: Input }],
        buttonText: [{ type: Input }],
        buttonIconName: [{ type: Input }],
        isDisabled: [{ type: Input }]
    };
    return RsbExpansionPanelComponent;
}());
if (false) {
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.iconName;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.text;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.onClickHandler;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.onAddClickHandler;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.hasAddNewButton;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.isExpanded;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.isPanelExpanded;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.buttonTooltipText;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.buttonText;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.buttonIconName;
    /** @type {?} */
    RsbExpansionPanelComponent.prototype.isDisabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-expansion-panel/rsb-expansion-panel.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RsbExpansionPanelModule = /** @class */ (function () {
    function RsbExpansionPanelModule() {
    }
    RsbExpansionPanelModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RsbExpansionPanelComponent],
                    imports: [
                        CommonModule,
                        IconModule,
                        MatExpansionModule,
                        TextModule,
                    ],
                    exports: [RsbExpansionPanelComponent],
                },] }
    ];
    return RsbExpansionPanelModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/rsb-expansion-panel/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/slider/slider.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SliderComponent = /** @class */ (function () {
    function SliderComponent() {
        this.currentMinValue = 0;
        this.currentMaxValue = 0;
        this.lastMinValue = 0;
        this.lastMaxValue = 0;
        this.minValueChangeHandler = new EventEmitter();
        this.maxValueChangeHandler = new EventEmitter();
        this.warningTranquilizer = Options;
    }
    /**
     * @return {?}
     */
    SliderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.currentMinValue = this.minValue;
        this.currentMaxValue = this.maxValue;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SliderComponent.prototype.onMinValueChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        if (this.minValue !== this.maxValue)
            this.lastMinValue = value;
        if (this.minValue === this.maxValue) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.minValue = _this.lastMinValue;
            }), 0);
        }
        if (value !== this.currentMinValue) {
            this.currentMinValue = value;
            this.minValueChangeHandler.emit({ value: value, name: 'minPointer' });
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SliderComponent.prototype.onHighValueChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        if (this.maxValue !== this.minValue)
            this.lastMaxValue = value;
        if (this.maxValue === this.minValue) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.maxValue = _this.lastMaxValue;
            }), 0);
        }
        if (value !== this.currentMaxValue) {
            this.currentMaxValue = value;
            this.maxValueChangeHandler.emit({ value: value, name: 'maxPointer' });
        }
    };
    SliderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-range-slider',
                    template: "<ng5-slider class=\"itb-rang-slider\" [(value)]=\"minValue\" [(highValue)]=\"maxValue\" [options]=\"options\"\n(valueChange)=\"onMinValueChange($event)\"\n(highValueChange)=\"onHighValueChange($event)\"></ng5-slider>"
                }] }
    ];
    /** @nocollapse */
    SliderComponent.ctorParameters = function () { return []; };
    SliderComponent.propDecorators = {
        minValue: [{ type: Input }],
        maxValue: [{ type: Input }],
        options: [{ type: Input }],
        minValueChangeHandler: [{ type: Output }],
        maxValueChangeHandler: [{ type: Output }]
    };
    return SliderComponent;
}());
if (false) {
    /** @type {?} */
    SliderComponent.prototype.currentMinValue;
    /** @type {?} */
    SliderComponent.prototype.currentMaxValue;
    /** @type {?} */
    SliderComponent.prototype.lastMinValue;
    /** @type {?} */
    SliderComponent.prototype.lastMaxValue;
    /** @type {?} */
    SliderComponent.prototype.minValue;
    /** @type {?} */
    SliderComponent.prototype.maxValue;
    /** @type {?} */
    SliderComponent.prototype.options;
    /** @type {?} */
    SliderComponent.prototype.minValueChangeHandler;
    /** @type {?} */
    SliderComponent.prototype.maxValueChangeHandler;
    /** @type {?} */
    SliderComponent.prototype.warningTranquilizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/slider/slider.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RangeSliderModule = /** @class */ (function () {
    function RangeSliderModule() {
    }
    RangeSliderModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SliderComponent],
                    imports: [CommonModule, Ng5SliderModule],
                    exports: [SliderComponent],
                },] }
    ];
    return RangeSliderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/slider/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/integration-box/integration-box.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IntegrationBoxComponent = /** @class */ (function () {
    function IntegrationBoxComponent() {
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @param {?} integrationType
     * @param {?} integrationLogo
     * @return {?}
     */
    IntegrationBoxComponent.prototype.onAddClickEvent = /**
     * @param {?} integrationType
     * @param {?} integrationLogo
     * @return {?}
     */
    function (integrationType, integrationLogo) {
        this.onClickHandler.emit({ integrationType: integrationType, integrationLogo: integrationLogo });
    };
    IntegrationBoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-integration-box',
                    template: "<div *ngIf=\"integrationType !== 'disabled'\" class=\"itb-integration-box {{integrationType}}\" (click)=\"onAddClickEvent(integrationType, integrationLogo)\">\n    <img *ngIf=\"integrationType==='added'\" src=\"images-library/{{integrationLogo}}.png\" >\n    <img *ngIf=\"integrationType==='add'\" src=\"images-library/{{integrationLogo}}_disabled.png\">    \n</div>\n\n<div *ngIf=\"integrationType === 'disabled'\" class=\"itb-integration-box {{integrationType}}\">\n    <img *ngIf=\"integrationType==='disabled'\" src=\"images-library/{{integrationLogo}}_disabled.png\">    \n</div>\n"
                }] }
    ];
    IntegrationBoxComponent.propDecorators = {
        integrationType: [{ type: Input }],
        integrationLogo: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return IntegrationBoxComponent;
}());
if (false) {
    /** @type {?} */
    IntegrationBoxComponent.prototype.integrationType;
    /** @type {?} */
    IntegrationBoxComponent.prototype.integrationLogo;
    /** @type {?} */
    IntegrationBoxComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/integration-box/integration-box.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IntegrationBoxModule = /** @class */ (function () {
    function IntegrationBoxModule() {
    }
    IntegrationBoxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [IntegrationBoxComponent],
                    exports: [IntegrationBoxComponent],
                },] }
    ];
    return IntegrationBoxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/integration-box/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/paginator/paginator.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginatorComponent = /** @class */ (function () {
    function PaginatorComponent() {
        this.paginatorValueHandler = new EventEmitter();
        this.pages = [];
        this.currentPage = 1;
        this.pageSize = 10;
        this.maxShownPages = 7;
    }
    /**
     * @return {?}
     */
    PaginatorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        for (var i = 0; i < this.records; i++) {
            this.pages.push(i);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PaginatorComponent.prototype.pageChangeEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.currentPage = event;
        this.paginatorValueHandler.emit(event);
    };
    PaginatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-paginator',
                    template: "\n<div *ngFor=\"let page of pages | paginate: { itemsPerPage: pageSize, currentPage: currentPage }\"></div>\n             \n<pagination-controls \n  [maxSize]=\"maxShownPages\"\n  previousLabel=\"Previous\"\n  nextLabel=\"Next\"\n  (pageChange)=\"pageChangeEvent($event)\">\n</pagination-controls>\n"
                }] }
    ];
    /** @nocollapse */
    PaginatorComponent.ctorParameters = function () { return []; };
    PaginatorComponent.propDecorators = {
        records: [{ type: Input }],
        pageSize: [{ type: Input }],
        currentPage: [{ type: Input }],
        maxShownPages: [{ type: Input }],
        paginatorValueHandler: [{ type: Output }]
    };
    return PaginatorComponent;
}());
if (false) {
    /** @type {?} */
    PaginatorComponent.prototype.records;
    /** @type {?} */
    PaginatorComponent.prototype.pageSize;
    /** @type {?} */
    PaginatorComponent.prototype.currentPage;
    /** @type {?} */
    PaginatorComponent.prototype.maxShownPages;
    /** @type {?} */
    PaginatorComponent.prototype.paginatorValueHandler;
    /** @type {?} */
    PaginatorComponent.prototype.pages;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/paginator/paginator.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginatorModule = /** @class */ (function () {
    function PaginatorModule() {
    }
    PaginatorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, NgxPaginationModule],
                    declarations: [PaginatorComponent],
                    exports: [PaginatorComponent],
                },] }
    ];
    return PaginatorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/paginator/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/spinner/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/bar-loader/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loaders/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/info-message/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/popup-alert/popup-alert.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = (__assign({}, new MatDialogConfig()));
var PopupAlertModule = /** @class */ (function () {
    function PopupAlertModule() {
    }
    PopupAlertModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatFormFieldModule, MatDialogModule, ActionPanelModule, MatIconModule, MatButtonModule],
                    declarations: [PopupAlertComponent],
                    exports: [PopupAlertComponent, MatDialogModule],
                    providers: [
                        {
                            provide: MAT_DIALOG_DEFAULT_OPTIONS,
                            useValue: (/** @type {?} */ (ɵ0)),
                        },
                        { provide: MatDialogRef },
                    ],
                },] }
    ];
    return PopupAlertModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/popup-alert/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/confirmation-messages/confirmation-messages.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfirmationMessagesComponent = /** @class */ (function () {
    function ConfirmationMessagesComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.hasInnerHTML = false;
    }
    /**
     * @return {?}
     */
    ConfirmationMessagesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.data.innerHTML ? this.hasInnerHTML = true : this.hasInnerHTML = false;
    };
    /**
     * @return {?}
     */
    ConfirmationMessagesComponent.prototype.closeDialog = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    /**
     * @param {?} name
     * @return {?}
     */
    ConfirmationMessagesComponent.prototype.btnClick = /**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.name = name;
    };
    ConfirmationMessagesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-confirmation-messages',
                    template: "<itb-heading mat-dialog-title [className]=\"'modal-h'\" [text]=\"data.title\" ></itb-heading>\n<itb-round-button [tooltipText]=\"'Close'\" mat-dialog-close [className]=\"'light round-modal-cross caret-close-modal'\" [iconClassName]=\"'cross'\"></itb-round-button>\n<div mat-dialog-content>\n  <p *ngIf=\"!hasInnerHTML\">{{data.body}}</p>\n  <p *ngIf=\"hasInnerHTML\" [innerHTML]=\"data.body\"></p>\n</div>\n<!-- <itb-action-panel [btnArray]=\"data.buttonsArray\" [mat-dialog-close]=\"name\" (onClickHandler)=\"btnClick($event)\">\n</itb-action-panel> -->\n\n<mat-dialog-actions align=\"end\">\n<itb-default-button [mat-dialog-close]=\"name\" *ngFor=\"let btn of data.buttonsArray\" [iconClassName]=\"btn.iconClassName\" [isHidden]=\"btn.isHidden\" [isDisabled]=\"btn.isDisabled\" [className]=\"btn.className\" [isLoading]=\"btn.isLoading\" [text]=\"btn.text\" (onClickHandler)=\"btnClick(btn.buttonName)\"></itb-default-button>\n</mat-dialog-actions>\n"
                }] }
    ];
    /** @nocollapse */
    ConfirmationMessagesComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return ConfirmationMessagesComponent;
}());
if (false) {
    /** @type {?} */
    ConfirmationMessagesComponent.prototype.name;
    /** @type {?} */
    ConfirmationMessagesComponent.prototype.hasInnerHTML;
    /** @type {?} */
    ConfirmationMessagesComponent.prototype.dialogRef;
    /** @type {?} */
    ConfirmationMessagesComponent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/confirmation-messages/confirmation-messages.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$1 = (__assign({}, new MatDialogConfig(), { panelClass: ['itb-dialog', 'itb-confirmation'] }));
var ConfirmationMessagesModule = /** @class */ (function () {
    function ConfirmationMessagesModule() {
    }
    ConfirmationMessagesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatFormFieldModule, MatDialogModule, ActionPanelModule, MatIconModule, MatButtonModule,
                        HeadingModule, RoundButtonModule, DefaultButtonModule],
                    declarations: [ConfirmationMessagesComponent],
                    exports: [ConfirmationMessagesComponent, MatDialogModule],
                    providers: [
                        {
                            provide: MAT_DIALOG_DEFAULT_OPTIONS,
                            useValue: (/** @type {?} */ (ɵ0$1)),
                        },
                        { provide: MatDialogRef },
                    ],
                },] }
    ];
    return ConfirmationMessagesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/confirmation-messages/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notification/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/input/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/switch/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/radio/radio.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RadioComponent = /** @class */ (function () {
    function RadioComponent() {
        this.onChangeHandler = new EventEmitter();
        this.className = stringConstants.DEFAULT_RADIO_BUTTON_CLASSNAME;
        this.isReactive = true;
        this.isChecked = false;
        this.isDisabled = false;
        this.hasOptions = false;
    }
    /**
     * @return {?}
     */
    RadioComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.options)
            this.hasOptions = true;
    };
    /**
     * @return {?}
     */
    RadioComponent.prototype.changeEvent = /**
     * @return {?}
     */
    function () {
        this.onChangeHandler.emit(this.parentForm.value[this.formFieldName]);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RadioComponent.prototype.simpleChangeEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onChangeHandler.emit(event);
    };
    RadioComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-radio',
                    template: "<div *ngIf=\"isReactive\" [formGroup]=\"parentForm\" class=\"radio-btn-group\">\n  <label class=\"radio-label\">{{label}} <span *ngIf=\"isRequired\" class=\"error-msg\"> *</span></label>\n  <mat-radio-group [formControlName]=\"formFieldName\"\n                   labelPosition=\"{{labelPosition}}\" (change)=\"changeEvent()\" class=\"{{className}}\" >\n    <mat-radio-button [disableRipple]=\"true\"  *ngFor=\"let item of options\" value=\"{{item.value}}\" checked=\"{{item.isChecked ? true: false }}\" disabled=\"{{item.isDisabled ? true: false}}\">{{item.label}}</mat-radio-button>\n  </mat-radio-group>\n  <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n\n<div *ngIf=\"!isReactive && !hasOptions\" class=\"radio-btn-group\">\n  <label class=\"radio-label\">{{label}} <span *ngIf=\"isRequired\" class=\"error-msg\"> *</span></label>\n  <mat-radio-group labelPosition=\"{{labelPosition}}\" (change)=\"changeEvent()\" class=\"{{className}}\" >\n    <mat-radio-button [disableRipple]=\"true\" value=\"{{value}}\" checked=\"{{isChecked}}\" disabled=\"{{isDisabled}}\">{{value}}</mat-radio-button>\n  </mat-radio-group>\n  <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n\n<div *ngIf=\"!isReactive && hasOptions\" class=\"radio-btn-group\">\n  <label class=\"radio-label\">{{label}} <span *ngIf=\"isRequired\" class=\"error-msg\"> *</span></label>\n  <mat-radio-group labelPosition=\"{{labelPosition}}\" class=\"{{className}}\" >\n    <mat-radio-button [disableRipple]=\"true\" *ngFor=\"let item of options\" value=\"{{item.value}}\" checked=\"{{item.isChecked ? true: false }}\" disabled=\"{{item.isDisabled ? true: false}}\" (change)=\"simpleChangeEvent($event.value)\">{{item.label}}</mat-radio-button>\n  </mat-radio-group>\n  <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    RadioComponent.ctorParameters = function () { return []; };
    RadioComponent.propDecorators = {
        parentForm: [{ type: Input }],
        className: [{ type: Input }],
        labelPosition: [{ type: Input }],
        label: [{ type: Input }],
        formFieldName: [{ type: Input }],
        options: [{ type: Input }],
        isReactive: [{ type: Input }],
        value: [{ type: Input }],
        isChecked: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isRequired: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return RadioComponent;
}());
if (false) {
    /** @type {?} */
    RadioComponent.prototype.parentForm;
    /** @type {?} */
    RadioComponent.prototype.className;
    /** @type {?} */
    RadioComponent.prototype.labelPosition;
    /** @type {?} */
    RadioComponent.prototype.label;
    /** @type {?} */
    RadioComponent.prototype.formFieldName;
    /** @type {?} */
    RadioComponent.prototype.options;
    /** @type {?} */
    RadioComponent.prototype.isReactive;
    /** @type {?} */
    RadioComponent.prototype.value;
    /** @type {?} */
    RadioComponent.prototype.isChecked;
    /** @type {?} */
    RadioComponent.prototype.isDisabled;
    /** @type {?} */
    RadioComponent.prototype.isRequired;
    /** @type {?} */
    RadioComponent.prototype.onChangeHandler;
    /** @type {?} */
    RadioComponent.prototype.hasOptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/radio/radio.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RadioModule = /** @class */ (function () {
    function RadioModule() {
    }
    RadioModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatRadioModule, FormsModule, ReactiveFormsModule, DividerModule],
                    declarations: [RadioComponent],
                    exports: [RadioComponent],
                },] }
    ];
    return RadioModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/radio/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-picker/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/textarea/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/select/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/select-with-button/select-with-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectWithButtonComponent = /** @class */ (function () {
    function SelectWithButtonComponent() {
        this.onClickHandler = new EventEmitter();
        this.onChangeHandler = new EventEmitter();
        this.onSimpleChangeHandler = new EventEmitter();
        this.isDataInStrings = false;
        this.isReactive = true;
        this.isRequired = false;
        this.isDisabled = false;
        this.isSorted = false;
    }
    /**
     * @return {?}
     */
    SelectWithButtonComponent.prototype.clickEvent = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectWithButtonComponent.prototype.changeEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onChangeHandler.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectWithButtonComponent.prototype.emptyFunction = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectWithButtonComponent.prototype.onSimpleChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onSimpleChangeHandler.emit(event);
    };
    SelectWithButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-select-with-button',
                    template: "<div class=\"select-wbtn\">\n  <itb-square-button *ngIf=\"!isDisabled\" [iconClassName]=\"iconClassName\" [className]=\"className\"\n  (onClickHandler)=\"emptyFunction($event)\"></itb-square-button>\n  <itb-select [isReactive]=\"isReactive\" [isRequired]=\"isRequired\" [isSorted]=\"isSorted\" [isMultiple]=\"isMultiple\" [selected]=\"selected\" [isDataInStrings]=\"isDataInStrings\" [itemsStringArray]=\"itemsStringArray\" [formFieldName]=\"formField\" [isDisabled]=\"isDisabled\" [parentForm]=\"parentForm\" [items]=\"items\"\n    [label]=\"label\" (onChangeHandler)=\"changeEvent($event)\" (onSimpleChangeHandler)=\"onSimpleChange($event)\">\n  </itb-select>\n  <itb-square-button *ngIf=\"!isDisabled\" [tooltipText]=\"tooltipText\" [iconClassName]=\"iconClassName\" [className]=\"className\"\n    (onClickHandler)=\"clickEvent()\"></itb-square-button>\n</div>"
                }] }
    ];
    /** @nocollapse */
    SelectWithButtonComponent.ctorParameters = function () { return []; };
    SelectWithButtonComponent.propDecorators = {
        isDisabled: [{ type: Input }],
        parentForm: [{ type: Input }],
        className: [{ type: Input }],
        label: [{ type: Input }],
        formField: [{ type: Input }],
        items: [{ type: Input }],
        tooltipText: [{ type: Input }],
        iconClassName: [{ type: Input }],
        itemsStringArray: [{ type: Input }],
        isDataInStrings: [{ type: Input }],
        isReactive: [{ type: Input }],
        isMultiple: [{ type: Input }],
        selected: [{ type: Input }],
        isRequired: [{ type: Input }],
        isSorted: [{ type: Input }],
        onClickHandler: [{ type: Output }],
        onChangeHandler: [{ type: Output }],
        onSimpleChangeHandler: [{ type: Output }]
    };
    return SelectWithButtonComponent;
}());
if (false) {
    /** @type {?} */
    SelectWithButtonComponent.prototype.isDisabled;
    /** @type {?} */
    SelectWithButtonComponent.prototype.parentForm;
    /** @type {?} */
    SelectWithButtonComponent.prototype.className;
    /** @type {?} */
    SelectWithButtonComponent.prototype.label;
    /** @type {?} */
    SelectWithButtonComponent.prototype.formField;
    /** @type {?} */
    SelectWithButtonComponent.prototype.items;
    /** @type {?} */
    SelectWithButtonComponent.prototype.tooltipText;
    /** @type {?} */
    SelectWithButtonComponent.prototype.iconClassName;
    /** @type {?} */
    SelectWithButtonComponent.prototype.itemsStringArray;
    /** @type {?} */
    SelectWithButtonComponent.prototype.isDataInStrings;
    /** @type {?} */
    SelectWithButtonComponent.prototype.isReactive;
    /** @type {?} */
    SelectWithButtonComponent.prototype.isMultiple;
    /** @type {?} */
    SelectWithButtonComponent.prototype.selected;
    /** @type {?} */
    SelectWithButtonComponent.prototype.isRequired;
    /** @type {?} */
    SelectWithButtonComponent.prototype.isSorted;
    /** @type {?} */
    SelectWithButtonComponent.prototype.onClickHandler;
    /** @type {?} */
    SelectWithButtonComponent.prototype.onChangeHandler;
    /** @type {?} */
    SelectWithButtonComponent.prototype.onSimpleChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/select-with-button/select-with-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectWithButtonModule = /** @class */ (function () {
    function SelectWithButtonModule() {
    }
    SelectWithButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, ReactiveFormsModule, FormsModule, SelectModule, SquareButtonModule],
                    declarations: [SelectWithButtonComponent],
                    exports: [SelectWithButtonComponent],
                },] }
    ];
    return SelectWithButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/select-with-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox-list/checkbox-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxListComponent = /** @class */ (function () {
    function CheckboxListComponent() {
        this.onChangeHandler = new EventEmitter();
        this.isDisabled = false;
    }
    /**
     * @param {?} value
     * @param {?} index
     * @param {?} name
     * @return {?}
     */
    CheckboxListComponent.prototype.onChangeEvent = /**
     * @param {?} value
     * @param {?} index
     * @param {?} name
     * @return {?}
     */
    function (value, index, name) {
        this.onChangeHandler.emit({ value: value, index: index, name: name });
    };
    CheckboxListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-checkbox-list',
                    template: "<div *ngIf=\"!isDisabled\" class=\"itb-checkbox\">\n  <itb-text [className]=\"'text-default text-color-primary'\" [text]=\"label\"></itb-text><span *ngIf=\"isRequired\"\n    class=\"error-msg\"> *</span>\n  <div style=\"margin-top: 10px;\">\n    <mat-checkbox *ngFor=\"let box of checkboxArray; let i=index\" [labelPosition]=\"box.position\"\n      [checked]=\"box.isSelected || box.isChecked\" [disabled]=\"box.isDisabled\"\n      (change)=\"onChangeEvent($event,i,box.label)\">\n      {{box.label}}</mat-checkbox>\n  </div>\n</div>\n<div *ngIf=\"isDisabled\" class=\"itb-checkbox\">\n  <itb-text [className]=\"'text-default text-color-primary'\" [text]=\"label\"></itb-text><span *ngIf=\"isRequired\"\n    class=\"error-msg\"> *</span>\n  <div style=\"margin-top: 10px;\">\n    <mat-checkbox *ngFor=\"let box of checkboxArray; let i=index\" [labelPosition]=\"box.position\" [disabled]=\"isDisabled\"\n      [checked]=\"box.isSelected || box.isChecked\">{{box.label}}</mat-checkbox>\n  </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    CheckboxListComponent.ctorParameters = function () { return []; };
    CheckboxListComponent.propDecorators = {
        label: [{ type: Input }],
        checkboxArray: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isRequired: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return CheckboxListComponent;
}());
if (false) {
    /** @type {?} */
    CheckboxListComponent.prototype.label;
    /** @type {?} */
    CheckboxListComponent.prototype.checkboxArray;
    /** @type {?} */
    CheckboxListComponent.prototype.isDisabled;
    /** @type {?} */
    CheckboxListComponent.prototype.isRequired;
    /** @type {?} */
    CheckboxListComponent.prototype.onChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox-list/checkbox-list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxListModule = /** @class */ (function () {
    function CheckboxListModule() {
    }
    CheckboxListModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatCheckboxModule, MatFormFieldModule$1, HeadingModule, TextModule],
                    declarations: [CheckboxListComponent],
                    exports: [CheckboxListComponent],
                },] }
    ];
    return CheckboxListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox-list/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/drop-zone/drop-zone.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropZoneComponent = /** @class */ (function () {
    function DropZoneComponent() {
        this.contentReady = new EventEmitter();
        this.files = [];
    }
    /**
     * @param {?} event
     * @return {?}
     */
    DropZoneComponent.prototype.onSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _a;
        if (this.files.length === 0) {
            (_a = this.files).push.apply(_a, __spread(event.addedFiles));
            this.contentReady.emit({
                type: 'file',
                file: this.files,
            });
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DropZoneComponent.prototype.onRemove = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.files.splice(this.files.indexOf(event), 1);
        this.contentReady.emit({
            type: 'deleteFile',
            file: event,
        });
    };
    DropZoneComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-drop-zone',
                    template: "<div class=\"{{className}}\">\n  <ngx-dropzone accept=\".pdf,.doc,.docx\" (change)=\"onSelect($event)\">\n    <ngx-dropzone-label>Drop File Here</ngx-dropzone-label>\n    <ngx-dropzone-preview *ngFor=\"let f of files\" [removable]=\"true\" (removed)=\"onRemove(f)\">\n        <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>\n    </ngx-dropzone-preview>\n  </ngx-dropzone>\n\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    DropZoneComponent.ctorParameters = function () { return []; };
    DropZoneComponent.propDecorators = {
        className: [{ type: Input }],
        contentReady: [{ type: Output }]
    };
    return DropZoneComponent;
}());
if (false) {
    /** @type {?} */
    DropZoneComponent.prototype.className;
    /** @type {?} */
    DropZoneComponent.prototype.contentReady;
    /** @type {?} */
    DropZoneComponent.prototype.files;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/drop-zone/drop-zone.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropZoneModule = /** @class */ (function () {
    function DropZoneModule() {
    }
    DropZoneModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, NgxDropzoneModule],
                    declarations: [DropZoneComponent],
                    exports: [DropZoneComponent],
                },] }
    ];
    return DropZoneModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/drop-zone/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/editor/editor.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditorComponent = /** @class */ (function () {
    function EditorComponent() {
        this.onChangeHandler = new EventEmitter();
        this.editor = ClassicEditor;
        if (!this.paragraph) {
            this.paragraph = stringConstants.DEFAULT_CK_EDITOR_TEXT;
        }
        this.className = stringConstants.DEFAULT_EDITOR_CLASSNAME + this.className
            || stringConstants.DEFAULT_EDITOR_CLASSNAME;
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    EditorComponent.prototype.onChange = /**
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var editor = _a.editor;
        /** @type {?} */
        var data = editor.getData();
        this.onChangeHandler.emit(data);
    };
    EditorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-editor',
                    template: "<div class=\"{{className}}\">\n  <ckeditor [disabled]=\"isDisabled\" [editor]=\"editor\" data=\"{{paragraph}}\" (change)=\"onChange($event)\"></ckeditor>\n</div>"
                }] }
    ];
    /** @nocollapse */
    EditorComponent.ctorParameters = function () { return []; };
    EditorComponent.propDecorators = {
        className: [{ type: Input }],
        paragraph: [{ type: Input }],
        isDisabled: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return EditorComponent;
}());
if (false) {
    /** @type {?} */
    EditorComponent.prototype.className;
    /** @type {?} */
    EditorComponent.prototype.paragraph;
    /** @type {?} */
    EditorComponent.prototype.isDisabled;
    /** @type {?} */
    EditorComponent.prototype.onChangeHandler;
    /** @type {?} */
    EditorComponent.prototype.editor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/editor/editor.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditorModule = /** @class */ (function () {
    function EditorModule() {
    }
    EditorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, CKEditorModule],
                    declarations: [EditorComponent],
                    exports: [EditorComponent],
                },] }
    ];
    return EditorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/editor/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-time-picker/date-time-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateTimePickerComponent = /** @class */ (function () {
    function DateTimePickerComponent() {
        this.onDateChangeHandler = new EventEmitter();
        this.pickerType = 'both';
        this.isRequired = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    DateTimePickerComponent.prototype.changed = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onDateChangeHandler.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DateTimePickerComponent.prototype.restrictEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
    };
    DateTimePickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-date-time-picker',
                    template: "<div [formGroup]=\"parentForm\" class=\"date-time-picker\">\n  <mat-form-field>\n    <input matInput [required]=\"isRequired\" [owlDateTime]=\"dt1\" [owlDateTimeTrigger]=\"dt1\" [placeholder]=\"placeholder\"\n      [formControlName]=\"formFieldName\" [min]=\"min\" [max]=\"max\" (dateTimeChange)=\"changed($event)\" (keypress)=\"restrictEvent($event)\">\n    <span [owlDateTimeTrigger]=\"dt1\" class=\"add-date\">\n      <itb-square-button [iconClassName]=\"'add-date'\" [className]=\"'btn-square-lg'\">\n      </itb-square-button>\n    </span>\n    <owl-date-time [pickerType]=\"pickerType\" [showSecondsTimer]=\"true\" [hour12Timer]=\"hourFormate\" #dt1></owl-date-time>\n  </mat-form-field>\n</div>"
                }] }
    ];
    /** @nocollapse */
    DateTimePickerComponent.ctorParameters = function () { return []; };
    DateTimePickerComponent.propDecorators = {
        hourFormate: [{ type: Input }],
        placeholder: [{ type: Input }],
        parentForm: [{ type: Input }],
        formFieldName: [{ type: Input }],
        dateFormat: [{ type: Input }],
        min: [{ type: Input }],
        max: [{ type: Input }],
        pickerType: [{ type: Input }],
        isRequired: [{ type: Input }],
        onDateChangeHandler: [{ type: Output }]
    };
    return DateTimePickerComponent;
}());
if (false) {
    /** @type {?} */
    DateTimePickerComponent.prototype.hourFormate;
    /** @type {?} */
    DateTimePickerComponent.prototype.placeholder;
    /** @type {?} */
    DateTimePickerComponent.prototype.parentForm;
    /** @type {?} */
    DateTimePickerComponent.prototype.formFieldName;
    /** @type {?} */
    DateTimePickerComponent.prototype.dateFormat;
    /** @type {?} */
    DateTimePickerComponent.prototype.min;
    /** @type {?} */
    DateTimePickerComponent.prototype.max;
    /** @type {?} */
    DateTimePickerComponent.prototype.pickerType;
    /** @type {?} */
    DateTimePickerComponent.prototype.isRequired;
    /** @type {?} */
    DateTimePickerComponent.prototype.onDateChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-time-picker/date-time-picker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CUSTOM_FORMATS = {
    fullPickerInput: { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' },
    datePickerInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
    timePickerInput: { hour: 'numeric', minute: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
};
var DateTimePickerModule = /** @class */ (function () {
    function DateTimePickerModule() {
    }
    DateTimePickerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        MatFormFieldModule$1,
                        MatInputModule$1,
                        OwlDateTimeModule,
                        OwlNativeDateTimeModule,
                        SquareButtonModule,
                    ],
                    declarations: [DateTimePickerComponent],
                    exports: [DateTimePickerComponent],
                    providers: [{ provide: OWL_DATE_TIME_FORMATS, useValue: CUSTOM_FORMATS }],
                },] }
    ];
    return DateTimePickerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/date-time-picker/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/input-with-flag/input-with-flag.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputWithFlagComponent = /** @class */ (function () {
    function InputWithFlagComponent() {
        var _this = this;
        this.changedCountryHandler = new EventEmitter();
        this.onChangeHandler = new EventEmitter();
        this.countryForm = new FormControl();
        this.changeEvent = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.value = event.target.value;
            _this.updateCountryFlag();
        });
        this.restrictAlphabets = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var pattern = /[0-9\+\-\ ]/;
            /** @type {?} */
            var inputChar = event.key;
            if (!pattern.test(inputChar)) {
                event.preventDefault();
            }
            else {
                _this.value = event.target.value;
                _this.updateCountryFlag();
            }
        });
        this.prefix = '+1';
        this.selectedIndex = 185;
        this.value = this.value || '';
    }
    /**
     * @param {?} event
     * @return {?}
     */
    InputWithFlagComponent.prototype.onSelectedOption = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.selectedIndex = event.value;
        if (this.prefix !== this.countries[parseInt(event.value)].prefix) {
            // tslint:disable-next-line: prefer-conditional-expression
            if (this.prefix && !this.value.includes(this.prefix))
                this.value = this.countries[parseInt(event.value)].prefix + this.value;
            else
                this.value = this.value.replace(this.prefix, this.countries[parseInt(event.value)].prefix);
        }
        this.prefix = this.countries[parseInt(event.value)].prefix;
    };
    /**
     * @return {?}
     */
    InputWithFlagComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.countries = [];
        this.generateCountries();
        this.countries = this.countries.slice();
        this.selectedItem = this.countries[0];
        this.prefix = '';
        // tslint:disable-next-line: prefer-for-of
        this.updateCountryFlag();
        if (this.prefix === '') {
            this.prefix = '+1';
            this.selectedIndex = 185;
        }
    };
    /**
     * @param {?} o1
     * @return {?}
     */
    InputWithFlagComponent.prototype.compareFunction = /**
     * @param {?} o1
     * @return {?}
     */
    function (o1) {
        if (o1.name === 'United States of America')
            return true;
    };
    /**
     * @return {?}
     */
    InputWithFlagComponent.prototype.updateCountryFlag = /**
     * @return {?}
     */
    function () {
        if (!this.value || this.value === undefined)
            this.value = '';
        if (this.value.startsWith('+1')) {
            this.prefix = '+1';
            this.selectedIndex = 185;
            return;
        }
        for (var i = 0; i < this.countries.length; i++) {
            if (this.value.startsWith(this.countries[i].prefix)) {
                if (this.prefix.length <= this.countries[i].prefix.length || !this.value.startsWith(this.prefix)) {
                    this.prefix = this.countries[i].prefix;
                    this.selectedIndex = i;
                }
            }
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputWithFlagComponent.prototype.country = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.changedCountryHandler.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputWithFlagComponent.prototype.changer = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onChangeHandler.emit(event.target.value);
    };
    /**
     * @return {?}
     */
    InputWithFlagComponent.prototype.onBlur = /**
     * @return {?}
     */
    function () {
        if (this.parentForm.get(this.formFieldName).status === 'INVALID')
            // tslint:disable-next-line: no-string-literal
            document.querySelectorAll("." + this.className + " input")[0]['value'] = '';
    };
    /**
     * @return {?}
     */
    InputWithFlagComponent.prototype.getFlagPosition = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line: restrict-plus-operands
        return { 'background-position': 100 + 'px' };
    };
    /**
     * @return {?}
     */
    InputWithFlagComponent.prototype.generateCountries = /**
     * @return {?}
     */
    function () {
        this.countries.push({ name: 'Afghanistan', prefix: '+93' });
        this.countries.push({ name: 'Albania', prefix: '+355' });
        this.countries.push({ name: 'Algeria', prefix: '+213' });
        this.countries.push({ name: 'Andorra', prefix: '+376' });
        this.countries.push({ name: 'Angola', prefix: '+244' });
        this.countries.push({ name: 'Antigua & Barbuda', prefix: '+1268' });
        this.countries.push({ name: 'Antartica', prefix: '+672' });
        this.countries.push({ name: 'Argentina', prefix: '+54' });
        this.countries.push({ name: 'Armenia', prefix: '+374' });
        this.countries.push({ name: 'Aruba', prefix: '+297' });
        this.countries.push({ name: 'Australia', prefix: '+61' });
        this.countries.push({ name: 'Austria', prefix: '+43' });
        this.countries.push({ name: 'Azerbaijan', prefix: '+994' });
        this.countries.push({ name: 'Bahamas', prefix: '+1242' });
        this.countries.push({ name: 'Bahrain', prefix: '+973' });
        this.countries.push({ name: 'Bangladesh', prefix: '+880' });
        this.countries.push({ name: 'Barbados', prefix: '+1246' });
        this.countries.push({ name: 'Belarus', prefix: '+375' });
        this.countries.push({ name: 'Belgium', prefix: '+32' });
        this.countries.push({ name: 'Belize', prefix: '+501' });
        this.countries.push({ name: 'Benin', prefix: '+229' });
        this.countries.push({ name: 'Bhutan', prefix: '+975' });
        this.countries.push({ name: 'Bolivia', prefix: '+591' });
        this.countries.push({ name: 'Bosnia Herzegovina', prefix: '+387' });
        this.countries.push({ name: 'Botswana', prefix: '+267' });
        this.countries.push({ name: 'Brazil', prefix: '+55' });
        this.countries.push({ name: 'Brunei', prefix: '+673' });
        this.countries.push({ name: 'Bulgaria', prefix: '+359' });
        this.countries.push({ name: 'Burkina', prefix: '+226' });
        this.countries.push({ name: 'Burundi', prefix: '+257' });
        this.countries.push({ name: 'Cambodia', prefix: '+855' });
        this.countries.push({ name: 'Cameroon', prefix: '+237' });
        this.countries.push({ name: 'Canada', prefix: '+1' });
        this.countries.push({ name: 'Cape Verde', prefix: '+238' });
        this.countries.push({ name: 'Central African Rep', prefix: '+236' });
        this.countries.push({ name: 'Chad', prefix: '+235' });
        this.countries.push({ name: 'Chile', prefix: '+56' });
        this.countries.push({ name: 'China', prefix: '+86' });
        this.countries.push({ name: 'Colombia', prefix: '+57' });
        this.countries.push({ name: 'Comoros', prefix: '+269' });
        this.countries.push({ name: 'Congo', prefix: '+242' });
        this.countries.push({ name: 'Costa Rica', prefix: '+506' });
        this.countries.push({ name: 'Cote divoire', prefix: '+225' });
        this.countries.push({ name: 'Croatia', prefix: '+385' });
        this.countries.push({ name: 'Cuba', prefix: '+53' });
        this.countries.push({ name: 'Cyprus', prefix: '+357' });
        this.countries.push({ name: 'Czech Republic', prefix: '+420' });
        this.countries.push({ name: 'Democratic Republic of Congo', prefix: '+243' });
        this.countries.push({ name: 'Denmark', prefix: '+45' });
        this.countries.push({ name: 'Djibouti', prefix: '+253' });
        this.countries.push({ name: 'Dominica', prefix: '+1767' });
        this.countries.push({ name: 'Dominican Republic', prefix: '+1809' });
        this.countries.push({ name: 'East Timor', prefix: '+670' });
        this.countries.push({ name: 'Egypt', prefix: '+20' });
        this.countries.push({ name: 'Ecuador', prefix: '+593' });
        this.countries.push({ name: 'El Salvador', prefix: '+503' });
        this.countries.push({ name: 'Equatorial Guinea', prefix: '+240' });
        this.countries.push({ name: 'Eritrea', prefix: '+291' });
        this.countries.push({ name: 'Estonia', prefix: '+372' });
        this.countries.push({ name: 'Ethiopia', prefix: '+251' });
        this.countries.push({ name: 'Federated States of Micronesia', prefix: '+691' });
        this.countries.push({ name: 'Fiji', prefix: '+679' });
        this.countries.push({ name: 'Finland', prefix: '+358' });
        this.countries.push({ name: 'France', prefix: '+33' });
        this.countries.push({ name: 'Gabon', prefix: '+241' });
        this.countries.push({ name: 'Gambia', prefix: '+220' });
        this.countries.push({ name: 'Georgia', prefix: '+995' });
        this.countries.push({ name: 'Germany', prefix: '+49' });
        this.countries.push({ name: 'Ghana', prefix: '+233' });
        this.countries.push({ name: 'Greece', prefix: '+30' });
        this.countries.push({ name: 'Grenada', prefix: '+1473' });
        this.countries.push({ name: 'Guatemala', prefix: '+502' });
        this.countries.push({ name: 'Guinea-Bissau', prefix: '+245' });
        this.countries.push({ name: 'Guinea', prefix: '+224' });
        this.countries.push({ name: 'Guyana', prefix: '+592' });
        this.countries.push({ name: 'Haiti', prefix: '+509' });
        this.countries.push({ name: 'Honduras', prefix: '+504' });
        this.countries.push({ name: 'Hungary', prefix: '+36' });
        this.countries.push({ name: 'Iceland', prefix: '+354' });
        this.countries.push({ name: 'India', prefix: '+91' });
        this.countries.push({ name: 'Indonesia', prefix: '+62' });
        this.countries.push({ name: 'Iran', prefix: '+98' });
        this.countries.push({ name: 'Iraq', prefix: '+964' });
        this.countries.push({ name: 'Ireland', prefix: '+353' });
        this.countries.push({ name: 'Israel', prefix: '+972' });
        this.countries.push({ name: 'Italy', prefix: '+39' });
        this.countries.push({ name: 'Jamaica', prefix: '+1876' });
        this.countries.push({ name: 'Japan', prefix: '+81' });
        this.countries.push({ name: 'Jordan', prefix: '+962' });
        this.countries.push({ name: 'Kazakhstan', prefix: '+7' });
        this.countries.push({ name: 'Kenya', prefix: '+254' });
        this.countries.push({ name: 'Kiribati', prefix: '+686' });
        this.countries.push({ name: 'Kuwait', prefix: '+965' });
        this.countries.push({ name: 'Kyrgyzstan', prefix: '+996' });
        this.countries.push({ name: 'Laos', prefix: '+856' });
        this.countries.push({ name: 'Latvia', prefix: '+371' });
        this.countries.push({ name: 'Lebanon', prefix: '+961' });
        this.countries.push({ name: 'Lesotho', prefix: '+266' });
        this.countries.push({ name: 'Liberia', prefix: '+231' });
        this.countries.push({ name: 'Libya', prefix: '+218' });
        this.countries.push({ name: 'Liechtenstein', prefix: '+423' });
        this.countries.push({ name: 'Lithuania', prefix: '+370' });
        this.countries.push({ name: 'Luxembourg', prefix: '+352' });
        this.countries.push({ name: 'Macedonia', prefix: '+389' });
        this.countries.push({ name: 'Madagascar', prefix: '+261' });
        this.countries.push({ name: 'Malawi', prefix: '+265' });
        this.countries.push({ name: 'Malaysia', prefix: '+60' });
        this.countries.push({ name: 'Maldives', prefix: '+960' });
        this.countries.push({ name: 'Mali', prefix: '+223' });
        this.countries.push({ name: 'Malta', prefix: '+356' });
        this.countries.push({ name: 'Marshall Islands', prefix: '+692' });
        this.countries.push({ name: 'Mauritania', prefix: '+222' });
        this.countries.push({ name: 'Mauritius', prefix: '+230' });
        this.countries.push({ name: 'Mexico', prefix: '+52' });
        this.countries.push({ name: 'Moldova', prefix: '+373' });
        this.countries.push({ name: 'Monaco', prefix: '+377' });
        this.countries.push({ name: 'Mongolia', prefix: '+976' });
        this.countries.push({ name: 'Montenegro', prefix: '+382' });
        this.countries.push({ name: 'Morocco', prefix: '+212' });
        this.countries.push({ name: 'Mozambique', prefix: '+258' });
        this.countries.push({ name: 'Myanmar', prefix: '+95' });
        this.countries.push({ name: 'Namibia', prefix: '+264' });
        this.countries.push({ name: 'Nauru', prefix: '+674' });
        this.countries.push({ name: 'Nepal', prefix: '+977' });
        this.countries.push({ name: 'Netherlands', prefix: '+31' });
        this.countries.push({ name: 'New Zealand', prefix: '+64' });
        this.countries.push({ name: 'Nicaragua', prefix: '+505' });
        this.countries.push({ name: 'Niger', prefix: '+227' });
        this.countries.push({ name: 'Nigeria', prefix: '+234' });
        this.countries.push({ name: 'North Korea', prefix: '+850' });
        this.countries.push({ name: 'Norway', prefix: '+47' });
        this.countries.push({ name: 'Oman', prefix: '+968' });
        this.countries.push({ name: 'Pakistan', prefix: '+92' });
        this.countries.push({ name: 'Palau', prefix: '+680' });
        this.countries.push({ name: 'Papua New Guinea', prefix: '+675' });
        this.countries.push({ name: 'Paraguay', prefix: '+595' });
        this.countries.push({ name: 'Peru', prefix: '+51' });
        this.countries.push({ name: 'Philippines', prefix: '+63' });
        this.countries.push({ name: 'Poland', prefix: '+48' });
        this.countries.push({ name: 'Portugal', prefix: '+351' });
        this.countries.push({ name: 'Qatar', prefix: '+974' });
        this.countries.push({ name: 'Romania', prefix: '+40' });
        this.countries.push({ name: 'Russia', prefix: '+7' });
        this.countries.push({ name: 'Rwanda', prefix: '+250' });
        this.countries.push({ name: 'St Kitts & Nevis', prefix: '+1869' });
        this.countries.push({ name: 'St Lucia', prefix: '+1758' });
        this.countries.push({ name: 'Saint Vincent & the Grenadines', prefix: '+1784' });
        this.countries.push({ name: 'Samoa', prefix: '+685' });
        this.countries.push({ name: 'San Marino', prefix: '+378' });
        this.countries.push({ name: 'Sao Tome and Principe', prefix: '+239' });
        this.countries.push({ name: 'Saudi Arabia', prefix: '+966' });
        this.countries.push({ name: 'Senegal', prefix: '+221' });
        this.countries.push({ name: 'Serbia', prefix: '+381' });
        this.countries.push({ name: 'Seychelles', prefix: '+248' });
        this.countries.push({ name: 'Sierra Leone', prefix: '+232' });
        this.countries.push({ name: 'Singapore', prefix: '+65' });
        this.countries.push({ name: 'Slovakia', prefix: '+421' });
        this.countries.push({ name: 'Slovenia', prefix: '+386' });
        this.countries.push({ name: 'Solomon Islands', prefix: '+677' });
        this.countries.push({ name: 'Somalia', prefix: '+252' });
        this.countries.push({ name: 'South Africa', prefix: '+27' });
        this.countries.push({ name: 'South Korea', prefix: '+82' });
        this.countries.push({ name: 'South Sudan', prefix: '+211' });
        this.countries.push({ name: 'Spain', prefix: '+34' });
        this.countries.push({ name: 'Sri Lanka', prefix: '+94' });
        this.countries.push({ name: 'Sudan', prefix: '+249' });
        this.countries.push({ name: 'Suriname', prefix: '+597' });
        this.countries.push({ name: 'Swaziland', prefix: '+268' });
        this.countries.push({ name: 'Sweden', prefix: '+46' });
        this.countries.push({ name: 'Switzerland', prefix: '+41' });
        this.countries.push({ name: 'Syria', prefix: '+963' });
        this.countries.push({ name: 'Tajikistan', prefix: '+992' });
        this.countries.push({ name: 'Tanzania', prefix: '+255' });
        this.countries.push({ name: 'Thailand', prefix: '+66' });
        this.countries.push({ name: 'Togo', prefix: '+228' });
        this.countries.push({ name: 'Tonga', prefix: '+676' });
        this.countries.push({ name: 'Trinidad & Tobago', prefix: '+1868' });
        this.countries.push({ name: 'Tunisia', prefix: '+216' });
        this.countries.push({ name: 'Turkey', prefix: '+90' });
        this.countries.push({ name: 'Turkmenistan', prefix: '+993' });
        this.countries.push({ name: 'Tuvalu', prefix: '+688' });
        this.countries.push({ name: 'Uganda', prefix: '+256' });
        this.countries.push({ name: 'United Kingdom', prefix: '+44' });
        this.countries.push({ name: 'Ukraine', prefix: '+380' });
        this.countries.push({ name: 'United Arab Emirates', prefix: '+971' });
        this.countries.push({ name: 'United States of America', prefix: '+1' });
        this.countries.push({ name: 'Uruguay', prefix: '+598' });
        this.countries.push({ name: 'Uzbekistan', prefix: '+998' });
        this.countries.push({ name: 'Vanuatu', prefix: '+678' });
        this.countries.push({ name: 'Vatican City', prefix: '+39' });
        this.countries.push({ name: 'Venezuela', prefix: '+58' });
        this.countries.push({ name: 'Vietnam', prefix: '+84' });
        this.countries.push({ name: 'Yemen', prefix: '+967' });
        this.countries.push({ name: 'Zambia', prefix: '+260' });
        this.countries.push({ name: 'Zimbabwe', prefix: '+263' });
    };
    InputWithFlagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-input-with-flag',
                    template: "<div class=\"input-with-flag\" [formGroup]=\"parentForm\">\n  <div class=\"flag-input\">\n    <mat-form-field>\n      <mat-label>{{label}}</mat-label>\n      <span matPrefix>&nbsp;</span>\n      <input matInput [disabled]=\"isDisabled\" style=\"width:82%\" type=\"text\" maxlength=18 placeholder=\"+1(555)555-1234\" [value]=\"value\" (keyup)=\"changeEvent($event)\" (keypress)=\"restrictAlphabets($event)\" [formControlName]=\"formFieldName\">\n    </mat-form-field>\n    <div class=\"flag-selector\">\n      <mat-select (selectionChange)='onSelectedOption($event)' [compareWith]=\"compareFunction\" [disabled]=\"isDisabled\">\n        <mat-option *ngFor=\"let item of countries; let i = index\" [value]=\"i\">\n          <div class=\"flag-image\" [style.background-position-x.px]=\"-i*28\"></div>\n          <div class=\"flag-text\">{{ item.name }} {{item.prefix}} </div>\n        </mat-option>\n      </mat-select>\n      <div class=\"selected-flag-image\" [style.background-position-x.px]=\"-selectedIndex*28\"></div>\n    </div>\n  </div>\n\n\n</div>"
                }] }
    ];
    /** @nocollapse */
    InputWithFlagComponent.ctorParameters = function () { return []; };
    InputWithFlagComponent.propDecorators = {
        fieldName: [{ type: Input }],
        className: [{ type: Input }],
        label: [{ type: Input }],
        formFieldName: [{ type: Input }],
        parentForm: [{ type: Input }],
        isDisabled: [{ type: Input }],
        prefix: [{ type: Input }],
        value: [{ type: Input }],
        changedCountryHandler: [{ type: Output }],
        onChangeHandler: [{ type: Output }],
        selectedItem: [{ type: Input }]
    };
    return InputWithFlagComponent;
}());
if (false) {
    /** @type {?} */
    InputWithFlagComponent.prototype.fieldName;
    /** @type {?} */
    InputWithFlagComponent.prototype.className;
    /** @type {?} */
    InputWithFlagComponent.prototype.label;
    /** @type {?} */
    InputWithFlagComponent.prototype.formFieldName;
    /** @type {?} */
    InputWithFlagComponent.prototype.parentForm;
    /** @type {?} */
    InputWithFlagComponent.prototype.isDisabled;
    /** @type {?} */
    InputWithFlagComponent.prototype.prefix;
    /** @type {?} */
    InputWithFlagComponent.prototype.value;
    /** @type {?} */
    InputWithFlagComponent.prototype.changedCountryHandler;
    /** @type {?} */
    InputWithFlagComponent.prototype.onChangeHandler;
    /** @type {?} */
    InputWithFlagComponent.prototype.countries;
    /** @type {?} */
    InputWithFlagComponent.prototype.countryForm;
    /** @type {?} */
    InputWithFlagComponent.prototype.selectedIndex;
    /** @type {?} */
    InputWithFlagComponent.prototype.selectedItem;
    /** @type {?} */
    InputWithFlagComponent.prototype.changeEvent;
    /** @type {?} */
    InputWithFlagComponent.prototype.restrictAlphabets;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/input-with-flag/input-with-flag.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputWithFlagModule = /** @class */ (function () {
    function InputWithFlagModule() {
    }
    InputWithFlagModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatFormFieldModule$1,
                        FormsModule,
                        ReactiveFormsModule,
                        MatAutocompleteModule,
                        MatIconModule,
                        MatInputModule$1,
                        MatSelectModule,
                    ],
                    declarations: [InputWithFlagComponent],
                    exports: [InputWithFlagComponent],
                },] }
    ];
    return InputWithFlagModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/input-with-flag/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multi-select-chips/multi-select-chips.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiSelectChipsComponent = /** @class */ (function () {
    function MultiSelectChipsComponent() {
        this.deletedTags = [];
        this.dataCtrl = new FormControl();
        this.onRemoveHandler = new EventEmitter();
        this.onAddHandler = new EventEmitter();
        this.onChipClickHandler = new EventEmitter();
        this.warningTranquilizer = ElementRef;
        this.warningTranquilizer = MatAutocomplete;
    }
    /**
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.removable = true;
        this.selectable = true;
        this.addOnBlur = true;
        this.separatorKeysCodes = [ENTER, COMMA];
        if (!this.tags) {
            this.tags = [];
        }
        if (this.options) {
            this.filterData();
        }
    };
    /**
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.filterData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.filteredData = this.dataCtrl.valueChanges.pipe(startWith(undefined), map((/**
         * @param {?} fruit
         * @return {?}
         */
        function (fruit) {
            return fruit ? _this._filter(fruit) : _this.options.slice();
        })));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.add = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.value.length < 3) {
            return;
        }
        if (this.tags.length < this.tagsMaxLength) {
            if (!this.matAutocomplete.isOpen) {
                /** @type {?} */
                var input = event.input;
                /** @type {?} */
                var value = event.value;
                if ((value || '').trim()) {
                    if (this.enableBoth) {
                        /** @type {?} */
                        var find = this.tags.indexOf(value);
                        if (find === -1) {
                            this.duplicationMessage = '';
                            this.tags.push(value.trim());
                            this.onAddHandler.emit(this.tags);
                        }
                        else {
                            this.duplicationMessage = 'Search Tag with this name already exists';
                        }
                    }
                    else {
                        if (this.isSelectFromOtionOnly) {
                            /** @type {?} */
                            var find = this.options.indexOf(value);
                            if (find !== -1) {
                                this.tags.push(value.trim());
                                this.onAddHandler.emit(this.tags);
                                /** @type {?} */
                                var index = this.options.indexOf(value);
                            }
                        }
                        else {
                            /** @type {?} */
                            var find = this.tags.indexOf(value);
                            if (find === -1) {
                                this.duplicationMessage = '';
                                this.tags.push(value.trim());
                                this.onAddHandler.emit(this.tags);
                            }
                            else {
                                this.duplicationMessage = 'Search Tag with this name already exists';
                            }
                        }
                    }
                }
                if (input) {
                    input.value = '';
                }
                this.dataCtrl.setValue(undefined);
            }
        }
        if (this.tags.length === this.tagsMaxLength) {
            this.isReadOnly = true;
        }
        if (this.tags.length >= this.tagsMaxLength) {
            this.errorFlag = true;
        }
    };
    /**
     * @param {?} tag
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.remove = /**
     * @param {?} tag
     * @return {?}
     */
    function (tag) {
        /** @type {?} */
        var index = this.tags.indexOf(tag);
        if (index >= 0) {
            this.duplicationMessage = '';
            this.deletedTags.push(tag.trim());
            this.tags.splice(index, 1);
            this.options.push(tag.trim());
            this.filterData();
            this.onRemoveHandler.emit({
                tags: this.tags,
                deletedTags: this.deletedTags,
            });
        }
        if (this.tags.length < this.tagsMaxLength) {
            this.errorFlag = false;
            this.isReadOnly = false;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.selected = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var index = this.options.indexOf(event.option.viewValue);
        /** @type {?} */
        var alreadyExist = this.tags.indexOf(event.option.viewValue);
        if (this.isSelectFromOtionOnly) {
            if (index !== -1 && alreadyExist === -1) {
                if (this.tags.length < this.tagsMaxLength) {
                    this.tags.push(event.option.viewValue);
                    this.onAddHandler.emit(this.tags);
                    this.tagsInput.nativeElement.value = '';
                    this.dataCtrl.setValue(undefined);
                    this.options.splice(this.options.indexOf(event.option.viewValue), 1);
                    this.filterData();
                }
            }
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.onViewChipClick = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        // console.log("chip viewed")
        this.onChipClickHandler.emit(value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectChipsComponent.prototype.restrictEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.target.value.length >= 25) {
            if (window.getSelection().type === 'Range') {
                if (window.getSelection().toString().length >= 25) {
                    this.tagsInput.nativeElement.value = '';
                }
            }
            else {
                event.preventDefault();
            }
        }
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    MultiSelectChipsComponent.prototype._filter = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var filterValue = value.toLowerCase();
        return this.options.filter((/**
         * @param {?} fruit
         * @return {?}
         */
        function (fruit) { return fruit.toLowerCase().indexOf(filterValue) === 0; }));
    };
    MultiSelectChipsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-multi-select-chips',
                    template: "<mat-form-field class=\"example-chip-list itb-multiselect-chip\" [ngClass]=\"{'itb-multiselect-required':isRequired}\">\n  <mat-chip-list #chipList aria-label=\"Fruit selection\">\n    <ng-container *ngIf=\"!isDisabled\">\n    <mat-chip  *ngFor=\"let tags of tags\" [removable]=\"removable\" (removed)=\"remove(tags)\">\n      {{ tags }}\n      <!-- <mat-icon matChipRemove *ngIf=\"removable\">cancel</mat-icon> -->\n      <span matChipRemove *ngIf=\"removable\" class=\"chip-btn\"><itb-icon [className]=\"'cross icon-disabled'\" ></itb-icon></span>\n    </mat-chip>\n  </ng-container>\n  <ng-container *ngIf=\"isDisabled\">\n    <mat-chip  *ngFor=\"let tags of tags\" [removable]=\"removable\" (click)=\"onViewChipClick(tags)\">\n      {{ tags }}\n      <!-- <mat-icon matChipRemove *ngIf=\"removable\">cancel</mat-icon> -->\n      <!-- <span matChipRemove *ngIf=\"removable\" class=\"chip-btn\"><itb-icon [className]=\"'cross icon-disabled'\" ></itb-icon></span> -->\n    </mat-chip>\n  </ng-container>\n    <input [readonly]=\"isReadOnly\" #trigger=\"matAutocompleteTrigger\" [required]=\"isRequired\" [disabled]=\"isDisabled\" [placeholder]=\"placeholder\" #tagsInput [formControl]=\"dataCtrl\" [matAutocomplete]=\"auto\"\n      [matChipInputFor]=\"chipList\" [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n      [matChipInputAddOnBlur]=\"addOnBlur\" (matChipInputTokenEnd)=\"add($event)\" (keypress)=\"restrictEvent($event)\" />\n  </mat-chip-list>\n  <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\" #autoCompletePageList>\n    <mat-option *ngFor=\"let tags of filteredData | async\" [value]=\"tags\" (click)=\"$event.stopPropagation(); trigger.openPanel()\">\n      {{ tags }}\n    </mat-option>\n  </mat-autocomplete>\n</mat-form-field>\n<itb-info-message *ngIf=\"errorFlag\" [className]=\"'info-danger'\" [text]=\"'Maximum '+tagsMaxLength+' tags allowed'\"></itb-info-message>\n<itb-info-message [className]=\"'info-danger'\" [text]=\"duplicationMessage\"></itb-info-message>"
                }] }
    ];
    /** @nocollapse */
    MultiSelectChipsComponent.ctorParameters = function () { return []; };
    MultiSelectChipsComponent.propDecorators = {
        enableBoth: [{ type: Input }],
        tags: [{ type: Input }],
        tagsInput: [{ type: ViewChild, args: ['tagsInput', { static: false },] }],
        matAutocomplete: [{ type: ViewChild, args: ['auto', { static: false },] }],
        isSelectFromOtionOnly: [{ type: Input }],
        onRemoveHandler: [{ type: Output }],
        onAddHandler: [{ type: Output }],
        tagsMaxLength: [{ type: Input }],
        options: [{ type: Input }],
        isDisabled: [{ type: Input }],
        placeholder: [{ type: Input }],
        isRequired: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        onChipClickHandler: [{ type: Output }]
    };
    return MultiSelectChipsComponent;
}());
if (false) {
    /** @type {?} */
    MultiSelectChipsComponent.prototype.enableBoth;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.deletedTags;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.removable;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.selectable;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.addOnBlur;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.dataCtrl;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.filteredData;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.separatorKeysCodes;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.tags;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.tagsInput;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.matAutocomplete;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.isSelectFromOtionOnly;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.onRemoveHandler;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.onAddHandler;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.tagsMaxLength;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.options;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.isDisabled;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.placeholder;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.isRequired;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.isReadOnly;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.onChipClickHandler;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.errorFlag;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.duplicationMessage;
    /** @type {?} */
    MultiSelectChipsComponent.prototype.warningTranquilizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multi-select-chips/multi-select-chips.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiSelectChipsModule = /** @class */ (function () {
    function MultiSelectChipsModule() {
    }
    MultiSelectChipsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        MatIconModule$1,
                        CKEditorModule,
                        MatChipsModule,
                        MatAutocompleteModule$1,
                        MatFormFieldModule,
                        IconModule,
                        InfoMessageModule,
                    ],
                    declarations: [MultiSelectChipsComponent],
                    exports: [MultiSelectChipsComponent],
                },] }
    ];
    return MultiSelectChipsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multi-select-chips/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox-with-divider/checkbox-with-divider.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxWithDividerComponent = /** @class */ (function () {
    function CheckboxWithDividerComponent() {
        this.onChangeHandler = new EventEmitter();
        this.isReactive = true;
        this.isDisabled = false;
    }
    /**
     * Emits a value either true/false on selecting/unselecting a checkbox.
     * @param change The value to emit.
     */
    /**
     * Emits a value either true/false on selecting/unselecting a checkbox.
     * @param {?} change The value to emit.
     * @return {?}
     */
    CheckboxWithDividerComponent.prototype.changeEvent = /**
     * Emits a value either true/false on selecting/unselecting a checkbox.
     * @param {?} change The value to emit.
     * @return {?}
     */
    function (change) {
        this.onChangeHandler.emit(change);
    };
    CheckboxWithDividerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-checkbox-with-divider',
                    template: "<div *ngIf=\"isReactive\" class=\"itb-divider-checkbox\" [formGroup]=\"parentForm\">\n  <mat-checkbox\n    [labelPosition]=\"position\"\n    [formControlName]=\"formFieldName\"\n    [checked]=\"isChecked\"\n    (change)=\"changeEvent($event)\"\n  >\n    {{ label }}\n  </mat-checkbox>\n  <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n\n<div *ngIf=\"!isReactive\" class=\"itb-divider-checkbox\">\n  <mat-checkbox\n    [labelPosition]=\"position\"\n    [checked]=\"isChecked\"\n    [disabled]=\"isDisabled\"\n    (change)=\"changeEvent($event)\"\n  >\n    {{ label }}\n  </mat-checkbox>\n  <itb-divider [className]=\"'mat-divider'\"></itb-divider>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CheckboxWithDividerComponent.ctorParameters = function () { return []; };
    CheckboxWithDividerComponent.propDecorators = {
        label: [{ type: Input }],
        isChecked: [{ type: Input }],
        className: [{ type: Input }],
        formFieldName: [{ type: Input }],
        position: [{ type: Input }],
        parentForm: [{ type: Input }],
        isReactive: [{ type: Input }],
        isDisabled: [{ type: Input }],
        onChangeHandler: [{ type: Output }]
    };
    return CheckboxWithDividerComponent;
}());
if (false) {
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.label;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.isChecked;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.className;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.formFieldName;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.position;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.parentForm;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.isReactive;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.isDisabled;
    /** @type {?} */
    CheckboxWithDividerComponent.prototype.onChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox-with-divider/checkbox-with-divider.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxWithDividerModule = /** @class */ (function () {
    function CheckboxWithDividerModule() {
    }
    CheckboxWithDividerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatCheckboxModule,
                        ReactiveFormsModule,
                        DividerModule,
                    ],
                    declarations: [CheckboxWithDividerComponent],
                    exports: [CheckboxWithDividerComponent],
                },] }
    ];
    return CheckboxWithDividerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/checkbox-with-divider/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multiselect-chip-object/multiselect-chip-object.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiselectChipObjectComponent = /** @class */ (function () {
    function MultiselectChipObjectComponent() {
        this.visible = true;
        this.selectable = true;
        this.onChangeHandler = new EventEmitter();
        this.onRemoveHandler = new EventEmitter();
        this.onClickHandler = new EventEmitter();
        this.removable = true;
        this.addOnBlur = true;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.fruits = [];
        if (!this.addedTags)
            this.addedTags = [];
        this.warningTranquilizer = MatAutocomplete$1;
    }
    /**
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.parentForm) {
            this.parentForm = new FormGroup({
                formFieldName: new FormControl(this.addedTags),
            });
        }
        this.addedTags.forEach((/**
         * @param {?} addedTag
         * @return {?}
         */
        function (addedTag) {
            /** @type {?} */
            var find = _this.objectOfTags.find((/**
             * @param {?} objectOfTags
             * @return {?}
             */
            function (objectOfTags) { return objectOfTags.id === addedTag.id; }));
            if (find) {
                _this.objectOfTags = _this.objectOfTags.filter((/**
                 * @param {?} objectOfTags
                 * @return {?}
                 */
                function (objectOfTags) { return objectOfTags.id !== find.id; }));
            }
        }));
    };
    /**
     * @param {?} e
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.ngOnChanges = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _a;
        if (this.parentForm && e.addedTags && e.addedTags.currentValue) {
            this.parentForm.patchValue((_a = {},
                _a[this.formFieldName] = e.addedTags.currentValue,
                _a));
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.add = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.isSelectFromOptionOnly) {
            // Add fruit only when MatAutocomplete is not open
            // To make sure this does not conflict with OptionSelected Event
            if (!this.matAutocomplete.isOpen) {
                /** @type {?} */
                var input = event.input;
                /** @type {?} */
                var value = event.value
                // Add our fruit
                ;
                // Add our fruit
                if ((value || '').trim()) {
                    this.fruits.push(value.trim());
                }
                // Reset the input value
                if (input) {
                    input.value = '';
                }
            }
        }
    };
    /**
     * @param {?} addedTags
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.remove = /**
     * @param {?} addedTags
     * @return {?}
     */
    function (addedTags) {
        /** @type {?} */
        var index = this.addedTags.indexOf(addedTags);
        if (index >= 0) {
            this.addedTags.splice(index, 1);
            /** @type {?} */
            var find = this.objectOfTags.find((/**
             * @param {?} objectOfTags
             * @return {?}
             */
            function (objectOfTags) { return objectOfTags.id === addedTags.id; }));
            if (!find) {
                this.objectOfTags.push(addedTags);
            }
            if (this.formFieldName !== undefined) {
                this.parentForm.controls.name.setValue(this.addedTags);
            }
        }
        this.onChangeHandler.emit(this.addedTags);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.selected = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _a;
        /** @type {?} */
        var value = event.option.value;
        /** @type {?} */
        var find = this.addedTags.find((/**
         * @param {?} addedTags
         * @return {?}
         */
        function (addedTags) { return addedTags.id === value.id; }));
        if (!find) {
            this.addedTags.push(value);
            // tslint:disable-next-line: no-shadowed-variable
            /** @type {?} */
            var find_1 = this.objectOfTags.find((/**
             * @param {?} objectOfTags
             * @return {?}
             */
            function (objectOfTags) { return objectOfTags.id === value.id; }));
            if (find_1) {
                this.objectOfTags = this.objectOfTags.filter((/**
                 * @param {?} objectOfTags
                 * @return {?}
                 */
                function (objectOfTags) { return objectOfTags.id !== find_1.id; }));
            }
            this.onChangeHandler.emit(this.addedTags);
            if (this.formFieldName !== undefined) {
                this.parentForm.patchValue((_a = {},
                    _a[this.formFieldName] = this.addedTags,
                    _a));
            }
        }
        this.fruitInput.nativeElement.value = '';
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.changeSelected = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onClickHandler.emit(event);
    };
    /**
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype.onRemove = /**
     * @return {?}
     */
    function () {
        this.onRemoveHandler.emit();
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    MultiselectChipObjectComponent.prototype._filter = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var filterValue = value.toLowerCase();
        return this.objectOfTags.filter((/**
         * @param {?} fruit
         * @return {?}
         */
        function (fruit) { return fruit.toLowerCase().indexOf(filterValue) === 0; }));
    };
    MultiselectChipObjectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-multiselect-chip-object',
                    template: "<mat-form-field class=\"example-chip-list itb-multiselect-chiplist\" [ngClass]=\"{'itb-multiselect-required':isRequired}\">\n\t<mat-chip-list #chipList aria-label=\"Fruit selection\">\n\t\t<mat-chip *ngFor=\"let addedTags of addedTags\" [selectable]=\"selectable\" [removable]=\"removable\"\n\t\t\t(removed)=\"remove(addedTags)\" (click)=\"changeSelected(addedTags)\">\n\t\t\t{{ addedTags.tagName || addedTags.name}}\n\t\t\t<!-- <mat-icon  matChipRemove *ngIf=\"removable\">cancel</mat-icon> -->\n\t\t\t<itb-icon matChipRemove *ngIf=\"removable\" [className]=\"'icon-white cross'\" (click)=\"onRemove()\"></itb-icon>\n\t\t</mat-chip>\n\t\t<div [formGroup]=\"parentForm\" class=\"input-dropdown\">\n\t\t\t<input [required]=\"isRequired\" #trigger=\"matAutocompleteTrigger\" [disabled]=\"!removable ? true : false\"\n\t\t\t\tplaceholder=\"{{ placeHolder }}\" #fruitInput [formControlName]=\"\n\t\t\t\t\tformFieldName !== undefined ? formFieldName : 'formFieldName'\n\t\t\t\t\" [matAutocomplete]=\"auto\" [matChipInputFor]=\"chipList\" [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n\t\t\t\t[matChipInputAddOnBlur]=\"addOnBlur\" (matChipInputTokenEnd)=\"add($event)\" />\n\t\t</div>\n\t</mat-chip-list>\n\t<mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n\t\t<mat-option *ngFor=\"let fruit of objectOfTags\" [value]=\"fruit\"\n\t\t\t(click)=\"$event.stopPropagation(); trigger.openPanel()\">\n\t\t\t{{ fruit.tagName || fruit.name }}\n\t\t</mat-option>\n\t</mat-autocomplete>\n</mat-form-field>\n\n<!-- Copyright 2019 Google LLC. All Rights Reserved.\n    Use of this source code is governed by an MIT-style license that\n    can be found in the LICENSE file at http://angular.io/license -->"
                }] }
    ];
    /** @nocollapse */
    MultiselectChipObjectComponent.ctorParameters = function () { return []; };
    MultiselectChipObjectComponent.propDecorators = {
        parentForm: [{ type: Input }],
        onChangeHandler: [{ type: Output }],
        onRemoveHandler: [{ type: Output }],
        onClickHandler: [{ type: Output }],
        formFieldName: [{ type: Input }],
        removable: [{ type: Input }],
        placeHolder: [{ type: Input }],
        isSelectFromOptionOnly: [{ type: Input }],
        objectOfTags: [{ type: Input }],
        addedTags: [{ type: Input }],
        isRequired: [{ type: Input }],
        fruitInput: [{ type: ViewChild, args: ['fruitInput', { static: false },] }],
        matAutocomplete: [{ type: ViewChild, args: ['auto', { static: false },] }]
    };
    return MultiselectChipObjectComponent;
}());
if (false) {
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.visible;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.selectable;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.parentForm;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.onChangeHandler;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.onRemoveHandler;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.onClickHandler;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.formFieldName;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.removable;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.addOnBlur;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.separatorKeysCodes;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.placeHolder;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.fruits;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.isSelectFromOptionOnly;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.objectOfTags;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.addedTags;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.isRequired;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.myForm;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.fruitInput;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.matAutocomplete;
    /** @type {?} */
    MultiselectChipObjectComponent.prototype.warningTranquilizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multiselect-chip-object/multiselect-chip-object.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiSelectChipsObjectModule = /** @class */ (function () {
    function MultiSelectChipsObjectModule() {
    }
    MultiSelectChipsObjectModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        MatIconModule$1,
                        CKEditorModule,
                        MatChipsModule,
                        MatAutocompleteModule$1,
                        MatFormFieldModule,
                        IconModule,
                    ],
                    declarations: [MultiselectChipObjectComponent],
                    exports: [MultiselectChipObjectComponent],
                },] }
    ];
    return MultiSelectChipsObjectModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multiselect-chip-object/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multi-select-dropdown/multi-select-dropdown.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiSelectDropdownComponent = /** @class */ (function () {
    function MultiSelectDropdownComponent() {
        this.onDeSelect = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.isSorted = false;
        this.isMultiple = true;
    }
    /**
     * @return {?}
     */
    MultiSelectDropdownComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.settings && this.settings.singleSelection)
            this.isMultiple = false;
        if (this.options && this.selectedOptions) {
            this.options.map((/**
             * @param {?} option
             * @return {?}
             */
            function (option) {
                _this.selectedOptions.forEach((/**
                 * @param {?} selected
                 * @return {?}
                 */
                function (selected) {
                    selected.item_text === option.item_text ? option.isSelected = true : option.isSelected = false;
                }));
            }));
        }
        if (this.options && this.isSorted && this.isMultiple) {
            // tslint:disable-next-line: no-unbound-method
            this.options.sort(this.sortByAlphabet).sort(this.sortByChecked);
        }
        if (this.options && this.isSorted && !this.isMultiple) {
            // tslint:disable-next-line: no-unbound-method
            this.options.sort(this.sortByAlphabet);
        }
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    MultiSelectDropdownComponent.prototype.sortByAlphabet = /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (a, b) {
        /** @type {?} */
        var first;
        /** @type {?} */
        var second;
        if (a.item_text && b.item_text) {
            first = a.item_text.toLowerCase();
            second = b.item_text.toLowerCase();
        }
        else if (a.name && b.name) {
            first = a.name.toLowerCase();
            second = b.name.toLowerCase();
        }
        /** @type {?} */
        var comparison = 0;
        if (first < second) {
            comparison = -1;
        }
        else if (first > second) {
            comparison = 1;
        }
        return comparison;
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    MultiSelectDropdownComponent.prototype.sortByChecked = /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (a, b) {
        /** @type {?} */
        var first = a.isSelected;
        /** @type {?} */
        var second = b.isSelected;
        /** @type {?} */
        var comparison = 0;
        if (first > second) {
            comparison = -1;
        }
        else if (first < second) {
            comparison = 1;
        }
        return comparison;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectDropdownComponent.prototype.onSelectOption = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.options.map((/**
         * @param {?} option
         * @return {?}
         */
        function (option) {
            if (option.item_text === event.item_text)
                option.isSelected = true;
        }));
        this.onSelect.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectDropdownComponent.prototype.onDeselectOption = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.options.map((/**
         * @param {?} option
         * @return {?}
         */
        function (option) {
            if (option.item_text === event.item_text)
                option.isSelected = false;
        }));
        this.onDeSelect.emit(event);
    };
    MultiSelectDropdownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-multi-select-dropdown',
                    template: "<ng-multiselect-dropdown\n\t[ngStyle]=\"{'pointer-events': isDisabled ? 'none' : ''}\"\n\t[placeholder]=\"placeholder\"\n\t[data]=\"options\"\n\t[(ngModel)]=\"selectedOptions\"\n\t[settings]=\"settings\"\n\t[disabled]=\"isDisabled\"\n\t(onSelect)=\"onSelectOption($event)\"\n\t(onDeSelect)=\"onDeselectOption($event)\"\n>\n</ng-multiselect-dropdown>\n"
                }] }
    ];
    /** @nocollapse */
    MultiSelectDropdownComponent.ctorParameters = function () { return []; };
    MultiSelectDropdownComponent.propDecorators = {
        placeholder: [{ type: Input }],
        settings: [{ type: Input }],
        options: [{ type: Input }],
        selectedOptions: [{ type: Input }],
        isSorted: [{ type: Input }],
        isDisabled: [{ type: Input }],
        onDeSelect: [{ type: Output }],
        onSelect: [{ type: Output }]
    };
    return MultiSelectDropdownComponent;
}());
if (false) {
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.placeholder;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.settings;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.options;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.selectedOptions;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.isSorted;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.isDisabled;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.onDeSelect;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.onSelect;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.isMultiple;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multi-select-dropdown/multi-select-dropdown.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiSelectDropDownModule = /** @class */ (function () {
    function MultiSelectDropDownModule() {
    }
    MultiSelectDropDownModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        NgMultiSelectDropDownModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    declarations: [MultiSelectDropdownComponent],
                    exports: [MultiSelectDropdownComponent],
                },] }
    ];
    return MultiSelectDropDownModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/multi-select-dropdown/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/infinite-select/infinite-select.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ISelectItem() { }
if (false) {
    /** @type {?} */
    ISelectItem.prototype.title;
    /** @type {?} */
    ISelectItem.prototype.id;
}
/**
 * @record
 */
function ISelectGroup() { }
if (false) {
    /** @type {?|undefined} */
    ISelectGroup.prototype.isDisabled;
    /** @type {?} */
    ISelectGroup.prototype.title;
    /** @type {?} */
    ISelectGroup.prototype.options;
    /** @type {?} */
    ISelectGroup.prototype.count;
}
var InfiniteSelectComponent = /** @class */ (function () {
    function InfiniteSelectComponent() {
        this.onSearchHandler = new EventEmitter();
        this.onLoadDataHandler = new EventEmitter();
        this.onChangeHandler = new EventEmitter();
        this.onSelectionChangeHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    InfiniteSelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} isOpen
     * @return {?}
     */
    InfiniteSelectComponent.prototype.triggerEvent = /**
     * @param {?} isOpen
     * @return {?}
     */
    function (isOpen) {
        var _this = this;
        /** @type {?} */
        var panel = this.selectElem.panel.nativeElement;
        if (isOpen) {
            panel.addEventListener('scroll', (/**
             * @param {?} event
             * @return {?}
             */
            function (event) { return _this.loadAllOnScroll(event, panel); }));
        }
        else
            panel.removeEventListener('scroll');
        this.isLoading = false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InfiniteSelectComponent.prototype.onInputChangeHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /*** Clear all options of the last group */
        this.items[this.items.length - 1].options.length = 0;
        this.isSearching = true;
        this.onSearchHandler.emit(event.target.value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InfiniteSelectComponent.prototype.changeEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.source && event.source.selected.group) {
            /** @type {?} */
            var groupName = event.source.selected.group.label.split(' (')[0];
            this.onChangeHandler.emit({ title: event.source.selected._element.nativeElement.innerText,
                value: event.source.value, group: groupName });
        }
        else if (event.source)
            this.onChangeHandler.emit({ title: event.source.selected._element.nativeElement.innerText, value: event.source.value, group: '' });
    };
    /**
     * @param {?} event
     * @param {?} panels
     * @return {?}
     */
    InfiniteSelectComponent.prototype.loadAllOnScroll = /**
     * @param {?} event
     * @param {?} panels
     * @return {?}
     */
    function (event, panels) {
        if (this.isLoading)
            return;
        if (this.isMaxReached)
            return;
        if (event.target.scrollTop >= (panels.children[0].offsetHeight - panels.offsetHeight)) {
            this.isLoading = true;
            this.onLoadDataHandler.emit();
        }
    };
    InfiniteSelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-infinite-select',
                    template: "<div class=\"itb-select-wrapper\" [formGroup]=\"parentForm\">\n    <mat-form-field> \n        <mat-label>{{label}}</mat-label>\n        <mat-select #infiniteSelect (openedChange)=\"triggerEvent($event)\" [formControlName]=\"formFieldName\" (selectionChange)=\"changeEvent($event)\">\n            <div class=\"infinite-select-content\" #infiniteContent>\n                <itb-input [isReactive]=\"false\" [label]=\"'Search'\" (onChangeHandler)=\"onInputChangeHandler($event)\" (keydown)=\"$event.stopPropagation()\"></itb-input>\n                <div *ngIf=\"isSearching\" class=\"infinite-select-loader lp\"><itb-spinner [spinnerType]=\"'m'\"></itb-spinner></div>\n                <div *ngIf=\"!isSearching\">\n                    <mat-optgroup *ngFor=\"let group of items\" [label]=\"group.title + ' (' + group.count + ')'\"\n                    [disabled]=\"group.isDisabled\">\n                    <mat-option *ngFor=\"let option of group.options\" [value]=\"option.id\">\n                    {{option.title}}\n                    </mat-option>\n                </mat-optgroup>\n                <div *ngIf=\"isLoading\" class=\"infinite-select-loader\"><itb-spinner [spinnerType]=\"'s'\"></itb-spinner></div>\n                </div>\n        </div>\n        </mat-select>\n    </mat-form-field>\n</div>"
                }] }
    ];
    /** @nocollapse */
    InfiniteSelectComponent.ctorParameters = function () { return []; };
    InfiniteSelectComponent.propDecorators = {
        selectElem: [{ type: ViewChild, args: ['infiniteSelect', undefined,] }],
        selectElement: [{ type: ViewChild, args: ['selectField', undefined,] }],
        isRequired: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isLoading: [{ type: Input }],
        isSearching: [{ type: Input }],
        label: [{ type: Input }],
        items: [{ type: Input }],
        isMaxReached: [{ type: Input }],
        parentForm: [{ type: Input }],
        formFieldName: [{ type: Input }],
        onSearchHandler: [{ type: Output }],
        onLoadDataHandler: [{ type: Output }],
        onChangeHandler: [{ type: Output }],
        onSelectionChangeHandler: [{ type: Output }]
    };
    return InfiniteSelectComponent;
}());
if (false) {
    /** @type {?} */
    InfiniteSelectComponent.prototype.selectElem;
    /** @type {?} */
    InfiniteSelectComponent.prototype.selectElement;
    /** @type {?} */
    InfiniteSelectComponent.prototype.isRequired;
    /** @type {?} */
    InfiniteSelectComponent.prototype.isDisabled;
    /** @type {?} */
    InfiniteSelectComponent.prototype.isLoading;
    /** @type {?} */
    InfiniteSelectComponent.prototype.isSearching;
    /** @type {?} */
    InfiniteSelectComponent.prototype.label;
    /** @type {?} */
    InfiniteSelectComponent.prototype.items;
    /** @type {?} */
    InfiniteSelectComponent.prototype.isMaxReached;
    /** @type {?} */
    InfiniteSelectComponent.prototype.parentForm;
    /** @type {?} */
    InfiniteSelectComponent.prototype.formFieldName;
    /** @type {?} */
    InfiniteSelectComponent.prototype.onSearchHandler;
    /** @type {?} */
    InfiniteSelectComponent.prototype.onLoadDataHandler;
    /** @type {?} */
    InfiniteSelectComponent.prototype.onChangeHandler;
    /** @type {?} */
    InfiniteSelectComponent.prototype.onSelectionChangeHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/infinite-select/infinite-select.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InfiniteSelectModule = /** @class */ (function () {
    function InfiniteSelectModule() {
    }
    InfiniteSelectModule.decorators = [
        { type: NgModule, args: [{
                    // tslint:disable-next-line: max-line-length
                    imports: [CommonModule, FormsModule, MatSelectModule$1, MatFormFieldModule$1, InputModule, ReactiveFormsModule, SpinnerModule],
                    declarations: [InfiniteSelectComponent],
                    exports: [InfiniteSelectComponent],
                },] }
    ];
    return InfiniteSelectModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/infinite-select/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-controls/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/default-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/round-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/toggle-button/toggle-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToggleButtonComponent = /** @class */ (function () {
    function ToggleButtonComponent() {
        var _this = this;
        this.onClickHandler = new EventEmitter();
        this.clickEvent = (/**
         * @param {?} name
         * @return {?}
         */
        function (name) {
            _this.onClickHandler.emit(name);
        });
    }
    ToggleButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-toggle-button',
                    template: "<div class=\"itb-toggle-btn\">\n    <mat-button-toggle-group appearance=\"legacy\" value=\"default\">\n        <mat-button-toggle (click)=\"clickEvent(toggleButtonArray.iconName)\" *ngFor='let toggleButtonArray of toggleButtonArray' value=\"toggleButtonArray.tooltipText\" [checked]=\"toggleButtonArray.isChecked\">\n            <itb-icon [tooltipText]=\"toggleButtonArray.tooltipText\" [className]=\"toggleButtonArray.className\" >\n            </itb-icon>\n        </mat-button-toggle>\n    </mat-button-toggle-group>\n</div>"
                }] }
    ];
    ToggleButtonComponent.propDecorators = {
        toggleButtonArray: [{ type: Input }],
        default: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return ToggleButtonComponent;
}());
if (false) {
    /** @type {?} */
    ToggleButtonComponent.prototype.toggleButtonArray;
    /** @type {?} */
    ToggleButtonComponent.prototype.default;
    /** @type {?} */
    ToggleButtonComponent.prototype.onClickHandler;
    /** @type {?} */
    ToggleButtonComponent.prototype.clickEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/toggle-button/toggle-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToggleButtonModule = /** @class */ (function () {
    function ToggleButtonModule() {
    }
    ToggleButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonToggleModule, IconModule],
                    declarations: [ToggleButtonComponent],
                    exports: [ToggleButtonComponent],
                },] }
    ];
    return ToggleButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/toggle-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/button-group/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/dropup-button/dropup-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropupButtonComponent = /** @class */ (function () {
    function DropupButtonComponent() {
        this.onButtonClickHandler = new EventEmitter();
        this.onDropupClickHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    DropupButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line: prefer-template
        this.dropupClassName = ('mat-menu-trigger mat-icon-button mat-button-base btn-' + this.dropupClassName + 't');
        if (this.isLoading) {
            // tslint:disable-next-line: prefer-template
            this.buttonClassName = stringConstants.DEFAULT_DROPUP_BUTTON_CLASSNAME + ' btn-loader btn-' + this.buttonClassName;
            this.iconClassName = stringConstants.DEFAULT_DROPUP_ICON_CLASSNAME + this.iconClassName;
        }
        else {
            this.buttonClassName = stringConstants.DEFAULT_DROPUP_BUTTON_CLASSNAME + this.buttonClassName;
            this.iconClassName = stringConstants.DEFAULT_DROPUP_ICON_CLASSNAME + this.iconClassName;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DropupButtonComponent.prototype.buttonClickEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.isLoading)
            return;
        this.onButtonClickHandler.emit(event);
    };
    /**
     * @param {?} label
     * @return {?}
     */
    DropupButtonComponent.prototype.dropupClickEvent = /**
     * @param {?} label
     * @return {?}
     */
    function (label) {
        if (this.isLoading)
            return;
        this.onDropupClickHandler.emit(label);
    };
    DropupButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-dropup-button',
                    template: "<div class=\"dropup-button-group\">\n    <button mat-flat-button [disabled]=\"isDisabled\" class=\"{{iconClassName}}\" ngClass=\"{{buttonClassName}}\" *ngIf=\"!isLoading\" (click)=\"buttonClickEvent($event)\">\n        {{buttonText}}\n        <!-- <div [class]=\"iconClassName\"></div> -->\n    </button>\n    <button mat-flat-button [disabled]=\"isDisabled\" class=\"btn-innerico setting\" *ngIf=\"isLoading\" class=\"{{buttonClassName}}\" [ngClass]=\"isLoading ?  'setting btn-loader' : ''\" >\n        <!-- <div class=\"btn-innerico setting\"></div> -->\n    </button>\n    <button mat-icon-button [disabled]=\"isLoading || isDisabled\" class=\"{{dropupClassName}}\" [matMenuTriggerFor]=\"dropup\">\n        <!-- <mat-icon>expand_less</mat-icon> -->\n        <itb-icon class=\"btn-icon angle-up tab-inner-ico icon-white\"></itb-icon>\n    </button>\n</div>\n<mat-menu #dropup=\"matMenu\" yPosition=\"above\">\n    <button class=\"dropup-items\" mat-menu-item *ngFor=\"let item of dropupItems\" (click)=\"dropupClickEvent(item.label)\">\n        <itb-icon class=\"dropup-btns\" [className]=\"item.className\"></itb-icon>\n        {{item.label}}\n    </button>\n</mat-menu>"
                }] }
    ];
    DropupButtonComponent.propDecorators = {
        dropupClassName: [{ type: Input }],
        buttonClassName: [{ type: Input }],
        buttonText: [{ type: Input }],
        iconClassName: [{ type: Input }],
        isLoading: [{ type: Input }],
        isDisabled: [{ type: Input }],
        dropupItems: [{ type: Input }],
        onButtonClickHandler: [{ type: Output }],
        onDropupClickHandler: [{ type: Output }]
    };
    return DropupButtonComponent;
}());
if (false) {
    /** @type {?} */
    DropupButtonComponent.prototype.dropupClassName;
    /** @type {?} */
    DropupButtonComponent.prototype.buttonClassName;
    /** @type {?} */
    DropupButtonComponent.prototype.buttonText;
    /** @type {?} */
    DropupButtonComponent.prototype.iconClassName;
    /** @type {?} */
    DropupButtonComponent.prototype.isLoading;
    /** @type {?} */
    DropupButtonComponent.prototype.isDisabled;
    /** @type {?} */
    DropupButtonComponent.prototype.dropupItems;
    /** @type {?} */
    DropupButtonComponent.prototype.onButtonClickHandler;
    /** @type {?} */
    DropupButtonComponent.prototype.onDropupClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/dropup-button/dropup-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropupButtonModule = /** @class */ (function () {
    function DropupButtonModule() {
    }
    DropupButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatMenuModule, IconModule, MatIconModule, MatButtonModule],
                    declarations: [DropupButtonComponent],
                    exports: [DropupButtonComponent],
                },] }
    ];
    return DropupButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/dropup-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/square-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/progress-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/search-bar-button/search-bar-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchBarButtonComponent = /** @class */ (function () {
    function SearchBarButtonComponent() {
        this.onClickHandler = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SearchBarButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.className = this.className || stringConstants.DEFAULT_SEARCH_BAR_BUTTON_CLASSNAME;
    };
    /**
     * @return {?}
     */
    SearchBarButtonComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.onClickHandler.emit();
    };
    SearchBarButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-search-bar-button',
                    template: "<div class=\"{{className}}\" (click)=\"onClick()\">\n  <itb-icon [className]=\"searchBarButton.iconClassName\"></itb-icon>\n  <itb-text [className]=\"searchBarButton.textClassName\" [text]=\"searchBarButton.text\"></itb-text>\n</div>"
                }] }
    ];
    SearchBarButtonComponent.propDecorators = {
        className: [{ type: Input }],
        searchBarButton: [{ type: Input }],
        onClickHandler: [{ type: Output }]
    };
    return SearchBarButtonComponent;
}());
if (false) {
    /** @type {?} */
    SearchBarButtonComponent.prototype.className;
    /** @type {?} */
    SearchBarButtonComponent.prototype.searchBarButton;
    /** @type {?} */
    SearchBarButtonComponent.prototype.onClickHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/search-bar-button/search-bar-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchBarButtonModule = /** @class */ (function () {
    function SearchBarButtonModule() {
    }
    SearchBarButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SearchBarButtonComponent],
                    imports: [CommonModule, IconModule, TextModule],
                    exports: [SearchBarButtonComponent],
                },] }
    ];
    return SearchBarButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/search-bar-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/submenu-button/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/buttons/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/pie-chart/pie-chart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PieChartComponent = /** @class */ (function () {
    function PieChartComponent() {
        this.chartClickHandler = new EventEmitter();
        this.legendClickHandler = new EventEmitter();
    }
    /**
     * @param {?} chartInstance
     * @return {?}
     */
    PieChartComponent.prototype.onChartInit = /**
     * @param {?} chartInstance
     * @return {?}
     */
    function (chartInstance) {
        this.echartsInstance = chartInstance;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PieChartComponent.prototype.onChartClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.chartClickHandler.emit(event.data.name);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PieChartComponent.prototype.onLegendClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.suppressSelection(this.echartsInstance, event);
        this.legendClickHandler.emit(event);
    };
    /**
     * @param {?} chart
     * @param {?} params
     * @return {?}
     */
    PieChartComponent.prototype.suppressSelection = /**
     * @param {?} chart
     * @param {?} params
     * @return {?}
     */
    function (chart, params) {
        chart.setOption({ animation: false });
        chart.dispatchAction({
            type: 'legendSelect',
            name: params.name,
        });
        chart.setOption({ animation: true });
    };
    PieChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-pie-chart',
                    template: "<div class=\"card card-accent-info pie-chart\">\n  <div class=\"card-body\">\n    <div echarts class=\"demo-chart\" [options]=\"chartOptions\" (chartInit)=\"onChartInit($event)\" (chartClick)=\"onChartClick($event)\" (chartLegendSelectChanged)=\"onLegendClick($event)\"></div>\n  </div>\n</div>"
                }] }
    ];
    PieChartComponent.propDecorators = {
        hasLoader: [{ type: Input }],
        className: [{ type: Input }],
        theme: [{ type: Input }],
        title: [{ type: Input }],
        chartOptions: [{ type: Input }],
        chartClickHandler: [{ type: Output }],
        legendClickHandler: [{ type: Output }]
    };
    return PieChartComponent;
}());
if (false) {
    /** @type {?} */
    PieChartComponent.prototype.hasLoader;
    /** @type {?} */
    PieChartComponent.prototype.className;
    /** @type {?} */
    PieChartComponent.prototype.theme;
    /** @type {?} */
    PieChartComponent.prototype.title;
    /** @type {?} */
    PieChartComponent.prototype.chartOptions;
    /** @type {?} */
    PieChartComponent.prototype.chartClickHandler;
    /** @type {?} */
    PieChartComponent.prototype.legendClickHandler;
    /** @type {?} */
    PieChartComponent.prototype.echartsInstance;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/pie-chart/pie-chart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PieChartModule = /** @class */ (function () {
    function PieChartModule() {
    }
    PieChartModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, NgxEchartsModule],
                    declarations: [PieChartComponent],
                    exports: [PieChartComponent],
                },] }
    ];
    return PieChartModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/pie-chart/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/bar-chart/bar-chart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BarChartComponent = /** @class */ (function () {
    function BarChartComponent() {
        this.chartClickHandler = new EventEmitter();
        this.warningTranquilizer = EChartOption;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    BarChartComponent.prototype.onChartClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.chartClickHandler.emit(event.data.name);
    };
    BarChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'itb-bar-chart',
                    template: "<div class=\"card card-accent-info\">\n  <div class=\"card-body\">\n    <div echarts class=\"demo-chart\" [options]=\"chartOptions\" (chartClick)=\"onChartClick($event)\"></div>\n  </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    BarChartComponent.ctorParameters = function () { return []; };
    BarChartComponent.propDecorators = {
        hasLoader: [{ type: Input }],
        className: [{ type: Input }],
        theme: [{ type: Input }],
        title: [{ type: Input }],
        chartOptions: [{ type: Input }],
        chartClickHandler: [{ type: Output }]
    };
    return BarChartComponent;
}());
if (false) {
    /** @type {?} */
    BarChartComponent.prototype.hasLoader;
    /** @type {?} */
    BarChartComponent.prototype.className;
    /** @type {?} */
    BarChartComponent.prototype.theme;
    /** @type {?} */
    BarChartComponent.prototype.title;
    /** @type {?} */
    BarChartComponent.prototype.chartOptions;
    /** @type {?} */
    BarChartComponent.prototype.chartClickHandler;
    /** @type {?} */
    BarChartComponent.prototype.warningTranquilizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/bar-chart/bar-chart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BarChartModule = /** @class */ (function () {
    function BarChartModule() {
    }
    BarChartModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, NgxEchartsModule],
                    declarations: [BarChartComponent],
                    exports: [BarChartComponent],
                },] }
    ];
    return BarChartModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/bar-chart/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ui-components.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ActionPanelComponent, ActionPanelModule, AlphabetFilterComponent, AlphabetFilterModule, BadgeComponent, BadgeModule, BarChartComponent, BarChartModule, BarLoaderComponent, BarLoaderModule, BreadcrumbsComponent, BreadcrumbsModule, ButtonGroupComponent, ButtonGroupModule, CUSTOM_FORMATS, CheckboxComponent, CheckboxListComponent, CheckboxListModule, CheckboxModule, CheckboxWithDividerComponent, CheckboxWithDividerModule, ChipComponent, ChipModule, CircleProgressBarComponent, CircleProgressBarModule, ColorBarComponent, ColorBarModule, ConfirmationMessagesComponent, ConfirmationMessagesModule, DatePickerComponent, DatePickerModule, DateTimePickerComponent, DateTimePickerModule, DefaultButtonComponent, DefaultButtonModule, DividerComponent, DividerModule, DropZoneComponent, DropZoneModule, DropdownComponent, DropdownListComponent, DropdownListModule, DropdownModule, DropupButtonComponent, DropupButtonModule, DynamicActionPanelComponent, DynamicActionPanelModule, EditorComponent, EditorModule, EmailTemplateComponent, EmailTemplateModule, EmptyStateImageComponent, EmptyStateImageModule, ExpansionListItemModule, ExpansionPanelComponent, ExpansionPanelListItemComponent, ExpansionPanelModule, FeedbackPageComponent, FeedbackPageModule, HeadingComponent, HeadingModule, IconComponent, IconModule, ImageComponent, ImageModule, InfiniteSelectComponent, InfiniteSelectModule, InfoMessageComponent, InfoMessageModule, InpageHeadingComponent, InpageHeadingModule, InputComponent, InputModule, InputWithFlagComponent, InputWithFlagModule, IntegrationBoxComponent, IntegrationBoxModule, JsonViewerComponent, JsonViewerModule, LeftSideBarModule, LeftSidebarComponent, ListItemComponent, ListItemModule, MenuButtonComponent, MenuButtonModule, MultiSelectChipsComponent, MultiSelectChipsModule, MultiSelectChipsObjectModule, MultiSelectDropDownModule, MultiSelectDropdownComponent, MultiselectChipObjectComponent, NotificationModule, NotificationsComponent, PageTitleComponent, PageTitleModule, PageWrapperComponent, PageWrapperModule, PaginationComponent, PaginationModule, PaginatorComponent, PaginatorModule, PieChartComponent, PieChartModule, PopOverModule, PopoverComponent, PopupAlertComponent, PopupAlertModule, PricingColumnComponent, PricingColumnModule, PricingPanelComponent, PricingPanelModule, ProgressButtonComponent, ProgressButtonModule, RadioComponent, RadioModule, RangeSliderModule, RoundButtonComponent, RoundButtonModule, RsbExpansionPanelComponent, RsbExpansionPanelModule, RsbFeedbackComponent, RsbFeedbackModule, RsbItemListComponent, RsbItemListModule, SearchBarButtonComponent, SearchBarButtonModule, SearchWidgetComponent, SearchWidgetModule, SelectComponent, SelectModule, SelectWithButtonComponent, SelectWithButtonModule, SliderComponent, SpinnerComponent, SpinnerModule, SquareButtonComponent, SquareButtonModule, SubmenuButtonComponent, SubmenuButtonModule, SurveyCountComponent, SurveyCountModule, SurveyOptionComponent, SurveyOptionModule, SwitchComponent, SwitchModule, TableComponent, TableModule, TabsComponent, TabsModule, TextComponent, TextModule, TextareaComponent, TextareaModule, ThankyouTemplateComponent, ThankyouTemplateModule, TimelineComponent, TimelineModule, ToggleButtonComponent, ToggleButtonModule, WidgetComponent, WidgetFooterComponent, WidgetFooterModule, WidgetModule, stringConstants, CustomDateAdapter as ɵa, DatePickerService as ɵb, CustomErrorHandler as ɵc };
//# sourceMappingURL=ui-components.js.map
